webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    editItem: function editItem(id, url) {
      var _this = this;

      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
      var form = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (this.graphql) {
        this.$service.graphql({
          query: '\n            query get($id: Int!) {\n              ' + url + '(id: $id) {\n                ' + fields + '\n              }\n            }\n          ',
          variables: { id: id }
        }).then(function (response) {
          if (response) {
            _this.openModal(response[url], form);
          }
        });
      } else {
        this.$service.get((url || this.url) + '/' + id).then(function (response) {
          if (response) {
            _this.openModal(response);
          }
        });
      }
    },
    deleteItem: function deleteItem(id, url) {
      var _this2 = this;

      this.$confirm('¿Quiere eliminar el registro?', function () {
        if (_this2.graphql) {
          _this2.$service.graphql({
            query: '\n              mutation remove($id: Int!) {\n                ' + url + 'Delete(id: $id) {\n                  deleted\n                }\n              }\n            ',
            variables: { id: id }
          }).then(function (response) {
            if (response && response[url + 'Delete'] && response[url + 'Delete'].deleted) {
              _this2.$message.success('¡Registro eliminado correctamente!');
              _this2.updateList();
            }
          });
        } else {
          _this2.$service.delete(url || _this2.url, id).then(function (response) {
            _this2.$message.success('¡Registro eliminado correctamente!');
            _this2.updateList();
          });
        }
      });
    },
    changeActive: function changeActive(obj, id, url, type, callback) {
      var _this3 = this;

      var active = obj.active === 'ACTIVE';
      this.$confirm('\xBFEst\xE1 seguro de ' + (active ? 'activar' : 'desactivar') + ' el registro?.', function () {
        if (_this3.graphql) {
          _this3.$service.graphql({
            query: '\n              mutation edit($id: Int!, $' + url + ': ' + type + '!) {\n                ' + url + 'Edit(id: $id, ' + url + ': $' + url + ') {\n                  id\n                }\n              }\n            ',
            variables: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
              id: id
            }, url, {
              estado: active ? 'ACTIVO' : 'INACTIVO'
            })
          }).then(function (response) {
            if (response) {
              if (active) {
                _this3.$message.success('\xA1Registro activado!', null, { timeout: 2000 });
              } else {
                _this3.$message.warning('\xA1Registro desactivado!', null, { timeout: 2000 });
              }
              _this3.updateList();
              if (typeof callback === 'function') {
                callback();
              }
            }
          });
        } else {
          _this3.$service.patch(_this3.url + '/' + id, { 'transicion': active ? 'activar' : 'inactivar' }).then(function (response) {
            if (response) {
              if (active) {
                _this3.$message.success('\xA1Registro activado!', null, { timeout: 2000 });
              } else {
                _this3.$message.warning('\xA1Registro desactivado!', null, { timeout: 2000 });
              }
              _this3.updateList();
              if (typeof callback === 'function') {
                callback();
              }
            }
          });
        }
      }, function () {
        return obj.active = active ? 'INACTIVE' : 'ACTIVE';
      });
    },
    updateList: function updateList() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#btn-refresh-list';

      if (document.querySelector(id)) {
        console.log('Update list', document.querySelector(id));
        document.querySelector(id).dispatchEvent(new window.Event('click'));
      }
    },
    getValue: function getValue(id, items) {
      id = id + '';
      // console.log(id, items);
      for (var i in items) {
        // console.log(items[i].value, typeof items[i].value, items[i].value === id);
        if (items[i].value === id) {
          return items[i];
        }
      }
      return null;
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    $validate: function $validate() {
      var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var validations = [];
      for (var i in rules) {
        if (rules[i] === 'required') {
          validations.push(this.$validateRequired);
        }
        if (rules[i] === 'email') {
          validations.push(this.$validateEmail);
        }
        if (rules[i] === 'url') {
          validations.push(this.$validateUrl);
        }
      }
      return validations;
    },
    $validateRequired: function $validateRequired(v) {
      return !!v || this.$t('validate.required');
    },
    $validateEmail: function $validateEmail(v) {
      if (v) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('validate.email')
        );
      }
      return true;
    },
    $validateUrl: function $validateUrl(v) {
      if (v) {
        return (/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/.test(v) || this.$t('validate.url')
        );
      }
      return true;
    }
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    login: function login(data) {
      var _this = this;

      this.$http.post(this.$authUrl, {
        usuario: data.username,
        contrasena: data.password
      }).then(function (response) {
        if (response.data) {
          var menu = response.data.menu;
          var usuario = response.data.usuario;
          var permisos = response.data.permisos;
          var token = response.data.token;
          var redirect = response.data.redirect;
          var sidenav = data.sidenav === undefined ? true : data.sidenav;

          _this.$storage.setUser(usuario);
          _this.$storage.set('menu', menu);
          _this.$storage.set('token', token);
          _this.$storage.set('sidenav', sidenav);
          _this.$storage.set('permissions', permisos);

          _this.$store.commit('setUser', usuario);
          _this.$store.commit('setMenu', menu);
          _this.$store.commit('setSidenav', sidenav);
          _this.$store.commit('setPermissions', permisos);
          _this.$store.commit('setAuth', true);

          _this.timerSession();
          _this.$router.push(redirect || data.redirect || '/');
        }
      }).catch(function (error) {
        _this.$message.error(error.response.data.message || 'Usuario y/o contraseña inválida');
      });
    },
    logout: function logout(store, router, loading) {
      store = store || this.$store;
      router = router || this.$router;
      loading = loading || this.$loading;

      if (store.state.sessionInterval) {
        window.clearInterval(store.state.sessionInterval);
        store.state.sessionInterval = null;
      }

      loading.hide();

      this.$storage.removeUser();
      this.$storage.remove('menu');
      this.$storage.remove('token');
      this.$storage.remove('sidenav');
      this.$storage.remove('permissions');

      store.commit('setDefault');
      router.push('login');
    },
    timerSession: function timerSession() {
      var _this2 = this;

      // Definiendo el tiempo en el que dura una sesión sin actividad
      this.$store.commit('SET_TIME', 220 * 60);
      this.$store.state.sessionInterval = window.setInterval(function () {
        _this2.$store.commit('TIME_DECREASE');
        if (_this2.$store.state.time <= 0) {
          _this2.$message.warning('Su sesión ha sido cerrada automáticamente después de ' + 220 + ' minutos de inactividad.', '¡Sesión cerrada!', { timeout: 30000 });
          _this2.logout();
        }
      }, 1000);
    }
  }
});

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

var mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    data: function data() {
      return {
        estados: estados,
        mensajes: mensajes
      };
    },
    getDocumento: function getDocumento(idDocumento) {
      var _this = this;

      this.$service.graphql({
        query: '\n          query get($id: Int!){\n            documento(id: $id){\n              id\n              nombre\n              descripcion\n              tramite_ppte\n              id_entidad\n              entidad_nombre\n              entidad_descripcion\n              entidad_tramite_ppte\n              entidad_precio\n            }\n          }\n        ',
        variables: {
          id: idDocumento
        }
      }).then(function (response) {
        if (response) {
          _this.documento = response.documento;
        }
      });
    },
    getArchivo: function getArchivo(idArchivo) {
      var _this2 = this;

      this.$service.graphql({
        query: '\n          query getArchivo($id: Int!){\n            archivo(id: $id){\n              id\n              nombre\n              titulo\n            }\n          }\n        ',
        variables: {
          id: idArchivo
        }
      }).then(function (response) {
        if (response) {
          _this2.archivo = response.archivo;
        }
      });
    },
    getTramite: function getTramite(idTramite) {
      var _this3 = this;

      this.$loading.show('Obteniendo trámite');
      this.$service.graphql({
        query: '\n          query tramite ($id: Int!) {\n            tramiteDoc(id: $id) {\n              id\n              pago_entidad\n              pago_cancilleria\n              cod_seguridad\n              nro_apostilla\n              fecha_expedicion\n              estado\n              observacion\n              fecha_inicio\n              fecha_fin\n              firmante_documento_nombre\n              firmante_documento_cargo\n              firmante_documento_entidad\n              digital\n              otros\n              departamento\n              documento_id_entidad\n              documento_nombre\n              documento_descripcion\n              documento_precio\n              documento_cuenta\n              documento_monto\n              documento_entidad_nombre\n              documento_entidad_sigla\n              documento_duracion\n              documento_derivar\n              archivo_nombre\n              archivo_titulo\n              archivo_tamano\n              id_documento\n              id_archivo\n              id_tramite\n              tramite_cod_seguimiento\n              tramite_fecha_inicio\n              tramite_fecha_fin\n              tramite_solicitante_id\n              tramite_solicitante_nombres\n              tramite_solicitante_primer_apellido\n              tramite_solicitante_segundo_apellido\n              tramite_solicitante_tipo_documento\n              tramite_solicitante_nro_documento\n              tramite_solicitante_email\n              tramite_solicitante_telefono\n              tramite_solicitante_fecha_nacimiento\n              tramite_solicitante_observacion\n            }\n            pagos(id_tramite_doc: $id) {\n              count\n              rows {\n                id\n                cpt\n                tipo\n                fecha_pago\n                estado\n                tipo_documento\n                nro_documento\n                titular_factura\n              }\n            }\n          }\n        ',
        variables: {
          id: idTramite
        }
      }).then(function (response) {
        if (response) {
          if (_this3.tramite.id_archivo > 1) {
            _this3.$loading.show('Renderizando archivo PDF');
            setTimeout(_this3.$loading.hide, 1200);
          }
          var tramite = response.tramiteDoc;
          tramite.fecha_inicio_show = false;
          tramite.fecha_fin_show = false;
          _this3.tramite = tramite;

          var fechaInicio = void 0,
              fechaFin = void 0;
          if (_this3.tramite.fecha_inicio) {
            fechaInicio = new Date(_this3.tramite.fecha_inicio);
          } else {
            // Si no tiene fecha de inicio guardada se la genera automáticamente
            fechaInicio = new Date();
          }
          _this3.$nextTick(function () {
            _this3.tramite.fecha_inicio = fechaInicio;
            _this3.tramite.fecha_inicio_show = true;
          });

          if (_this3.tramite.fecha_fin) {
            fechaFin = new Date(_this3.tramite.fecha_fin);
          } else {
            // Si no tiene fecha de fin guardada se la genera automáticamente + los días de validez del documento a apostillar
            fechaFin = new Date(_this3.$datetime.addDays(fechaInicio, parseInt(_this3.tramite.documento_duracion)));
          }
          _this3.$nextTick(function () {
            _this3.tramite.fecha_fin = fechaFin;
            _this3.tramite.fecha_fin_show = true;
          });

          _this3.pagos = response.pagos.rows || [];
          _this3.url = _this3.$apiUrl + 'eregister/upload/' + _this3.tramite.id + '/' + _this3.tramite.id_archivo;
          _this3.$store.commit('setArchivo', _this3.tramite.id_archivo);
        }
      });
    },
    getTramites: function getTramites(filter) {
      var _this4 = this;

      // para TRAMITES
      this.$service.graphql({
        query: '\n          query getTramites {\n            tramites {\n              count\n              rows {\n                id\n                cod_seguimiento\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.tramites.rows;
          var tramites = [];
          items.map(function (tramite) {
            tramites.push({ value: tramite.id, text: tramite.cod_seguimiento });
          });
          _this4.tramites = tramites;
          if (filter && _this4.filters[filter] && _this4.filters[filter].items) {
            _this4.filters[filter].items = _this4.tramites;
          }
        }
      });
    },
    getPdf: function getPdf(idArchivo) {
      var _this5 = this;

      if (idArchivo > 1) {
        this.$loading.show('Cargando documento PDF, espere por favor...');
        this.$service.post('eregister/pdf', { id_archivo: idArchivo }).then(function (response) {
          if (response === null) {
            return null;
          }
          _this5.pdf = response;
          _this5.urlPdf = _this5.$apiUrl + 'eregister/pdf-download/' + idArchivo;
        });
      }
    },
    getDocumentos: function getDocumentos(filter) {
      var _this6 = this;

      // para DOCUMENTOS
      this.$service.graphql({
        query: '\n          query getDocumentos {\n            documentos {\n              count\n              rows {\n                id\n                nombre\n                descripcion\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.documentos.rows;
          var documentos = [{ value: '', text: 'TODOS' }];
          items.map(function (documento) {
            documentos.push({ value: documento.id, text: documento.nombre + ' - ' + documento.descripcion });
          });
          _this6.documentos = documentos;
          if (filter !== undefined && _this6.filters[filter] && _this6.filters[filter].items) {
            _this6.filters[filter].items = _this6.documentos;
          }
        }
      });
    },
    getArchivos: function getArchivos(filter) {
      var _this7 = this;

      // para ARCHIVOS
      this.$service.graphql({
        query: '\n          query getArchivos {\n            archivos {\n              count\n              rows {\n                id\n                cod_seguimiento\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.archivos.rows;
          var archivos = [];
          items.map(function (archivo) {
            archivos.push({ value: archivo.id, text: archivo.nombre });
          });
          _this7.archivos = archivos;
          if (filter && _this7.filters[filter] && _this7.filters[filter].items) {
            _this7.filters[filter].items = _this7.archivos;
          }
        }
      });
    },
    actualizarEstadoTramiteDoc: function actualizarEstadoTramiteDoc(solicitud, estado, observacion, tipoInst) {
      var _this8 = this;

      if (estado === 'REVISADO_ENTIDAD' && solicitud.id_archivo === 1) {
        this.$message.warning('Tiene que agregar un documento PDF para ser apostillado');
        return false;
      }

      this.$service.graphql({
        query: '\n          mutation edit($id: Int!, $tramiteDoc: EditTramiteDoc!) {\n            tramiteDocEdit(id: $id, tramiteDoc: $tramiteDoc) {\n              id\n            }\n          }\n        ',
        variables: {
          id: solicitud.id,
          tramiteDoc: {
            estado: estado,
            observacion: observacion,
            firmante_documento_nombre: solicitud.firmante_documento_nombre,
            firmante_documento_cargo: solicitud.firmante_documento_cargo,
            firmante_documento_entidad: solicitud.firmante_documento_entidad,
            departamento: solicitud.departamento,
            fecha_inicio: this.$store.state.date.fecha_inicio,
            fecha_fin: this.$store.state.date.fecha_fin
          }
        }
      }).then(function (response) {
        if (response) {
          _this8.$message.success(mensajes[estado]);
          _this8.$store.commit('closeModal', 2);
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    },
    generarCpt: function generarCpt(item, tipoInstitucion, callback) {
      var _this9 = this;

      var fechaNac = item.tramite_solicitante_fecha_nacimiento.split('-');
      var fechaNac2 = [fechaNac[2], fechaNac[1], fechaNac[0]].join('/');
      var datos = {
        cpt_ppte: {
          numeroDocumento: item.tramite_solicitante_nro_documento,
          tipoDocumento: item.tramite_solicitante_tipo_documento,
          nombre: item.tramite_solicitante_nombres + ' ' + item.tramite_solicitante_primer_apellido + ' ' + item.tramite_solicitante_segundo_apellido,
          fechaNacimiento: fechaNac2,
          complemento: '',
          transicion: 'crear',
          monto: item.documento_monto
        },
        datos_tramite_apostilla: {
          id_documento: item.id_documento,
          id_tramite: item.id_tramite,
          id_usuario: this.$store.state.user.id,
          email: item.tramite_solicitante_email,
          id_tramite_doc: parseInt(item.id),
          tipo_institucion: tipoInstitucion,
          id_rol: this.$store.state.user.id_rol,
          id_entidad: this.$store.state.user.id_entidad
        }
      };
      this.$service.post('eapostilla/generar_cpt', datos).then(function (response) {
        if (response) {
          _this9.$message.success('Se generó el Código de Pago(CPT) correctamente y se le envió al solicitante para que realice su pago.');
          if (typeof callback === 'function') {
            callback();
          }
        }
      });
    }
  }
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getRoles: function getRoles(filter) {
      var _this = this;

      this.$service.graphql({
        query: '\n          query getRoles {\n            roles {\n              count\n              rows {\n                id\n                nombre\n                descripcion\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.roles.rows;
          var roles = [];
          items.map(function (rol) {
            roles.push({ value: rol.id, text: rol.nombre + ' - ' + rol.descripcion });
          });
          _this.roles = roles;
          if (filter && _this.filters[filter] && _this.filters[filter].items) {
            _this.filters[filter].items = _this.roles;
          }
        }
      });
    },
    getRegionales: function getRegionales(filter) {
      var _this2 = this;

      this.$service.graphql({
        query: '\n          query getRegionales {\n            parametroBuscar(name: "REGIONALES") {\n              valor\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response && response.parametroBuscar) {
          _this2.regionales = response.parametroBuscar.valor.split(',');
          if (filter && _this2.filters[filter] && _this2.filters[filter].items) {
            _this2.filters[filter].items = _this2.regionales;
          }
        }
      });
    },
    getEntidades: function getEntidades(filter) {
      var _this3 = this;

      this.$service.graphql({
        query: '\n          query getEntidades($estado: EstadoEntidad) {\n            entidades(estado: $estado) {\n              count\n              rows {\n                id\n                nombre\n                sigla\n              }\n            }\n          }\n        ',
        variables: {
          estado: 'ACTIVO'
        }
      }).then(function (response) {
        if (response) {
          var items = response.entidades.rows;
          var entidades = [];
          items.map(function (est) {
            entidades.push({ value: est.id, text: (est.sigla ? est.sigla + ' - ' : '') + est.nombre });
          });
          _this3.entidades = entidades;
          if (filter && _this3.filters[filter] && _this3.filters[filter].items) {
            _this3.filters[filter].items = _this3.entidades;
          }
        }
      });
    }
  }
});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    bloquear: function bloquear(e) {
      // 46 - Delete
      // 8 - Backspace
      // 9 - Tab
      // 27 - Escape
      // 13 - Enter
      var code = e.keyCode || e.charCode;
      if ([27, 9, 13].indexOf(code) !== -1) {
        console.log('code', code);
        var btnCancel = document.querySelector('#md-btn-confirm-selected-cancel');
        var btnOk = document.querySelector('#md-btn-confirm-selected-ok');
        var select = document.activeElement;
        if (code === 9) {
          console.log('select.class', select, select.classList.contains('md-button-confirm'));
          if (select.id !== 'md-btn-confirm-selected-cancel') {
            setTimeout(function () {
              btnOk.classList.remove('md-focused');
              btnCancel.classList.add('md-focused');
              btnCancel.focus();
            }, 10);
          } else {
            setTimeout(function () {
              btnCancel.classList.remove('md-focused');
              btnOk.classList.add('md-focused');
              btnOk.focus();
            }, 10);
          }
        }
        if (code === 27) {
          btnCancel.click();
        }
        if (code === 13) {
          if (select.id === 'md-btn-confirm-selected-ok') {
            btnOk.click();
          } else {
            if (select.id === 'md-btn-confirm-selected-cancel') {
              btnCancel.click();
            } else {
              e.preventDefault();
            }
          }
        }
        return;
      } else {
        e.preventDefault();
      }
    }
  }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(497),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_tramite__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_plugins_modal_mixins_modal__ = __webpack_require__(37);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: {
    main: true,
    time: null,
    sessionInterval: null,
    toggle: true,
    auth: false,
    menu: {},
    user: {},
    date: {},
    permissions: {},
    rol: '',
    breadcrumbs: {},
    sidenav: false,
    maxFilesize: 0,
    alert: {
      show: false,
      text: '',
      callback: null
    },
    confirm: {
      show: false,
      text: '',
      callbackOk: null,
      callbackCancel: null,
      textOk: '',
      textCancel: ''
    },
    selected: null,
    modal: false,
    modal2: false,
    modal3: false,
    modal4: false,
    modal5: false,
    modal6: false,
    modal7: false,
    data: {},
    state403: false,
    touch: false,
    message: null,
    selectDate: null,
    changes: 0,
    archivo: 0,
    pin: null,
    loading: false,
    action: null
  },
  mutations: {
    toggleSidenav: function toggleSidenav(state) {
      state.toggle = !state.toggle;
    },
    setToogle: function setToogle(state, value) {
      state.toggle = value;
    },
    openModal: function openModal(state) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      state['modal' + id] = true;
    },
    closeModal: function closeModal(state) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      state['modal' + id] = false;
    },
    setSelectDate: function setSelectDate(state, value) {
      state.selectDate = value;
    },
    setMaxFilesize: function setMaxFilesize(state, value) {
      state.maxFilesize = value;
    },
    setDate: function setDate(state, value) {
      if (state.date === undefined) {
        state.date = {};
      }
      if (value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (keys.length) {
          state.date[keys[0]] = value[keys[0]];
        } else {
          state.date = value;
        }
      } else {
        state.date = value;
      }
    },
    setTouch: function setTouch(state, value) {
      state.touch = value;
    },
    setSelected: function setSelected(state, value) {
      if (Array.isArray(value)) {
        state.selected = value;
      } else {
        if (!state.selected) {
          state.selected = [];
        }
        state.selected.push(value);
      }
    },
    setAction: function setAction(state, value) {
      state.action = value;
    },
    setUser: function setUser(state, value) {
      state.user = value;
    },
    setArchivo: function setArchivo(state, value) {
      state.archivo = value;
    },
    setMenu: function setMenu(state, value) {
      state.menu = value;
    },
    setChanges: function setChanges(state, value) {
      state.changes = value;
    },
    setSidenav: function setSidenav(state, value) {
      state.sidenav = value;
    },
    setAuth: function setAuth(state, value) {
      state.auth = value;
    },
    setPermissions: function setPermissions(state, value) {
      state.permissions = value;
    },
    setMain: function setMain(state, value) {
      state.main = value;
    },
    setPin: function setPin(state, value) {
      state.pin = value;
    },
    setData: function setData(state, value) {
      state.data = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setDefault: function setDefault(state) {
      state.auth = false;
      state.menu = {};
      state.user = {};
      state.permissions = {};
      state.rol = '';
      state.breadcrumbs = {};
      state.modal = false;
      state.modal2 = false;
      state.modal3 = false;
      state.modal4 = false;
      state.modal5 = false;
      state.modal6 = false;
      state.modal7 = false;
      state.state403 = false;
      state.pin = null;
      state.loading = false;
      state.message = null;
      state.alert.show = false;
      state.confirm.show = false;
      state.selectDate = null;
      document.removeEventListener('keydown', __WEBPACK_IMPORTED_MODULE_4__common_plugins_modal_mixins_modal__["a" /* default */].methods.bloquear, false);
    },
    CLOSE_ALERT: function CLOSE_ALERT(state) {
      state.alert.show = false;
      document.removeEventListener('keydown', __WEBPACK_IMPORTED_MODULE_4__common_plugins_modal_mixins_modal__["a" /* default */].methods.bloquear, false);
    },
    CLOSE_CONFIRM: function CLOSE_CONFIRM(state) {
      state.confirm.show = false;
      document.removeEventListener('keydown', __WEBPACK_IMPORTED_MODULE_4__common_plugins_modal_mixins_modal__["a" /* default */].methods.bloquear, false);
    },
    SET_TIME: function SET_TIME(state, value) {
      state.time = value;
    },
    TIME_DECREASE: function TIME_DECREASE(state) {
      state.time--;
    }
  },
  modules: {
    tramite: __WEBPACK_IMPORTED_MODULE_3__modules_tramite__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_Dashboard__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_Login__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_layout_pages_AppNotFound__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_layout_pages_AppNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_layout_pages_AppNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_layout_pages_AppForbidden__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_layout_pages_AppForbidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_layout_pages_AppForbidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_layout_pages_AppError__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_layout_pages_AppError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_layout_pages_AppError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eRegister_solicitante_Solicitante__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eRegister_solicitante_Solicitante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_eRegister_solicitante_Solicitante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eRegister_tramite_Tramite__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eRegister_tramite_Tramite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_eRegister_tramite_Tramite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eRegister_tramiteDoc_TramiteDoc__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eRegister_tramiteDoc_TramiteDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_eRegister_tramiteDoc_TramiteDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eRegister_tramiteDoc_Historial__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eRegister_tramiteDoc_Historial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_eRegister_tramiteDoc_Historial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eRegister_tramiteDoc_ParaFirma__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eRegister_tramiteDoc_ParaFirma___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_eRegister_tramiteDoc_ParaFirma__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eRegister_pago_Pago__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eRegister_pago_Pago___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_eRegister_pago_Pago__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eApostilla_entidad_Entidad__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eApostilla_entidad_Entidad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_eApostilla_entidad_Entidad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eApostilla_documento_Documento__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eApostilla_documento_Documento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_eApostilla_documento_Documento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eApostilla_reportes_Reporte__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eApostilla_reportes_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_eApostilla_reportes_Reporte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_account_Account__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_account_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_admin_account_Account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_usuario_Usuario__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_usuario_Usuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_admin_usuario_Usuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_auxiliar_Auxiliar__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_auxiliar_Auxiliar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_admin_auxiliar_Auxiliar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_modulo_Modulo__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_modulo_Modulo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_admin_modulo_Modulo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_admin_preferencias_Preferencias__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_admin_preferencias_Preferencias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_admin_preferencias_Preferencias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_admin_Log__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_admin_Log___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_admin_Log__);








// e-register







// e-apostilla




// System







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_Dashboard___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_Login___default.a
  }, {
    path: '/usuarios',
    name: 'Usuario',
    component: __WEBPACK_IMPORTED_MODULE_17__components_admin_usuario_Usuario___default.a
  }, {
    path: '/auxiliares',
    name: 'Auxiliar',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_auxiliar_Auxiliar___default.a
  }, {
    path: '/account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_16__components_admin_account_Account___default.a
  }, {
    path: '/entidades',
    name: 'Entidad',
    component: __WEBPACK_IMPORTED_MODULE_13__components_eApostilla_entidad_Entidad___default.a
  }, {
    path: '/parametros',
    name: 'Preferencias',
    component: __WEBPACK_IMPORTED_MODULE_20__components_admin_preferencias_Preferencias___default.a
  }, {
    path: '/documentos',
    name: 'Documento',
    component: __WEBPACK_IMPORTED_MODULE_14__components_eApostilla_documento_Documento___default.a
  }, {
    path: '/modulos',
    name: 'Módulo',
    component: __WEBPACK_IMPORTED_MODULE_19__components_admin_modulo_Modulo___default.a
  }, {
    path: '/logs',
    name: 'Logs',
    component: __WEBPACK_IMPORTED_MODULE_21__components_admin_Log___default.a
  }, {
    path: '/solicitantes',
    name: 'Solicitante',
    component: __WEBPACK_IMPORTED_MODULE_7__components_eRegister_solicitante_Solicitante___default.a
  }, {
    path: '/tramites',
    name: 'Tramite',
    component: __WEBPACK_IMPORTED_MODULE_8__components_eRegister_tramite_Tramite___default.a
  }, {
    path: '/tramitesDoc',
    name: 'TramiteDoc',
    component: __WEBPACK_IMPORTED_MODULE_9__components_eRegister_tramiteDoc_TramiteDoc___default.a
  }, {
    path: '/pagos',
    name: 'Pago',
    component: __WEBPACK_IMPORTED_MODULE_12__components_eRegister_pago_Pago___default.a
  }, {
    path: '/historial',
    name: 'Historial',
    component: __WEBPACK_IMPORTED_MODULE_10__components_eRegister_tramiteDoc_Historial___default.a
  }, {
    path: '/para_firma',
    name: 'Para Firma',
    component: __WEBPACK_IMPORTED_MODULE_11__components_eRegister_tramiteDoc_ParaFirma___default.a
  }, {
    path: '/reportes',
    name: 'Reporte',
    component: __WEBPACK_IMPORTED_MODULE_15__components_eApostilla_reportes_Reporte___default.a
  }, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_4__common_layout_pages_AppNotFound___default.a
  }, {
    path: '/403',
    component: __WEBPACK_IMPORTED_MODULE_5__common_layout_pages_AppForbidden___default.a
  }, {
    path: '/500',
    component: __WEBPACK_IMPORTED_MODULE_6__common_layout_pages_AppError___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_4__common_layout_pages_AppNotFound___default.a
  }]
}));

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '400': 'Mä jani walt\'awiwa utji.',
  '401': 'Sart\'awimaxa tukuyxiwa.',
  '412': 'Janiwa luraskiti',
  '403': 'Janiwa utjkiti suma iyasañanakaxa.',
  '404': 'Kuntixa thaqhtaxa janiwa utjkiti.',
  '407': 'Wakichañawa proxypaxa, apnaqañataki.',
  '408': 'Servidoraxa janiwa jayskiti. ukatjaru yant\'ama.',
  '409': 'Qillqatamaxa janiwa walikiti.',
  '410': 'Kuntixa maytaxa janiwa utjkiti, ukhamarusa janiwa utjkaniti.',
  '500': 'Pantxasiwa servidoraxa, ukatjaru yant\'ama.',
  '502': 'Atamiri kipuxa janiwa walikiti, ukatjaru yant\'ama.',
  '503': 'Atamiri kipuxa janiwa anchitaxa irnaqkiti,  ukatjaru yant\'ama ampsuma.',
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': 'Janiwa servidorampixa arust\'asiñxamakiti.',
  'cancelRequest': 'Mayiwi tukuyaña.',
  'validation': 'Janiwa walikiti.',
  'unknown': 'Janiwa jani walt\'awi yatiskiti, ukatjaru yant\'ama.',
  'sessionExpired': 'Sart\'awimaxa tukusxiwa, machaqata mantanim.'
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '400': 'There was an error in validating.',
  '401': 'Your session expired.',
  '412': 'Operation cannot be completed.',
  '403': 'You are not authorized',
  '404': 'Requested resource does not exist.',
  '407': 'You need to configure your Proxy to use the system.',
  '408': 'Server is not responding. Try later.',
  '409': 'Invalid data',
  '410': 'Requested resource is not and will not be available.',
  '500': 'There was an error communicating with the server, Try later.',
  '502': 'System is not available at the moment. Try later.',
  '503': 'System currently undergoing maintenance. Try later please.',
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': 'Cannot communicate with the server.',
  'cancelRequest': 'Request was canceled',
  'validation': 'Validation error',
  'unknown': 'An unknown error occurred, try later.',
  'sessionExpired': 'Your session has expired, login again.'
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  '400': 'Hubo un error de validación.',
  '401': 'Su sesión ha caducado.',
  '412': 'No se pudo realizar la operación.',
  '403': 'No tiene los permisos necesarios.',
  '404': 'No existe el recurso solicitado.',
  '407': 'Necesita configurar su Proxy para poder usar el sistema.',
  '408': 'El servidor no responde intente más tarde.',
  '409': 'Los datos no son válidos',
  '410': 'El recurso solicitado ya no está disponible y no lo estará de nuevo.',
  '500': 'Se produjo un error en el servidor, inténtelo más tarde.',
  '502': 'El sistema no está disponible en estos momentos, inténtelo más tarde.',
  '503': 'El sistema se encuentra en mantenimiento en estos momentos, vuelva a intentarlo más tarde por favor.',
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': 'No se pudo establecer conexión con el servidor.',
  'cancelRequest': 'Petición cancelada.',
  'validation': 'Error de validación',
  'unknown': 'Ocurrió un error desconocido, intente más tarde.',
  'sessionExpired': 'Su sesión ha expirado, ingrese nuevamente.'
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    setActive: function setActive(url) {
      var el = document.querySelector('#sidenav-menu .list__tile.active');
      if (el) {
        el.classList.remove('active');
      }
      if (url.length) {
        el = document.querySelector('#sidenav-menu .list__tile[data-url=\'' + url + '\']');
        if (el) {
          el.classList.add('active');
        }
      }
    },
    clickEvent: function clickEvent(url) {
      var sidenav = document.getElementById('sidenav-menu');
      var element = sidenav.querySelector('a[data-url="' + url.substring(1) + '"]');
      if (element) {
        element.classList.add('active');
        element = element.parentNode.parentNode.previousElementSibling;
        if (element.classList.contains('list--group__header') && !element.classList.contains('list--group__header--active')) {
          element.dispatchEvent(new window.Event('click'));
        }
      }
    }
  }
});

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(496),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
  __webpack_require__(400)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
  __webpack_require__(404)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es_messages__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_messages__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ay_messages__ = __webpack_require__(284);




/* harmony default export */ __webpack_exports__["a"] = ({
  es: __WEBPACK_IMPORTED_MODULE_0__es_messages__["a" /* default */],
  en: __WEBPACK_IMPORTED_MODULE_1__en_messages__["a" /* default */],
  ay: __WEBPACK_IMPORTED_MODULE_2__ay_messages__["a" /* default */]
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var instance = new Vue();
    var Util = instance.$util;

    var DatetimeService = {
      formatDate: 'dd/MM/YYYY',
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      days: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayslong: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],

      date: function date(_date, separator) {
        _date = _date.split(separator || '-');
        return new Date(_date[0], _date[1] - 1, _date[2]);
      },
      parse: function parse(date, separator) {
        return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join(separator || '-');
      },
      dateMonth: function dateMonth() {
        var date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1);
      },
      getDate: function getDate(date) {
        date = new Date(date);
        return {
          day: date.getUTCDate(),
          month: date.getUTCMonth() + 1,
          year: date.getUTCFullYear()
        };
      },
      getPrevDateMonth: function getPrevDateMonth(data) {
        data = data || 1;
        var date = new Date();
        var day = date.getDate();
        var month = date.getMonth();
        var year = date.getFullYear();

        if (day < data) {
          month--;
          if (month < 0) {
            month = 11;
            year--;
          }
        }
        return new Date(year, month, data);
      },
      toString: function toString(date) {
        if (Util.toType(date) === 'string') {
          var pos = date.indexOf('T');
          if (pos !== -1 && pos <= 10 && pos >= 8) {
            var fecha = date.substring(0, pos);
            if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+-?[0-9]+-?[0-9]*$/g.test(fecha)) {
              fecha = fecha.split('-');
              return this.format(new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]));
            }
          }
        } else {
          if (Util.toType(date) === 'date') {
            return this.format(new Date(date));
          }
        }
        return date;
      },
      toDate: function toDate(string) {
        if (Util.toType(string) === 'string') {
          var pos = string.indexOf('T');
          if (pos !== -1 && pos <= 10 && pos >= 8) {
            var fecha = string.substring(0, pos);
            if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+-?[0-9]+-?[0-9]*$/g.test(fecha)) {
              fecha = fecha.split('-');
              return new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]);
            }
          }
        }
        return string;
      },
      isDate: function isDate(date) {
        if (Util.toType(date) === 'string') {
          date = this.convert(date);
        }
        return this.isValid(date);
      },
      isValid: function isValid(date) {
        if (Util.toType(date) !== 'date') {
          return false;
        }
        return !isNaN(date.getTime());
      },
      isLessThan: function isLessThan(date) {
        return this.milliseconds(date) < new Date().getTime();
      },
      isLessThanDays: function isLessThanDays(date, data) {
        return this.milliseconds(date) > this.subtractDays(new Date(), data);
      },
      isGreaterThan: function isGreaterThan(date) {
        return this.milliseconds(date) > new Date().getTime();
      },
      isGreaterThanDays: function isGreaterThanDays(date, data) {
        return this.milliseconds(date) < this.addDays(new Date(), data);
      },
      addDays: function addDays(date, days) {
        return this.milliseconds(date) + (days || 0) * 24 * 60 * 60 * 1000;
      },
      subtractDays: function subtractDays(date, days) {
        return this.milliseconds(date) - (days || 0) * 24 * 60 * 60 * 1000;
      },
      diff: function diff(date2, date1) {
        return this.milliseconds(date2) - this.milliseconds(date1);
      },
      milliseconds: function milliseconds(date) {
        if (Util.toType(date) === 'string') {
          date = this.convert(date);
        }
        return date.getTime();
      },
      convert: function convert(date) {
        date = date.split('/');
        if (this.formatDate === 'dd/MM/YYYY') {
          return new Date(date[2], date[1] - 1, date[0]);
        } else if (this.formatDate === 'MM/dd/YYYY') {
          return new Date(date[2], date[0] - 1, date[1]);
        } else {
          return new Date(date[0], date[1] - 1, date[2]);
        }
      },
      setFormatDate: function setFormatDate(format) {
        this.formatDate = format;
      },
      now: function now(format) {
        return this.replace(new Date(), format || this.formatDate);
      },
      dateLiteral: function dateLiteral(date) {
        return this.format(date, 'dd de MMM del YYYY');
      },
      time: function time(date) {
        return this.format(date, 'HH:mm');
      },
      timeLiteral: function timeLiteral(time, txt) {
        var text = '';
        if (typeof time === 'number') {
          if (time === 0) {
            return '';
          }
          if (time < 60) {
            text = time + 's';
          } else if (time < 3600) {
            text = Math.floor(time / 60) + 'm ' + (time % 60 > 0 ? time % 60 + 's' : '');
          } else {
            text = Math.floor(time / 3600) + 'h ' + (time % 3600 > 0 ? Math.floor(time / 60) + 'm ' : '') + (time % 60 > 0 ? time % 60 + 's' : '');
          }
          return (txt || '') + text;
        } else {
          if (time.length === 0) {
            return '';
          }
          time = time.split(':');
          var hours = time[0];
          var minutes = time[1];

          if (parseInt(hours) > 0) {
            text += parseInt(hours) + 'h ';
          }
          if (parseInt(minutes) > 0) {
            text += parseInt(minutes) + 'm ';
          }
          if (time.length === 3 && parseInt(time[2]) > 0) {
            text += parseInt(time[2]) + 's';
          }

          return (txt || '') + text;
        }
      },
      getSeconds: function getSeconds(time) {
        time = time.split(':');
        var hours = time[0];
        var minutes = time[1];
        var total = 0;

        if (parseInt(hours) > 0) {
          total += parseInt(hours) * 3600;
        }
        if (parseInt(minutes) > 0) {
          total += parseInt(minutes) * 60;
        }
        if (time.length === 3 && parseInt(time[2]) > 0) {
          total += parseInt(time[2]);
        }

        return total;
      },
      datetimeLiteral: function datetimeLiteral(date) {
        return this.format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
      },
      format: function format(date, _format) {
        if (date) {
          var d = new Date(date);
          if (this.isDate(d)) {
            return this.replace(d, _format || this.formatDate);
          }
        }
        return date;
      },
      standar: function standar(date, format) {
        if (date) {
          var type = Util.toType(date);
          if (type === 'date') {
            return date;
          }
          var day, month, year;
          if (type === 'string') {
            format = format || this.formatDate;
            var separator = date.indexOf('/') !== -1 ? '/' : '-';
            date = date.split(separator);

            if (format === 'dd-MM-YYYY' || format === 'dd/MM/YYYY') {
              day = date[0];
              month = date[1] - 1;
              year = date[2];
            }

            if (format === 'MM-dd-YYYY' || format === 'MM/dd/YYYY') {
              day = date[1];
              month = date[0] - 1;
              year = date[2];
            }

            if (format === 'YYYY-MM-dd' || format === 'YYYY/MM/dd') {
              day = date[2];
              month = date[1] - 1;
              year = date[0];
            }

            if (format === 'YYYY-dd-MM' || format === 'YYYY/dd/MM') {
              day = date[1];
              month = date[2] - 1;
              year = date[0];
            }
          }
          return new Date(year, month, day);
        }
        return null;
      },
      replace: function replace(date, format) {
        format = format || this.formatDate;
        date = this.standar(date, format);
        var monthLiteral = format.indexOf('MMM') !== -1;
        return Util.replace(format, ['dddd', 'ddd', 'dd', monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'], [this.dayslong[date.getDay()], this.days[date.getDay()], (date.getDate() < 10 ? '0' : '') + date.getDate(), monthLiteral ? this.months[date.getMonth()] : (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1), date.getFullYear(), (date.getHours() < 10 ? '0' : '') + date.getHours(), (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(), (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()]);
      },
      last: function last(date) {
        var now = new Date();
        var days = this.daysBetweenTwoDates(date, now);
        if (days > 31) {
          return this.dateLiteral(date);
        } else {
          if (days > 7) {
            var weeks = parseInt(days / 7);
            return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
          } else {
            if (days >= 1) {
              return this.format(date, 'ddd a la(s) HH:mm');
            } else {
              var hours = this.hoursBetweenTwoDates(date, now);
              if (this.isYesterday(date, hours)) {
                return 'Ayer a la(s) ' + this.time(date);
              } else {
                if (hours >= 1) {
                  return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
                } else {
                  var minutes = this.minutesBetweenTwoDates(date, now);
                  if (minutes >= 1) {
                    return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
                  } else {
                    var seconds = this.secondsBetweenTwoDates(date, now);
                    return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
                  }
                }
              }
            }
          }
        }
      },
      secondsBetweenTwoDates: function secondsBetweenTwoDates(date1, date2, absolute) {
        return this.betweenTwoDates(date1, date2, 's', absolute);
      },
      minutesBetweenTwoDates: function minutesBetweenTwoDates(date1, date2, absolute) {
        return this.betweenTwoDates(date1, date2, 'i', absolute);
      },
      hoursBetweenTwoDates: function hoursBetweenTwoDates(date1, date2, absolute) {
        return this.betweenTwoDates(date1, date2, 'h', absolute);
      },
      daysBetweenTwoDates: function daysBetweenTwoDates(date1, date2, absolute) {
        return this.betweenTwoDates(date1, date2, 'd', absolute);
      },
      betweenTwoDates: function betweenTwoDates(date1, date2, type, absolute) {
        var types = { s: 1000, i: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };
        var diff = parseInt((this.standar(date2).getTime() - this.standar(date1).getTime()) / types[type]);

        if (typeof absolute !== 'undefined' && absolute !== false) {
          return Math.abs(diff);
        }
        return diff;
      },
      isYesterday: function isYesterday(date, hours) {
        if (this.isDate(date)) {
          date = date.split(' ');
          var time = date[1].split(':');
          return hours >= parseInt(time[0]);
        }
        return false;
      },
      parseDate: function parseDate(date) {
        return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/');
      }
    };

    Vue.prototype.$datetime = DatetimeService;
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var eventBus = {};

eventBus.install = function (Vue) {
  Vue.prototype.$bus = new Vue();
};

/* harmony default export */ __webpack_exports__["a"] = (eventBus);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var exceptions = {
      'integer': [46, 8, 9, 27, 13, 110, 173, 189, 109],
      'natural': [46, 8, 9, 27, 13, 110, 190],
      'decimal': [46, 8, 9, 27, 13, 110, 190, 173, 189, 109],
      'decimal_positive': [46, 8, 9, 27, 13, 110, 190],
      'numeric': [46, 8, 9, 27, 13],
      'alpha': [46, 8, 9, 27, 13, 32],
      'alpha_dash': [46, 8, 9, 27, 13, 32, 173, 189, 109],
      'passport': [46, 8, 9, 27, 13, 32, 173, 189, 109, 190, 0, 192]
    };
    exceptions.alpha_numeric = exceptions.alpha;

    var evaluate = {
      numeric: function numeric(e) {
        return (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105);
      },
      alpha: function alpha(e) {
        return e.keyCode < 65 || e.keyCode > 90;
      }
    };
    evaluate.integer = evaluate.numeric;
    evaluate.decimal = evaluate.numeric;
    evaluate.natural = evaluate.numeric;
    evaluate.decimal_positive = evaluate.numeric;
    evaluate.alpha_numeric = function (e) {
      return evaluate.alpha(e) && evaluate.numeric(e);
    };
    evaluate.alpha_dash = evaluate.alpha_numeric;
    evaluate.alpha_dash = evaluate.alpha_numeric;
    evaluate.passport = evaluate.alpha_numeric;

    var FilterService = {
      nit: function nit() {
        var nit = {
          verhoeff: function verhoeff(x, y) {
            var m = ['0123456789', '1234067895', '2340178956', '3401289567', '4012395678', '5987604321', '6598710432', '7659821043', '8765932104', '9876543210'];
            if (m[x] && m[x][y]) {
              return parseInt(m[x][y]);
            }
            return -1;
          },

          permutations: function permutations(x, y) {
            var m = ['0123456789', '1576283094', '5803796142', '8916043527', '9453126870', '4286573901', '2793806415', '7046913258'];
            if (m[x] && m[x][y]) {
              return parseInt(m[x][y]);
            }
            return -1;
          },

          evaluate: function evaluate(num) {
            var check = 0;
            var x;
            var y;
            var z;

            if (typeof num === 'string' && isNaN(num)) {
              return false;
            }
            num = parseInt(num);
            for (var i = 0, l = num.toString().length; i < l; i++) {
              x = i % 8;
              y = num % 10;
              num = Math.floor(num / 10);
              z = nit.permutations(x, y);
              check = nit.verhoeff(check, z);
            }

            return check === 0;
          }
        };

        return nit;
      },
      filterBase: function filterBase(e, type) {
        if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
          e.preventDefault();
        }
        if (exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
          return;
        }
        if (evaluate[type](e)) {
          if (type.indexOf('alpha') === 0) {
            if (!(e.key === 'ñ' || e.key === 'Ñ')) {
              e.preventDefault();
            }
          } else {
            e.preventDefault();
          }
        }
      },
      isNumber: function isNumber(o) {
        return typeof o === 'number' && isFinite(o);
      },
      isFloat: function isFloat(value) {
        return value % 1 !== 0;
      },
      integer: function integer(e) {
        this.filterBase(e, 'integer');
      },
      isInteger: function isInteger(value) {
        if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]*$/g.test(value)) {
          return false;
        }
        value = this.convert(value);
        if (value === 'NaN' || !this.isNumber(value)) {
          return false;
        }
        return !this.isFloat(value);
      },
      decimal: function decimal(e) {
        this.filterBase(e, 'decimal');
      },
      isDecimal: function isDecimal(value) {
        if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]+,?[0-9]*$/g.test(value)) {
          return false;
        }
        value = this.convert(value);
        if (value === 'NaN') {
          return false;
        }
        return this.isNumber(value);
      },
      decimalPositive: function decimalPositive(e) {
        this.filterBase(e, 'decimal_positive');
      },
      isDecimalPositive: function isDecimalPositive(value) {
        if (/[a-zA-Z]+/g.test(value) || !/^[0-9.]+,?[0-9]*$/g.test(value)) {
          return false;
        }
        value = this.convert(value);
        if (value === 'NaN') {
          return false;
        }
        return this.isNumber(value);
      },
      decimalFormat: function decimalFormat(e) {
        this.decimalPositive(e);

        var valor = e.target.value;
        var exceptions = [37, 39, 46, 8, 9];
        var t = e.keyCode ? e.keyCode : e.which;
        var target = e.target;

        if (valor.match(/\./g)) {
          if (t === 190 || t === 110) {
            e.preventDefault();
          }
          var char = t >= 96 && t <= 105 ? t - 96 : String.fromCharCode(t);
          var newValue = valor.substring(0, target.selectionStart) + char + valor.substring(target.selectionEnd);
          if (!/^(\d+(?:\.?\d{0,2})?)?$/g.test(newValue) && exceptions.indexOf(t) === -1) {
            e.preventDefault();
          }
        } else {
          if (t === 190 || t === 110) {
            var decimal = valor.substring(target.selectionEnd);
            if (decimal.length > 2) {
              decimal = decimal.substring(0, 2);
              e.target.value = valor.substring(0, target.selectionStart) + '.' + decimal;
              e.preventDefault();
            }
            if (valor.length === 0) {
              e.target.value = '0';
            }
          }
        }
      },
      isDecimalFormat: function isDecimalFormat(value) {
        return (/^(\d+(?:\.?\d{0,2})?)?$/g.test(value)
        );
      },
      natural: function natural(e) {
        this.filterBase(e, 'natural');
      },
      isNatural: function isNatural(value) {
        if (/[a-zA-Z]+/g.test(value) || !/^[0-9]*$/g.test(value)) {
          return false;
        }
        value = this.convert(value);
        if (value === 'NaN' || !this.isNumber(value)) {
          return false;
        }
        return !this.isFloat(value) && value >= 0;
      },
      numeric: function numeric(e) {
        this.filterBase(e, 'numeric');
      },
      isNumeric: function isNumeric(value) {
        return (/^([0-9])*$/.test(value)
        );
      },
      alpha: function alpha(e) {
        this.filterBase(e, 'alpha');
      },
      isAlpha: function isAlpha(value) {
        return (/^[\u00D1\u00F1A-Z a-z]*$/.test(value)
        );
      },
      alphaNumeric: function alphaNumeric(e) {
        this.filterBase(e, 'alpha_numeric');
      },
      isAlphaNumeric: function isAlphaNumeric(value) {
        return (/^[\u00D1\u00F1A-Z a-z0-9]*$/.test(value)
        );
      },
      alphaDash: function alphaDash(e) {
        this.filterBase(e, 'alpha_dash');
      },
      isAlphaDash: function isAlphaDash(value) {
        return (/^[\u00D1\u00F1A-Z a-z-_0-9]*$/.test(value)
        );
      },
      passport: function passport(e) {
        this.filterBase(e, 'passport');
      },
      isPassport: function isPassport(value) {
        return (/^[\u00D1\u00F1A-Z a-z-_0-9.]*$/.test(value)
        );
      },
      isPhone: function isPhone(value) {
        return (/^(?:(?:\(?(?:00|\+)([1-e]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(value)
        );
        // return /[\d()*+\- ]+/.test(value);
      },
      removeTagHTML: function removeTagHTML(text) {
        return text.replace(/<([^ >]+)[^>]*>.*?<\/\1>|<[^\/]+\/>/gi, '');
      },
      empty: function empty(value) {
        return value === undefined || value === null || value.length === 0 || /^\s+$/.test(value);
      },
      isEmail: function isEmail(value) {
        return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
        );
      },
      convert: function convert(value) {
        return parseFloat(isNaN(value) ? value.replace(/\./g, '').replace(',', '.') : value);
      },
      isNit: function isNit(value) {
        return this.nit().evaluate(value);
      },
      characters: function characters(input, chars, breakOnWord) {
        if (isNaN(chars)) return input;
        if (chars <= 0) return '';
        if (input && input.length > chars) {
          input = input.substring(0, chars).replace(/(<([^>]+)>)/ig, '');

          if (!breakOnWord) {
            var lastspace = input.lastIndexOf(' ');

            if (lastspace !== -1) {
              input = input.substr(0, lastspace);
            }
          } else {
            while (input.charAt(input.length - 1) === ' ') {
              input = input.substr(0, input.length - 1);
            }
          }
          return input + '…';
        }
        return input;
      },
      splitcharacters: function splitcharacters(input, chars) {
        if (isNaN(chars)) return input;
        if (chars <= 0) return '';
        if (input && input.length > chars) {
          input = input.replace(/(<([^>]+)>)/ig, '');
          var prefix = input.substring(0, chars / 2);
          var postfix = input.substring(input.length - chars / 2, input.length);
          return prefix + '...' + postfix;
        }
        return input;
      },
      words: function words(input, _words) {
        if (isNaN(_words)) return input;
        if (_words <= 0) return '';
        if (input) {
          input = input.replace(/(<([^>]+)>)/ig, '');
          var inputWords = input.split(/\s+/);
          if (inputWords.length > _words) {
            input = inputWords.slice(0, _words).join(' ') + '…';
          }
        }
        return input;
      }
    };

    Vue.prototype.$filter = FilterService;
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppLoading_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppLoading_vue__);


__WEBPACK_IMPORTED_MODULE_0__AppLoading_vue___default.a.install = function (Vue, options) {
  Vue.prototype.$loading = new (Vue.extend(__WEBPACK_IMPORTED_MODULE_0__AppLoading_vue___default.a))({ propsData: options });
  if (false) window.$loading = Vue.prototype.$loading;
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AppLoading_vue___default.a);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var AppMessages = __webpack_require__(247);

AppMessages.install = function (Vue, options) {
  Vue.prototype.$message = new (Vue.extend(AppMessages))({ propsData: options });
  if (false) window.$message = Vue.prototype.$message;
};
module.exports = AppMessages;

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_modal__ = __webpack_require__(37);





/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  install: function install(Vue) {
    var Modal = {
      alert: function alert() {
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Mensaje...';
        var callback = arguments[1];

        var alert = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.alert;
        alert.show = true;
        alert.text = text;

        document.addEventListener('keydown', __WEBPACK_IMPORTED_MODULE_1__mixins_modal__["a" /* default */].methods.bloquear, false);

        if (typeof callback === 'function') {
          alert.callback = callback;
        }
      },
      confirm: function confirm() {
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Mensaje...';
        var callbackOk = arguments[1];
        var callbackCancel = arguments[2];
        var textOk = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Aceptar';
        var textCancel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Cancelar';

        var confirm = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.confirm;
        confirm.show = true;
        confirm.text = text;
        confirm.textOk = textOk;
        confirm.textCancel = textCancel;

        document.addEventListener('keydown', __WEBPACK_IMPORTED_MODULE_1__mixins_modal__["a" /* default */].methods.bloquear, false);

        if (typeof callbackOk === 'function') {
          confirm.callbackOk = callbackOk;
        }

        if (typeof callbackCancel === 'function') {
          confirm.callbackCancel = callbackCancel;
        }
      }
    };

    Vue.prototype.$alert = Modal.alert;
    Vue.prototype.$confirm = Modal.confirm;
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_lang_es_errors__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_lang_en_errors__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_lang_ay_errors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(71);













var PATERN_HOST = location.protocol.indexOf('https') !== -1 ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;

/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  install: function install(Vue, config) {
    // config
    var apiUrl = config && config.apiUrl ? config.apiUrl : '';
    var graphqlUrl = config && config.graphqlUrl ? config.graphqlUrl : '';
    var authUrl = config && config.authUrl ? config.authUrl : '';
    var authToken = config && config.authToken ? config.authToken : 'Bearer';

    // Plugins
    var instance = new Vue({
      mixins: [__WEBPACK_IMPORTED_MODULE_7__components_admin_auth_mixins_auth__["a" /* default */]]
    });
    var Util = instance.$util;
    var Message = instance.$message;
    var Storage = instance.$storage;
    var Loading = instance.$loading;

    var languages = {
      'es': __WEBPACK_IMPORTED_MODULE_4__common_lang_es_errors__["a" /* default */],
      'en': __WEBPACK_IMPORTED_MODULE_5__common_lang_en_errors__["a" /* default */],
      'ay': __WEBPACK_IMPORTED_MODULE_6__common_lang_ay_errors__["a" /* default */]
    };

    function t(key) {
      var lang = Storage.get('lang') || "es";
      return languages[lang][key];
    }

    var Services = {
      options: function options(url) {
        return _http('get', url + '/fields');
      },
      get: function get(url, id) {
        return _http('get', url, id);
      },
      post: function post(url, data) {
        return _http('post', url, data);
      },
      put: function put(url, data) {
        return _http('put', url, data);
      },
      patch: function patch(url, data) {
        return _http('patch', url, data);
      },
      delete: function _delete(url, id) {
        return _http('delete', url, id);
      },
      remove: function remove(url, id) {
        return this.delete(url, id);
      },
      list: function list(url, query) {
        query = query ? '?' + Util.serialize(query) : '';
        return _http('get', url + query);
      },
      save: function save(url, data) {
        return _http(data.id ? 'put' : 'post', url, data);
      },
      file: function file(url, type) {
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        url = getUrl(url);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
          if (response.data) {
            var file = new window.Blob([response.data], { type: type });
            var fileURL = window.URL.createObjectURL(file);
            // return $sce.trustAsResourceUrl(fileURL);
            return fileURL;
          }
          return null;
        }).catch(function (error) {
          return handlingErrors(error);
        });
      },
      pdf: function pdf(url) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        url = getUrl(url, data);

        var setting = { responseType: 'arraybuffer' };
        // Set token in headers
        if (Storage.exist('token')) {
          setting.headers = { 'Authorization': authToken + ' ' + Storage.get('token') };
        }

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data, setting).then(function (response) {
          console.log('Respuesta PDF', response);
          // if (response.data) {
          //   let file = new window.Blob([response.data], { type: 'application/pdf' });
          //   console.log('file', file);
          //   return window.URL.createObjectURL(file);
          // }
          return response.data;
        }).catch(function (error) {
          return handlingErrors(error);
        });
      },
      graphql: function graphql(data) {
        var setting = {
          method: 'post',
          url: graphqlUrl,
          data: data
        };

        // Set token in headers
        if (Storage.exist('token')) {
          setting.headers = { 'Authorization': authToken + ' ' + Storage.get('token') };
        }
        instance.$Progress.start();
        return __WEBPACK_IMPORTED_MODULE_3_axios___default()(setting).then(function (response) {
          instance.$Progress.finish();
          Loading.hide();
          console.log('Respuesta Graphql', response.data);
          if (response.data.errors) {
            parseErrorGraphql(response.data);
          } else {
            return response.data.data;
          }
        }).catch(function (error) {
          instance.$Progress.finish();
          Loading.hide();
          if (error.response && error.response.data) {
            var _data = error.response.data;
            parseErrorGraphql(_data);
          }
        });
      }
    };

    function parseErrorGraphql(data) {
      if (Util.toType(data.errors) === 'array') {
        var msg = [];
        data.errors.map(function (el) {
          if (el.message.indexOf('NOT_AUTHORIZED') !== -1) {
            if (el.message === 'NOT_AUTHORIZED:READ') {
              __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.state403 = true;
              __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('403');
            } else {
              Message.error('No tiene permisos para realizar esta operación.');
            }
          } else {
            var message = '<p>';
            if (el.name) {
              message += '<strong>Error: </strong>' + el.name + ' <br />';
            }
            message += '<strong>Mensaje: </strong> ' + el.message + '</p>';
            msg.push(message);
          }
        });
        Message.error(msg.join(''));
      }
    }

    function _http(method, url, data) {
      instance.$Progress.start();
      url = getUrl(url, data);
      console.group('Petición con DataService:');
      console.info('URL:', method.toUpperCase(), url);
      if (data) {
        console.info('Params:', data);
      }

      var setting = {
        method: method,
        url: url
      };

      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).length) {
        delete data.id;
        setting.data = data;
      }

      // Set token in headers
      if (Storage.exist('token')) {
        setting.headers = { 'Authorization': authToken + ' ' + Storage.get('token') };
      }

      return __WEBPACK_IMPORTED_MODULE_3_axios___default()(setting).then(function (response) {
        return filterResponse(response.data);
      }).catch(function (error) {
        return handlingErrors(error);
      });
    }

    function getUrl(url, id) {
      id = typeof id === 'string' || typeof id === 'number' ? '' + id : (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.id ? '' + id.id : '';
      if (url[url.length - 1] !== '/' && id.length > 1) {
        id = '/' + id;
      }
      return PATERN_HOST.test(url) ? url + id : apiUrl + url + id;
    }

    function filterResponse(response) {
      instance.$Progress.finish();
      Loading.hide();
      var data = response.data || response.datos || response;
      console.info('Respuesta:');
      if (Util.toType(data) === 'array') {
        if (window.navigator.appName === 'Netscape') {
          console.log('firefox');
          console.table(data);
        } else {
          console.table(data.map(function (item) {
            return [item];
          }));
        }
      } else {
        console.dir(data);
      }
      console.groupEnd();
      if (config && typeof config.filterResponse === 'function') {
        return config.filterResponse(response, Message);
      }
      return response;
    }

    function handlingErrors(error) {
      instance.$Progress.fail();
      Loading.hide();
      // console.log('error', error);
      if (error.response) {
        var status = error.response.status;
        var data = error.response.data;
        var states = [401, 403, 500]; // Estados que no mostrarán mensajes

        if (states.indexOf(status) === -1) {
          if (status === 408 || status === 504) {
            return data;
          } else if (__WEBPACK_IMPORTED_MODULE_4__common_lang_es_errors__["a" /* default */][status]) {
            Message.error(parseError(data) || t('status') || t('unknown'));
          } else {
            Message.error(parseError(data) || t('unknown'));
          }
        }
      } else if (error.message) {
        if (error.message === 'Network Error') {
          Message.error(t('connection'));
        } else {
          Message.error(error.message);
        }
      } else {
        Message.error(t('unknown'));
      }
    }

    function parseError(data) {
      var message = 'mensaje';
      if (config && config.errorFormat) {
        message = config.errorFormat;
      }
      if (data[message]) {
        console.log('Error', data[message], Util.toType(data[message]));
        if (Util.toType(data[message]) === 'array') {
          var errors = [];
          data[message].map(function (el) {
            errors.push(el.error);
          });
          return errors.join('<br>');
        }
        return data[message];
      }
      return null;
    }

    // INTERCEPTORS CONFIG
    // Add a request interceptor
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
      // Actualizando el tiempo de sesión de inactividad
      if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.time) {
        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('SET_TIME', 220 * 60);
      }
      return config;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    // Add a response interceptor
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          if (window.location.hash !== '#/login') {
            Message.error(t('sessionExpired'));
            instance.logout(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);
          }
        }
        if (error.response.status === 403) {
          __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.state403 = true;
          __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('403');
        }
        if (error.response.status === 500) {
          var data = error.response.data;
          var message = null;
          if (false) {
            if (data.mensaje || data.message) {
              message = data.mensaje || data.message;
            } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
              var text = [];
              for (var key in data) {
                text.push(key + ': ' + data[key]);
              }
              message = text.join('<br />');
            }
          }
          __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.message = message;
          __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('500');
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    Vue.prototype.$service = Services;
    Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
    Vue.prototype.$apiUrl = apiUrl;
    Vue.prototype.$authUrl = authUrl;
    Vue.prototype.$authToken = authToken;
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);




/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { appName: 'app' };

    var appName = config.appName;

    var Storage = {
      setUser: function setUser(user) {
        this.set('user', user);
      },
      getUser: function getUser() {
        return this.get('user');
      },
      existUser: function existUser() {
        return this.exist('user');
      },
      removeUser: function removeUser() {
        this.remove('user');
      },


      // LocalStorage
      set: function set(key, value) {
        localStorage.setItem(appName + '_' + key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
      },
      get: function get(key) {
        var data = localStorage.getItem(appName + '_' + key);
        try {
          return JSON.parse(data);
        } catch (Exception) {
          return data;
        }
      },
      remove: function remove(key) {
        localStorage.removeItem(appName + '_' + key);
      },
      destroy: function destroy(key) {
        this.remove(key);
      },
      exist: function exist(key) {
        var value = localStorage.getItem(appName + '_' + key);
        return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== undefined && value !== undefined && value !== null && value !== 'null' && value !== '[]';
      },


      // SessionStorage
      setSession: function setSession(key, value) {
        sessionStorage.setItem(appName + '_' + key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
      },
      getSession: function getSession(key) {
        return JSON.parse(sessionStorage.getItem(appName + '_' + key));
      },
      removeSession: function removeSession(key) {
        sessionStorage.removeItem(appName + '_' + key);
      },
      existSession: function existSession(key) {
        var value = sessionStorage.getItem(appName + '_' + key);
        return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== undefined && value !== undefined && value !== null && value !== 'null' && value !== '[]';
      },


      // Flash Data
      getFlash: function getFlash(key) {
        if (this.exist(key)) {
          var value = this.get(key);
          this.remove(key);
          return value;
        }
        return false;
      },
      flash: function flash(key) {
        this.getFlash(key);
      },
      removeAll: function removeAll() {
        localStorage.clear();
      }
    };

    Vue.prototype.$storage = Storage;
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* eslint no-useless-escape: "error" */




var tmplPrint = '\n  <!DOCTYPE html>\n  <html lang="en">\n  <head>\n    <meta charset="UTF-8"/>\n    <title>Document</title>\n    <style>{css}</style>\n  </head>\n  <body>{body}</body>\n  </html>';

var Util = {
  toType: function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  },
  isJson: function isJson(text) {
    // return /^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@')
    return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\/bfnrtu]/g, '@')
      // .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
      .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
    );
  },
  stripHTML: function stripHTML(texto) {
    return texto.replace(/(<([^>]+)>)/ig, '');
  },
  nano: function nano(template, data) {
    // return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
    return template.replace(/\{([\w.]*)\}/g, function (str, key) {
      var keys = key.split('.');
      var v = data[keys.shift()];
      for (var i = 0, l = keys.length; i < l; i++) {
        v = v[keys[i]];
      }
      return typeof v !== 'undefined' && v !== null ? v : '';
    });
  },
  print: function print(html, css) {
    var popup = window.open('', 'print');
    popup.document.write(this.nano(tmplPrint, { body: html, css: css }));
    popup.document.close();
    popup.focus();
    popup.print();
    popup.close();
  },


  /**
   * Función para crear una pausa para ejecutar una instrucción:
   *  Ejemplo:
   *
   *  let funcionConDelay = this.Util.debounce(function() {
   *      // ... lo que se quiere ejecutar con el retraso
   *  }, 1000);
   *
   *  funcionConDelay(); // Ejecutando el retraso
   */
  debounce: function debounce(func, wait, immediate) {
    var timeout = void 0;
    return function () {
      var context = this;
      var args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  popup: function popup(url) {
    window.open(url, 'print');
  },
  fullscreen: function fullscreen() {
    if (!document.fullscreenElement && // alternative standard method
    !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(window.Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  },
  size: function size(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length;
  },
  serialize: function serialize(json) {
    var string = [];
    for (var i in json) {
      string.push(i + '=' + json[i]);
    }
    return string.join('&');
  },
  getMenuOption: function getMenuOption(menu, url) {
    var items = [{ text: 'Inicio' }];
    for (var i in menu) {
      if (menu[i].submenu !== undefined) {
        var pages = menu[i].submenu;
        for (var j in pages) {
          if (pages[j].url === url) {
            items.push({ text: menu[i].label, disabled: false });
            items.push({ text: pages[j].label, disabled: false });
            return items;
          }
        }
      }
    }
    for (var k in menu) {
      if (menu[k].url === url) {
        items.push({ text: menu[k].label, disabled: false });
        return items;
      }
    }
    return items;
  },
  getKeys: function getKeys(data) {
    var types = {};

    data.map(function (el) {
      types[el.key] = el;
    });

    return types;
  },


  /**
   * Public: funcion que retrasa la ejecucion de una funcion, y que al volverse a activar reinicia el timeout
   * @param {Object} obj  objeto que guardara la referencia del intervalo
   * @param {Integer} ms  tiempo en miliesgundos
   * @param {Function} func funcion callback
   * *
   * Ejemplo
    this.timer = {};
    this.Util.funcDelay(this.timer, 1000, ()=> {
      this.personalSave(form, per);
    })
   */
  funcDelay: function funcDelay(obj, ms, func) {
    if (obj.timer_delay) {
      clearTimeout(obj.timer_delay);
    }

    obj.timer_delay = setTimeout(function () {
      obj.timer_delay = null;
      func();
    }, ms);
  },
  id: function id() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    var zero = '';
    for (var i = 0, l = length; i < l; i++) {
      zero += '0';
    }
    return (zero + (Math.random() * Math.pow(36, length) << 0).toString(36)).slice(-1 * length);
  },
  gotoAnchor: function gotoAnchor(id) {
    // if (this.$location.hash() !== id) {
    //   this.$location.hash(id);
    // } else {
    //   this.$anchorScroll();
    // }
    var el = document.querySelector('#' + id);
    if (el) {
      el.classList.add('blink-container');
      setTimeout(function () {
        el.classList.remove('blink-container');
      }, 8000);
    }
  },
  replace: function replace(text, find, _replace) {
    for (var i = 0, l = find.length, regex; i < l; i++) {
      regex = new RegExp(find[i], 'g');
      text = text.replace(regex, _replace[i]);
    }
    return text;
  },
  insert: function insert(arr, index, item) {
    return arr.splice(index, 0, item);
  },
  removeItem: function removeItem(arr, item) {
    var i = arr.indexOf(item);
    i !== -1 && arr.splice(i, 1);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.prototype.$util = Util;
  }
});

/***/ }),
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
  __webpack_require__(398)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  solicitantes: 'Solicitantes',
  entidades: 'Jach\'a utanaka',
  cuenta: 'Cuentaxa',
  configuracion: 'Configuraciones',
  usuarios: 'Atamiri jaqi',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Trámites'
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validates__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(283);




/* harmony default export */ __webpack_exports__["a"] = ({
  error: __WEBPACK_IMPORTED_MODULE_0__errors__["a" /* default */],
  validate: __WEBPACK_IMPORTED_MODULE_1__validates__["a" /* default */],
  menu: __WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],
  app: {
    title: 'Apostilla',
    account: 'Atamiri sart\'awixa',
    settings: 'Wakichawinaka',
    logOut: 'Sart\'awi tukuya\xF1a'
  },
  login: {
    title: 'Sart\'awima qalltama',
    user: 'Atamiri jaqi suti',
    password: 'Aru imt\'ata',
    rememberMe: 'Amtasita',
    forgotPass: '\xBFArmastati aru imt\'a\xF1ama?',
    login: 'Mantaña',
    noAccount: '¿Janit atamirina qillqataqta?',
    signUp: 'Akxaru qillqantasima'
  },
  common: {
    add: 'Yapt\'a\xF1a',
    required: 'Qillqa\xF1atakipuni',
    cancel: 'Chhaqtayaña',
    save: 'Imaña',
    rowsPage: 'siqinaka, laphi layku',
    updateList: 'Wasitata warucha\xF1a ',
    filters: 'Ch\'uma\xF1a/Thaqha\xF1a',
    of: 'de',
    active: 'Q\'apha',
    observation: 'Observación',
    firm: 'Firma',
    edit: 'Qillqsuña',
    status: 'Estado',
    actions: 'Lura\xF1anaka',
    close: 'Cerrar'
  },
  entity: {
    title: 'Jach\'a utanaka',
    add: 'Machaqa jach\'a uta yapt\'a\xF1a',
    crud: {
      edit: 'Qillqsuyaña',
      code: 'Código',
      name: 'Nombre',
      acronym: 'Jisk\'a suti',
      description: 'Amuykipawinaka',
      status: 'Estado',
      addEnt: 'jach\'a uta yapt\'a\xF1a',
      editEnt: 'jach\'a uta qillqsu\xF1a',
      address: 'Dirección',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      web: 'Página web de la institución',
      user_ppte: 'Usuario en el sistema PPTE',
      pass_ppte: 'Contraseña en el sistema PPTE'
    }
  },
  applicants: {
    title: 'Solicitantes',
    add: 'Agregar nuevo solicitante',
    crud: {
      edit: 'Editar',
      names: 'Nombres',
      first_name: 'Primer Apellido',
      second_name: 'Segundo Apellido',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      birthday: 'Fecha de Nacimiento',
      type_document: 'Tipo de Documento',
      number_document: 'Número de Documento',
      address: 'Dirección',
      enrol: 'Matricula',
      departament: 'Departamento',
      province: 'Provincia',
      municipio: 'Municipio',
      status: 'Estado',
      addEnt: 'Agregar Solicitante',
      editEnt: 'Editar Solicitante'
    }
  },
  transact: {
    title: 'Tramite',
    add: 'Agregar nuevo Tramite',
    crud: {
      edit: 'Editar',
      init_date: 'Fecha Inicio',
      end_date: 'Fecha Fin',
      cod_tracking: 'Codigo de Seguimiento',
      solicitante: 'Solicitante',
      status: 'Estado',
      addTran: 'Agregar Tramite',
      editTran: 'Editar Tramite'
    }
  },
  account: {
    title: 'Atamiri sart\'awinaka',
    add: 'Machaqa atamiri sart\'awi',
    select: 'Jach\'a uta ajllima, atamiri sart\'awinaka u\xF1ja\xF1ataki',
    crud: {
      edit: 'Qillqsuña',
      accountNumber: 'Atamiri sart\'awi jakhupa',
      status: 'Estado',
      entity: 'Jach\'a uta',
      addAc: 'Atamiri sart\'awi yapt\'a\xF1a',
      editAc: 'Atamiri sart\'awi qillqsu\xF1a'
    }
  },
  user: {
    title: 'Usuarios',
    add: 'Agregar nuevo usuario',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  module: {
    title: 'Módulos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  log: {
    title: 'Logs',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      fecha: 'Fecha de creación',
      id_usuario: 'Usuario'
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  _default: "Qillqataxa janiwa walikiti.",
  alpha_dash: "Qillqa\xF1a suyunxa utja\xF1apakiwa qillqanakampi jaqhunakampi sirqinakampi.",
  alpha_num: "Qillqa\xF1a suyunxa utja\xF1apakiwa qillqanakampi jaqhunakampi.",
  alpha_spaces: "Qillqa\xF1a suyunxa utja\xF1apakiwa qillqanakampi ch'usawja suyunakampi.",
  alpha: "Qillqa\xF1a suyunxa utja\xF1apakiwa qillqanak\xE4ki.",
  between: "Qillqa\xF1a suyuxa debe estar entre {min} y {max}.",
  confirmed: "Qillqa\xF1a suyuxa janiwa pachpakiti akampi {confirmedField}.",
  credit_card: "Qillqa\xF1a suyxa janiwa chiqakiti.",
  date_between: "El campo debe estar entre {min} y {max}.",
  date_format: "Qillqa\xF1a suyuxa aka arka\xF1apa {format}.",
  decimal: "Qillqa\xF1a suyuxa jaqhuki\xF1apawa ukatxa utja\xF1apawa {decimals} decimal ch'aqa.",
  digits: "Qillqa\xF1a suyuxa jaqhuki\xF1apawa ukatxa utja\xF1apawa jaqt'ata {length} d\xEDgitonaka.",
  dimensions: "Qillqa\xF1a suyuxa wakicha\xF1atapawa {width} pixelanaka ukampisa {height} pixelanaka.",
  email: "Qillqa\xF1a suyuxa chiqa correo electronico\xF1apawa.",
  ext: "Qillqa\xF1a suyuxa m\xE4  chiqa archivo\xF1apawa.",
  image: "Qillqa\xF1a suyuxa m\xE4 imagena\xF1apawa.",
  in: "Qillqa\xF1a suyuxa m\xE4 chiqa chani\xF1apawa.",
  ip: "Qillqa\xF1a suyuxa m\xE4 chiqa ip irpawi\xF1apawa.",
  max: "Qillqa\xF1a suyuxa janiw jiliri chani\xF1apakiti {length} qillqa jaqhuwinakaru.",
  max_value: "Qillqa\xF1a suyuxa pachpaki\xF1apawa {length} jan ukaxa sullka\xF1apawa.",
  mimes: "Qillqa\xF1a suyuxa m\xE4  chiqa kasta archivo\xF1apawa.",
  min: "Qillqa\xF1a suyuxa {length} qillqa jaqhuni\xF1apawa.",
  min_value: "Qillqa\xF1a suyuxa debe ser {length} o superior.",
  not_in: "Qillqa\xF1a suyuxa debe ser un valor v\xE1lido.",
  numeric: "Qillqa\xF1a suyuxa debe contener solo caracteres n\xFAmericos.",
  regex: "El formato del campo no es v\xE1lido.",
  required: "Qillqa\xF1a suyu\xF1axa wayt'atawa.",
  size: "Qillqa\xF1a suyuxa sullkaska\xF1apawa {size} KB.",
  url: "Qillqa\xF1a suyuxa janiwa m\xE4 URL chiqakiti."
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  solicitantes: 'Applicants',
  entidades: 'Entities',
  cuenta: 'Accounts',
  configuracion: 'Settings',
  usuarios: 'Users',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Trámites'
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validates__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(286);




/* harmony default export */ __webpack_exports__["a"] = ({
  error: __WEBPACK_IMPORTED_MODULE_0__errors__["a" /* default */],
  validate: __WEBPACK_IMPORTED_MODULE_1__validates__["a" /* default */],
  menu: __WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],
  app: {
    title: 'Apostilla',
    account: 'My account',
    settings: 'Settings',
    logOut: 'Logout'
  },
  login: {
    title: 'Login',
    user: 'Username',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPass: 'Forgot password?',
    login: 'Login',
    noAccount: 'Dont have an account?',
    signUp: 'Signup here'
  },
  common: {
    add: 'Add',
    required: 'Required',
    cancel: 'Cancel',
    save: 'Save',
    rowsPage: 'Rows per page',
    updateList: 'Update list',
    filters: 'Filters/Search',
    of: 'of',
    active: 'Active',
    observation: 'Observation',
    firm: 'Firm',
    edit: 'Edit',
    status: 'State',
    actions: 'Actions',
    close: 'Cerrar'
  },
  entity: {
    title: 'Entities',
    add: 'Add new entity',
    crud: {
      edit: 'Edit',
      name: 'Name',
      code: 'Code',
      acronym: 'Acronym',
      description: 'Description',
      status: 'Status',
      addEnt: 'Add entity',
      editEnt: 'Edit entity',
      address: 'Address',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      web: 'Página web de la institución',
      user_ppte: 'Usuario en el sistema PPTE',
      pass_ppte: 'Contraseña en el sistema PPTE'
    }
  },
  applicants: {
    title: 'Solicitantes',
    add: 'Agregar nuevo solicitante',
    crud: {
      edit: 'Editar',
      names: 'Nombres',
      first_name: 'Primer Apellido',
      second_name: 'Segundo Apellido',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      birthday: 'Fecha de Nacimiento',
      type_document: 'Tipo de Documento',
      number_document: 'Número de Documento',
      address: 'Dirección',
      enrol: 'Matricula',
      departament: 'Departamento',
      province: 'Provincia',
      municipio: 'Municipio',
      status: 'Estado',
      addEnt: 'Agregar Solicitante',
      editEnt: 'Editar Solicitante'
    }
  },
  transact: {
    title: 'Tramite',
    add: 'Agregar nuevo Tramite',
    crud: {
      edit: 'Editar',
      init_date: 'Fecha Inicio',
      end_date: 'Fecha Fin',
      cod_tracking: 'Codigo de Seguimiento',
      solicitante: 'Solicitante',
      status: 'Estado',
      addTran: 'Agregar Tramite',
      editTran: 'Editar Tramite'
    }
  },
  account: {
    title: 'Accounts',
    add: 'Add new account',
    select: 'Choose an entity to see its accounts',
    crud: {
      edit: 'Edit',
      accountNumber: 'Account number',
      status: 'Status',
      entity: 'Entity',
      addAc: 'Add account',
      editAc: 'Edit account'
    }
  },
  user: {
    title: 'Users',
    add: 'Add new user',
    crud: {
      edit: 'Edit',
      user: 'User',
      userData: 'User info',
      entity: 'Entity',
      role: 'Role',
      status: 'Status',
      addUser: 'Add user',
      editUser: 'Edit user',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  module: {
    title: 'Módulos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  log: {
    title: 'Logs',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      fecha: 'Fecha de creación',
      id_usuario: 'Usuario'
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  _default: "The field value is not valid.",
  alpha_dash: "The field may contain alpha-numeric characters as well as dashes and underscores.",
  alpha_num: "The field may only contain alpha-numeric characters.",
  alpha_spaces: "The field may only contain alphabetic characters as well as spaces.",
  alpha: "The field may only contain alphabetic characters.",
  between: "The field must be between {min} and {max}.",
  confirmed: "The field confirmation does not match.",
  credit_card: "The field is invalid.",
  date_between: "The field must be between {min} and {max}.",
  date_format: "The field must be in the format {format}.",
  decimal: "The field must be numeric and may contain {decimals} decimal points.",
  digits: "The field must be numeric and exactly contain {length} digits.",
  dimensions: "The field must be {width} pixels by {height} pixels.",
  email: "The field must be a valid email.",
  ext: "The field must be a valid file.",
  image: "The field must be an image.",
  in: "The field must be a valid value.",
  ip: "The field must be a valid ip address.",
  max: "The field may not be greater than {length} characters.",
  max_value: "The field must be {max} or less.",
  mimes: "The field must have a valid file type.",
  min: "The field must be at least {length} characters.",
  min_value: "The field must be {min} or more.",
  not_in: "The field must be a valid value.",
  numeric: "The field may only contain numeric characters.",
  regex: "The field format is invalid.",
  required: "The field is required.",
  size: "The field must be less than {size} KB.",
  url: "The field is not a valid URL."
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  solicitantes: 'Solicitantes',
  entidades: 'Entidades',
  cuenta: 'Cuentas',
  configuracion: 'Configuraciones',
  usuarios: 'Usuarios',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Solicitudes',
  reportes: 'Reportes'
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validates__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(289);




/* harmony default export */ __webpack_exports__["a"] = ({
  error: __WEBPACK_IMPORTED_MODULE_0__errors__["a" /* default */],
  validate: __WEBPACK_IMPORTED_MODULE_1__validates__["a" /* default */],
  menu: __WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],
  app: {
    title: 'Apostilla',
    account: 'Mi cuenta',
    settings: 'Configuración',
    logOut: 'Cerrar sesión'
  },
  login: {
    title: 'Inicia tu sesión',
    user: 'Nombre de usuario',
    password: 'Contraseña',
    rememberMe: 'Recuerdame',
    forgotPass: '¿Se te olvidó tu contraseña?',
    login: 'Ingresar',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Registrate aquí'
  },
  common: {
    add: 'Agregar',
    required: 'Campo obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar',
    rowsPage: 'Filas por página',
    updateList: 'Actualizar esta lista',
    filters: 'Filtros/búsqueda',
    of: 'de',
    active: 'Activo',
    observation: 'Observar',
    firm: 'Firmar',
    approve: 'Aprobar y Firmar',
    edit: 'Editar',
    status: 'Estado',
    actions: 'Acciones',
    close: 'Cerrar'
  },
  entity: {
    title: 'Entidades',
    add: 'Agregar nueva entidad',
    crud: {
      edit: 'Editar',
      code: 'Código',
      name: 'Nombre',
      acronym: 'Sigla',
      description: 'Descripción',
      status: 'Estado',
      addEnt: 'Agregar entidad',
      editEnt: 'Editar entidad',
      address: 'Dirección',
      email: 'Correo electrónico de atención al cliente',
      phones: 'Teléfono(s)',
      web: 'Página web de la entidad',
      user_ppte: 'Usuario en el sistema PPTE',
      pass_ppte: 'Contraseña en el sistema PPTE'
    }
  },
  applicants: {
    title: 'Solicitantes',
    add: 'Agregar nuevo solicitante',
    crud: {
      edit: 'Editar',
      names: 'Nombres',
      type: 'Tipo',
      first_name: 'Primer Apellido',
      second_name: 'Segundo Apellido',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      birthday: 'Fecha de Nacimiento',
      type_document: 'Tipo de Documento',
      number_document: 'Número de Documento',
      address: 'Dirección',
      enrol: 'Matricula',
      departament: 'Departamento',
      province: 'Provincia',
      municipio: 'Municipio',
      addEnt: 'Agregar Solicitante',
      editEnt: 'Editar Solicitante'
    }
  },
  transact: {
    title: 'Tramites',
    add: 'Agregar nuevo Tramite',
    crud: {
      edit: 'Editar',
      init_date: 'Fecha Inicio',
      end_date: 'Fecha Fin',
      cod_tracking: 'Codigo de Seguimiento',
      solicitante: 'Solicitante',
      status: 'Estado',
      addTran: 'Agregar Tramite',
      editTran: 'Editar Tramite'
    }
  },
  account: {
    title: 'Cuentas',
    add: 'Agregar nueva cuenta',
    select: 'Seleccione una entidad para ver sus cuentas',
    crud: {
      edit: 'Editar',
      accountNumber: 'Nro. de cuenta',
      status: 'Estado',
      entity: 'Entidad',
      addAc: 'Agregar cuenta',
      editAc: 'Editar cuenta'
    }
  },
  user: {
    title: 'Usuarios',
    add: 'Agregar nuevo usuario',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  auxiliar: {
    title: 'Usuarios Auxiliares',
    add: 'Agregar nuevo usuario auxiliar',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  rol: {
    title: 'Roles',
    add: 'Agregar nuevo rol',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      tipo: 'Tipo',
      editRol: 'Editar Rol',
      addRol: 'Agregar Rol'
    }
  },
  parametro: {
    title: 'Parámetros',
    add: 'Agregar nuevo parámetro',
    preferencias: 'Preferencias',
    crud: {
      name: 'Nombre',
      value: 'Valor',
      label: 'Label',
      description: 'Descripción',
      editParametro: 'Editar Parámetro',
      addParametro: 'Agregar Parámetro'
    }
  },
  documento: {
    title: 'Documentos para los trámites de la entidad',
    add: 'Agregar nuevo documento',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estado',
      token_ppte: 'Token PPTE',
      codigo_portal: 'Codigo Portal Unico',
      entity: 'Entidad',
      editDocumento: 'Editar Documento',
      addDocumento: 'Agregar Documento'
    }
  },
  module: {
    title: 'Módulos y permisos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo padre',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  tramite_doc: {
    title: 'Documentos de trámite',
    add: 'Agregar nuevo documento para trámite',
    crud: {
      pago: 'Pago',
      pago_entidad: 'Pago entidad',
      pago_cancilleria: 'pago cancilleria',
      cod_seguridad: 'Codigo seguridad',
      nro_apostilla: 'Nro apostilla',
      tramite_cod_seguimiento: 'Código de seguimiento',
      fecha_expedicion: 'Fecha expedicion',
      estado: 'Estado',
      observacion: 'Observación',
      editTramite_doc: 'Editar Tramite_doc',
      addTramite_doc: 'Agregar Tramite_doc',
      docName: 'Nombre documento',
      status: 'Estado',
      documento_nombre: 'Documento',
      nombre_solicitante: 'Solicitante',
      nro_documento: 'NIT/CI',
      fecha_solicitud: 'Fecha solicitud'
    }
  },
  pago: {
    title: 'Pagos',
    add: 'Agregar nuevo pago',
    crud: {
      editPago: 'Editar pago',
      addPago: 'Agregar pago',
      estado: 'Estado',
      id_cpt: 'ID cpt',
      cpt: 'Código de pago',
      tipo: 'Tipo',
      fecha_pago: 'Fecha de pago',
      nro_documento: 'NIT/CI',
      titular_factura: 'Señor(es)'
    }
  },
  log: {
    title: 'Logs del sistema',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      fecha: 'Fecha de creación',
      id_usuario: 'Usuario'
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  _default: "El valor es inv\xE1lido",
  alpha_dash: "El campo solo debe contener letras, n\xFAmeros y guiones.",
  alpha_num: "El campo solo debe contener letras y n\xFAmeros.",
  alpha_spaces: "El campo solo debe contener letras y espacios.",
  alpha: "El campo solo debe contener letras.",
  between: "El campo debe estar entre {min} y {max}.",
  confirmed: "El campo no coincide con {confirmedField}.",
  credit_card: "El campo es inv\xE1lido.",
  date_between: "El campo debe estar entre {min} y {max}.",
  date_format: "El campo debe tener formato formato {format}.",
  decimal: "El campo debe ser n\xFAmerico y contener {decimals} puntos decimales.",
  digits: "El campo debe ser n\xFAmerico y contener exactamente {length} d\xEDgitos.",
  dimensions: "El campo debe ser de {width} pixeles por {height} pixeles.",
  email: "El campo debe ser un correo electr\xF3nico v\xE1lido.",
  ext: "El campo debe ser un archivo v\xE1lido.",
  image: "El campo debe ser una imagen.",
  in: "El campo debe ser un valor v\xE1lido.",
  ip: "El campo debe ser una direcci\xF3n ip v\xE1lida.",
  max: "El campo no debe ser mayor a {length} caracteres.",
  max_value: "El campo debe de ser {length} o menor.",
  mimes: "El campo debe ser un tipo de archivo v\xE1lido.",
  min: "El campo debe tener al menos {length} caracteres.",
  min_value: "El campo debe ser {length} o superior.",
  not_in: "El campo debe ser un valor v\xE1lido.",
  numeric: "El campo debe contener solo caracteres n\xFAmericos.",
  regex: "El formato del campo no es v\xE1lido.",
  required: "El campo es obligatorio.",
  size: "El campo debe ser menor a {size} KB.",
  url: "El campo no es una URL v\xE1lida."
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // getRoles (filter) {
    //   this.$service.graphql({
    //     query: `
    //       query getRoles {
    //         roles {
    //           count
    //           rows {
    //             id
    //             nombre
    //             descripcion
    //           }
    //         }
    //       }
    //     `,
    //     variables: {}
    //   }).then(response => {
    //     if (response) {
    //       let items = response.roles.rows;
    //       let roles = [];
    //       items.map(rol => {
    //         roles.push({ value: rol.id, text: rol.nombre + ' - ' + rol.descripcion });
    //       });
    //       this.roles = roles;
    //       if (filter && this.filters[filter] && this.filters[filter].items) {
    //         this.filters[filter].items = this.roles;
    //       }
    //     }
    //   });
    // },
    getRegionales: function getRegionales(filter) {
      var _this = this;

      this.$service.graphql({
        query: '\n          query getRegionales {\n            parametroBuscar(name: "REGIONALES") {\n              valor\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response && response.parametroBuscar) {
          _this.regionales = response.parametroBuscar.valor.split(',');
          if (filter && _this.filters[filter] && _this.filters[filter].items) {
            _this.filters[filter].items = _this.regionales;
          }
        }
      });
    }
    // getEntidades (filter) {
    //   this.$service.graphql({
    //     query: `
    //       query getEntidades($estado: EstadoEntidad) {
    //         entidades(estado: $estado) {
    //           count
    //           rows {
    //             id
    //             nombre
    //             sigla
    //           }
    //         }
    //       }
    //     `,
    //     variables: {
    //       estado: 'ACTIVO'
    //     }
    //   }).then(response => {
    //     if (response) {
    //       let items = response.entidades.rows;
    //       let entidades = [];
    //       items.map(est => {
    //         entidades.push({ value: est.id, text: (est.sigla ? `${est.sigla} - ` : '') + est.nombre });
    //       });
    //       this.entidades = entidades;
    //       if (filter && this.filters[filter] && this.filters[filter].items) {
    //         this.filters[filter].items = this.entidades;
    //       }
    //     }
    //   });
    // }

  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getMenu: function getMenu() {
      var _this = this;

      this.$service.get('system/menu').then(function (response) {
        // Actualizando menú
        _this.$storage.set('menu', response.menu);
        _this.$store.commit('setMenu', response.menu);

        // Actualizando permisos
        _this.$storage.set('permissions', response.permisos);
        _this.$store.commit('setPermissions', response.permisos);

        // Actualizando token
        _this.$storage.set('token', response.token);
      });
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getSolicitantes: function getSolicitantes(filter) {
      var _this = this;

      this.$service.graphql({
        query: '\n          query getSolicitantes {\n            solicitantes {\n              count\n              rows {\n                id\n                nombres\n                primer_apellido\n                segundo_apellido\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.solicitantes.rows;
          var solicitantes = [];
          items.map(function (solicitante) {
            solicitantes.push({ value: solicitante.id, text: solicitante.nombres + ' ' + solicitante.primer_apellido + ' ' + solicitante.segundo_apellido });
          });
          _this.solicitantes = solicitantes;
          if (filter && _this.filters[filter] && _this.filters[filter].items) {
            _this.filters[filter].items = _this.solicitantes;
          }
        }
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-useless-escape: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getSolicitantes: function getSolicitantes(filter) {
      var _this = this;

      this.$service.graphql({
        query: '\n          query getSolicitantes {\n            solicitantes {\n              count\n              rows {\n                id\n                nombres\n                primer_apellido\n                segundo_apellido\n              }\n            }\n          }\n        ',
        variables: {}
      }).then(function (response) {
        if (response) {
          var items = response.solicitantes.rows;
          var solicitantes = [];
          items.map(function (solicitante) {
            solicitantes.push({ value: solicitante.id, text: solicitante.nombres + ' ' + solicitante.primer_apellido + ' ' + solicitante.segundo_apellido });
          });
          _this.solicitantes = solicitantes;
          if (filter && _this.filters[filter] && _this.filters[filter].items) {
            _this.filters[filter].items = _this.solicitantes;
          }
        }
      });
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_plugins_event_bus__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_plugins_util__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_plugins_storage__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_plugins_message_message__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_plugins_message_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_plugins_message_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_plugins_loading_loading__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_plugins_service__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_plugins_modal_modal__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_plugins_datetime__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_plugins_filter__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_lang___ = __webpack_require__(253);





// LOCAL




// Plugins











// Vendor
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#0f6a95',
    secondary: '#ffffff',
    info: '#36a3f7',
    warning: '#ffb822',
    error: '#f4516c',
    success: '#34bfa3'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default.a, {
  color: '#52d1e1',
  failedColor: '#fc4b6c',
  thickness: '4px'
});

// i18n config
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: "es",
  messages: __WEBPACK_IMPORTED_MODULE_16__common_lang___["a" /* default */]
});

// Store Vuex
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]);

// Plugins config
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__common_plugins_event_bus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__common_plugins_util__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__common_plugins_storage__["a" /* default */], { appName: 'apostilla' });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__common_plugins_message_message___default.a, { timeout: 6000 });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__common_plugins_loading_loading__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__common_plugins_service__["a" /* default */], {
  apiUrl: "//apostilla.rree.gob.bo/backend-api/api/",
  graphqlUrl: "//apostilla.rree.gob.bo/backend-api/graphql/",
  authUrl: "//apostilla.rree.gob.bo/backend-api/auth",
  authToken: "Bearer",
  filterResponse: function filterResponse(response, Message) {
    if (response.data && response.code === 1) {
      response = response.data;
    } else {
      if (response.code === -1) {
        Message.error(response.message);
        return null;
      } else if (response.code === 0) {
        Message.warning(response.message);
        return null;
      }
    }
    return response;
  },
  errorFormat: 'message'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__common_plugins_modal_modal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__common_plugins_datetime__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__common_plugins_filter__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  i18n: i18n,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    modal: false,
    tramite: null
  },
  mutations: {
    openModal: function openModal(state) {
      state.modal = true;
    },
    closeModal: function closeModal(state) {
      state.modal = false;
    },
    setTramite: function setTramite(state, tramite) {
      state.tramite = tramite;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_layout_AppNavbar__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_layout_AppNavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_layout_AppNavbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_layout_AppSidenav__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_layout_AppSidenav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_layout_AppSidenav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_layout_AppFooter__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_layout_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_layout_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_layout_AppBreadcrumbs__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_layout_AppBreadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_layout_AppBreadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_plugins_message_AppMessages__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_plugins_message_AppMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_plugins_message_AppMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_plugins_loading_AppLoading__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_plugins_loading_AppLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_plugins_loading_AppLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_plugins_modal_AppAlert__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_plugins_modal_AppAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_plugins_modal_AppAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_plugins_modal_AppConfirm__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_plugins_modal_AppConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_plugins_modal_AppConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__components_admin_auth_mixins_auth__["a" /* default */]],
  mounted: function mounted() {
    this.$Progress.finish();
  },
  created: function created() {
    var _this = this;

    if (this.$storage.existUser()) {
      this.$store.commit('setAuth', true);

      if (this.$storage.exist('sidenav')) {
        this.$store.commit('setSidenav', this.$storage.get('sidenav'));
      }

      if (this.$storage.exist('permissions')) {
        this.$store.commit('setPermissions', this.$storage.get('permissions'));
      }

      this.timerSession();

      // this.$router.push('/');
    } else {
      this.logout();
    }

    // Fullscreen event and hack mozilla
    document.addEventListener('onkeyup', function (e) {
      if (e.keyCode === 27) {
        document.querySelector('body').classList.remove('fullscreen');
      }
    });

    document.addEventListener('mozfullscreenchange', function () {
      if (!document.mozFullScreen) {
        document.querySelector('body').classList.remove('fullscreen');
      }
    }, false);

    if (false) {
      window.onbeforeunload = function () {
        return '¿Está seguro de abandonar la página?.';
      };
    }

    // loading bar config
    this.$Progress.start();
    this.$router.beforeEach(function (to, from, next) {
      if (to.meta.progress !== undefined) {
        var meta = to.meta.progress;
        _this.$Progress.parseMeta(meta);
      }
      _this.$Progress.start();
      next();
    });
    this.$router.afterEach(function (to, from) {
      _this.$Progress.finish();
    });
  },

  components: {
    AppNavbar: __WEBPACK_IMPORTED_MODULE_1__common_layout_AppNavbar___default.a,
    AppSidenav: __WEBPACK_IMPORTED_MODULE_2__common_layout_AppSidenav___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_3__common_layout_AppFooter___default.a,
    AppBreadcrumbs: __WEBPACK_IMPORTED_MODULE_4__common_layout_AppBreadcrumbs___default.a,
    AppMessages: __WEBPACK_IMPORTED_MODULE_5__common_plugins_message_AppMessages___default.a,
    AppAlert: __WEBPACK_IMPORTED_MODULE_7__common_plugins_modal_AppAlert___default.a,
    AppLoading: __WEBPACK_IMPORTED_MODULE_6__common_plugins_loading_AppLoading___default.a,
    AppConfirm: __WEBPACK_IMPORTED_MODULE_8__common_plugins_modal_AppConfirm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapState */])(['auth', 'sidenav', 'main'])),
  watch: {
    '$route': function $route(to, from) {
      if (!this.$storage.existUser()) {
        this.logout();
      }
      if (to.path !== '/login' && from.path !== '/login') {
        this.transitionName = 'fade';
      } else {
        this.transitionName = '';
      }
      this.$store.commit('closeModal');
      this.$store.commit('tramite/closeModal');
    }
  },
  data: function data() {
    return {
      transitionName: ''
    };
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.$storage.exist('menu')) {
      var items = this.$util.getMenuOption(this.$storage.get('menu'), this.$route.path);
      this.$store.state.breadcrumbs = items;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var lang = this.$storage.get('lang') || "es";

    this.$i18n.locale = lang;

    for (var i in this.languages) {
      if (this.languages[i].value === lang) {
        this.lang = this.languages[i];
        break;
      }
    }
  },
  data: function data() {
    return {
      languages: [{ value: 'es', text: 'Español', icon: 'es' }, { value: 'ay', text: 'Aymara', icon: 'ay' }, { value: 'en', text: 'English', icon: 'en' }],
      lang: {}
    };
  },

  methods: {
    selectLang: function selectLang(item) {
      this.lang = item;
      this.$i18n.locale = item.value;
      this.$storage.set('lang', item.value);

      this.$store.commit('setMain', false);
      this.$nextTick(function () {
        this.$store.commit('setMain', true);
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppLang__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppLang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AppLang__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_admin_auth_mixins_auth__["a" /* default */]],
  methods: {
    reload: function reload() {
      this.$store.commit('setMain', false);
      this.$nextTick(function () {
        this.$store.commit('setMain', true);
      });
    },
    fullscreen: function fullscreen() {
      document.querySelector('body').classList.toggle('fullscreen');
      this.$util.fullscreen();
    }
  },
  components: { AppLang: __WEBPACK_IMPORTED_MODULE_1__AppLang___default.a }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_layout__ = __webpack_require__(84);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_layout__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$storage.exist('menu')) {
      this.$store.commit('setMenu', this.$storage.get('menu'));
    }

    if (this.$storage.existUser()) {
      this.$store.commit('setUser', this.$storage.getUser());
    }

    this.setActive(this.$route.path);
    setTimeout(function () {
      return _this.clickEvent(_this.$route.path);
    }, 1000);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['menu', 'user']), {
    nombreCompleto: function nombreCompleto() {
      var user = this.$store.state.user;

      return user.nombres;
    },
    inicial: function inicial() {
      var user = this.$store.state.user;
      if (user.usuario) {
        return (user.usuario[0] || '?').toUpperCase();
      }
      return '?';
    }
  }),
  methods: {
    send: function send(url, submenu) {
      if (submenu === undefined) {
        if (this.$storage.exist('menu')) {
          var page = this.$util.getMenuOption(this.$storage.get('menu'), url);
          this.$store.state.breadcrumbs = page;
        }

        this.setActive(url);

        this.$router.push(url || '/');
      }
    },
    getLabel: function getLabel(item) {
      // if (item.url) {
      //   let label = this.$t(`menu.${item.url.replace('/', '')}`);
      //   if (label.indexOf('.') === -1) {
      //     return label;
      //   }
      // }

      return item.label;
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    back: function back() {
      this.$store.state.message = null;
      this.$store.state.modal = false;
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    back: function back() {
      if (this.$store.state.state403) {
        this.$store.state.state403 = false;
        this.$store.state.modal = false;
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    show: function show() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Cargando';

      var loading = document.getElementById('app-loading');
      if (loading) {
        loading.style.display = 'flex';
        loading.querySelector('span').innerHTML = message;
      }
    },
    hide: function hide() {
      var loading = document.getElementById('app-loading');
      if (loading) {
        loading.style.display = 'none';
        loading.querySelector('span').innerHTML = '';
      }
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    timeout: {
      type: Number,
      default: 10000
    }
  },
  methods: {
    success: function success(message, title) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.add(message || 'La operación se realizó correctamente.', title || 'Correcto', 'check', { theme: 'success', timeout: option.timeout });
    },
    info: function info(message, title) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.add(message || 'Revise la documentación.', title || 'Información', 'info', { theme: 'info', timeout: option.timeout });
    },
    warning: function warning(message, title) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.add(message || 'Ocurrió algo inesperado al procesar su operación.', title || 'Advertencia', 'warning', { theme: 'warning', timeout: option.timeout });
    },
    error: function error(message, title) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.add(message || 'Ocurrió un error al procesar su operación.', title || 'Error', 'error', { theme: 'error', timeout: option.timeout });
    },
    add: function add(message, title, icon, _ref) {
      var _this = this;

      var theme = _ref.theme,
          timeout = _ref.timeout;

      if (!this.$parent) {
        this.$mount();
        document.body.appendChild(this.$el);
      }
      var item = { message: message, title: title, icon: icon, theme: theme, key: Date.now() + '-' + Math.random() };
      this.items.push(item);
      setTimeout(function () {
        return _this.remove(item);
      }, timeout || this.timeout);
    },
    remove: function remove(item) {
      var i = this.items.indexOf(item);
      if (i >= 0) {
        this.items.splice(i, 1);
      }
    }
  },
  data: function data() {
    return {
      items: []
    };
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_modal__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_modal__["a" /* default */]],
  mounted: function mounted() {
    var el = document.querySelector('.dialog--confirm');
    if (el) {
      el.parentNode.style.zIndex = 100;
    }
  },

  methods: {
    ok: function ok() {
      var alert = this.$store.state.alert;
      this.$store.commit('CLOSE_ALERT');

      if (typeof alert.callback === 'function') {
        alert.callback();
      }
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    show: function show(store) {
      return store.alert.show;
    },
    text: function text(store) {
      return store.alert.text;
    }
  })
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_modal__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_modal__["a" /* default */]],
  mounted: function mounted() {
    var el = document.querySelector('.dialog--alert');
    if (el) {
      el.parentNode.style.zIndex = 100;
    }
  },

  methods: {
    ok: function ok() {
      var confirm = this.$store.state.confirm;
      confirm.show = false;
      this.$store.commit('CLOSE_CONFIRM');

      if (typeof confirm.callbackOk === 'function') {
        confirm.callbackOk();
      }
    },
    cancel: function cancel() {
      var confirm = this.$store.state.confirm;
      confirm.show = false;
      this.$store.commit('CLOSE_CONFIRM');

      if (typeof confirm.callbackCancel === 'function') {
        confirm.callbackCancel();
      }
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    show: function show(store) {
      return store.confirm.show;
    },
    text: function text(store) {
      return store.confirm.text;
    },
    textOk: function textOk(store) {
      return store.confirm.textOk;
    },
    textCancel: function textCancel(store) {
      return store.confirm.textCancel;
    }
  })
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */]],
  created: function created() {
    this.iniciado = false;
    this.solicitudes = [{
      url_source_pdf: this.$apiUrl + 'eapostilla/apostilla/' + this.solicitud.id_archivo + '/' + this.solicitud.id,
      nombre_archivo: 'documento.pdf',
      codigo_archivo: 'asada-adas-a-fwq-rfqw-rqasa-wrqw',
      id: this.solicitud.id,
      id_archivo: this.solicitud.id_archivo,
      tramite_solicitante_email: this.solicitud.tramite_solicitante_email
    }];
    this.url = 'https://localhost:3200';
    this.urlTokens = this.url + '/tokens';
    this.urlStart = this.url + '/start';
    this.urlCerts = this.url + '/certs';
    this.urlSign = this.url + '/sign';
    this.urlFinish = this.url + '/finish';
    this.urlStatus = this.url + '/estadoToken';
    this.urlKill = this.url + '/matarProceso';
    this.verificarTokenConectado();
  },
  data: function data() {
    return {
      url: '',
      noDemofi: 'Demofi no se est\xE1 ejecutando en su equipo. Verifique que el programa se est\xE9 ejecutando en su m\xE1quina.',
      pin: undefined,
      tokens: [],
      certificados: [],
      firmados: 0,
      iniciado: false,
      iniciando: false,
      firmador: null,
      solicitudes: [],
      autenticado: false,
      autenticando: false,
      firmando: false,
      demofi_ejecutandose: false,
      token_conectado: false,
      boton_autenticar_habilitado: false,
      mostrar_progress: false,
      firmadorSeleccionado: null,
      segmento: true,
      fechaActual: null,
      existeCertificados: false
    };
  },

  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    },
    onSuccess: {
      type: Function,
      default: null
    }
  },
  methods: {
    listTokens: function listTokens() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$loading.show('Obteniendo información del token');
        _this.$http.get(_this.urlTokens).then(function (data) {
          _this.$loading.hide();
          if (data.finalizado === false) return reject(data);
          return resolve(data);
        }).catch(function (error) {
          _this.$loading.hide();
          return reject({
            finalizado: false,
            mensaje: _this.noDemofi,
            data: error
          });
        });
      });
    },
    kill: function kill() {
      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.urlKill);
    },
    statusToken: function statusToken() {
      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.urlStatus).then(function (resp) {
        if (!resp.data || resp.data.finalizado === false || resp.data.mensaje !== 'True') throw Error();
        return true;
      }).catch(function () {
        return false;
      });
    },
    endSession: function endSession() {
      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.urlFinish).then(function (data) {
        return;
      }).catch(function (error) {
        console.log('Error al finalizar session', error);
        return;
      });
    },
    logout: function logout() {
      var _this2 = this;

      return this.statusToken().then(function (estadoToken) {
        if (estadoToken && estadoToken === true) return _this2.endSession();
        return;
      }).catch(function () {
        return;
      });
    },
    login: function login(pin) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(_this3.urlStart + '?pin=' + pin).then(function (data) {
          if (data.data.finalizado === false) return reject(data);
          return resolve(data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this3.noDemofi,
            data: error
          });
        });
      });
    },
    listCertificates: function listCertificates() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(_this4.urlCerts).then(function (data) {
          if (data.data.finalizado === false) return reject(data);
          return resolve(data.data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this4.noDemofi,
            data: error
          });
        });
      });
    },
    sign: function sign(datos) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(_this5.urlSign, datos, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (data) {
          return resolve(data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: 'Demofi no se esta ejecutando en su equipo.',
            data: error
          });
        });
      });
    },
    logoutOLD: function logoutOLD() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return _this6.$http.get(_this6.urlFinish).then(function (data) {
          if (data.finalizado === false) return reject(data);
          _this6.pin = undefined;
          _this6.autenticado = false;
          return resolve(data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this6.noDemofi,
            data: error
          });
        });
      });
    },
    arrayBufferToBase64: function arrayBufferToBase64(buf) {
      buf = new Uint8Array(buf);
      var s = '';
      for (var i = 0; i < buf.byteLength; i++) {
        s += String.fromCharCode(buf[i]);
      }return btoa(s);
    },
    obtenerPdfBase64: function obtenerPdfBase64(urlFile, firmador) {
      var _this7 = this;

      // console.log('Intentando obtener firma en base 64:');
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(urlFile, firmador, {
          responseType: 'arraybuffer',
          headers: { Authorization: 'Bearer ' + _this7.$storage.get('token') }
        }).then(function (response) {
          if (!response || !response.data) throw Error('No existe el arrayBuffer');
          return _this7.arrayBufferToBase64(response.data);
        }).then(function (base64) {
          return resolve(base64);
        }).catch(function (error) {
          console.log('Error al obtener archivo en base 64: ' + error);
          _this7.$message.error(error);
          return reject(error);
        });
      });
    },
    verCertificado: function verCertificado() {
      // ------------------------------ COMENZANDO CON LAS PANTALLAS
      var w = 800;
      var h = 400;
      var y = window.outerHeight / 2 + window.screenY - h / 2;
      var x = window.outerWidth / 2 + window.screenX - w / 2;
      window.open('' + this.url, '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=yes,left=' + x + ',top=' + y + ',width=' + w + ',height=' + h + ',visible=none', '');
    },
    verificarTokenConectado: function verificarTokenConectado() {
      var _this8 = this;

      if (this.iniciando === false) {
        this.iniciando = true;
        this.listTokens().then(function (response) {
          _this8.iniciando = false;
          _this8.iniciado = true;
          _this8.demofi_ejecutandose = true;
          _this8.tokens = response.data.datos;
          _this8.token_conectado = response.data.datos.length > 0;
        }).catch(function (error) {
          _this8.iniciando = false;
          _this8.iniciado = true;
          _this8.token_conectado = false;
          _this8.demofi_ejecutandose = false;
          console.error(error);
        });
      }
    },
    autenticar: function autenticar() {
      var _this9 = this;

      if (this.$refs.form.validate()) {
        this.mostrar_progress = true;
        this.autenticando = true;
        this.$loading.show('Autenticando token');
        return this.login(this.pin).then(function (respLogin) {
          _this9.mostrar_progress = false;
          _this9.autenticando = false;
          _this9.$loading.hide();
          if (!respLogin.data || respLogin.data.finalizado === false) throw Error('Error al autenticar');
          _this9.boton_autenticar_habilitado = false;
          _this9.autenticado = true; // Obtener certificados
          _this9.$loading.show('Obteniendo información del token');
          return _this9.listCertificates();
        }).then(function (respCert) {
          _this9.$loading.hide();
          if (!respCert || !respCert.datos) throw Error('Error al obtener certificados');
          var certificadosValidos = [];
          for (var item in respCert.datos) {
            if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(respCert.datos[0].finValidez, 'DD/MM/YYYY').isAfter(__WEBPACK_IMPORTED_MODULE_5_moment___default()())) {
              certificadosValidos.push(respCert.datos[item]);
            }
          }
          // console.log('hay ' + respCert.datos.length + ' certificados en el token, ' + certificadosValidos.length + ' validos');
          _this9.certificados = certificadosValidos;
          _this9.firmador = respCert.datos[0];
          _this9.firmadorSeleccionado = _this9.firmador.numeroSerie;
          _this9.existeCertificados = true;
          // console.log('datos adicionales,', this.firmador, this.firmadorSeleccionado);
        }).catch(function (error) {
          // console.log('Error en la autenticacion', error);
          _this9.$loading.hide();
          _this9.$message.error(error.data.mensaje || 'No se pudo acceder al token');
          _this9.mostrar_progress = false;
          _this9.autenticando = false;
          _this9.pin = undefined;
          _this9.autenticado = false;
          _this9.firmador = undefined;
          _this9.firmadorSeleccionado = null;
          _this9.boton_autenticar_habilitado = true;
          // console.log(error);
          return _this9.kill();
          // return this.logout();
        });
      }
    },
    cancelar: function cancelar() {
      // Cerrando session con el token
      return this.logout();
    },
    firmarDocumento: function firmarDocumento(documento, alias, indice, total) {
      var _this10 = this;

      var config = { headers: { Authorization: 'Bearer ' + this.$storage.get('token') } };
      this.mostrar_progress = true;
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        documento.estado = 'DESCARGANDO';
        _this10.$loading.show('Obteniendo documento para firmar.' + ('<br />' + (parseInt(indice) + 1) + ' de ' + total + ' documentos.'));
        return _this10.obtenerPdfBase64(documento.url_source_pdf).then(function (base64Pdf) {
          console.log('--------> Revisando la obtencion del documento', base64Pdf.length);
          if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
          documento.pdf_base64 = base64Pdf;
          documento.estado = 'FIRMANDO';
          console.log('--------> Revisando antes de enviar a firmar', base64Pdf);
          return _this10.sign(documento, alias);
        }).then(function (respuestaFirma) {
          respuestaFirma = respuestaFirma.data;
          console.log('---------> Revisando la respuesta de la firma', respuestaFirma);
          if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
            throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
          }
          documento.estado = 'ACTUALIZANDO';
          if (!_this10.solicitud) throw Error('No existe la solicitud');
          var datos = {
            codigo_archivo: documento.codigo_archivo,
            pdf_base64_signed: respuestaFirma.datos.pdf_base64,
            certificado: respuestaFirma.datos.certificado,
            idTramiteDoc: documento.id,
            emailTramiteDoc: documento.tramite_solicitante_email,
            id_archivo: documento.id_archivo
          };
          var url = _this10.$apiUrl + 'eapostilla/update/' + datos.id_archivo;
          console.log(' Revisando la URL de actualizacion', url);
          console.log('Datos de actualizacion', datos);
          _this10.$loading.show('Guardando documento firmado.' + ('<br />' + (parseInt(indice) + 1) + ' de ' + total + ' documentos.'));
          return _this10.$http.post(url, datos, config);
        }).then(function (respuestaActualizacion) {
          console.log('--------> Revisando la respuesta del backend', respuestaActualizacion);
          documento.estado = 'ACTUALIZADO';
          return resolve(respuestaActualizacion);
        }).catch(function (error) {
          console.log('Error al firmar el documento', error);
          _this10.$loading.hide();
          _this10.mostrar_progress = false;
          documento.estado = 'ERROR_DESCARGA';
          return reject(error);
        });
      });
      // return promesa;
    },
    firmarAsincrono: function firmarAsincrono(documentos, indice, alias) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var respuesta;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(indice < documentos.length)) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this11.firmarDocumento(documentos[indice], alias, indice, documentos.length);

              case 4:
                respuesta = _context.sent;

                _this11.correctos.push({ nombre_archivo: documentos[indice].nombre_archivo, data: respuesta });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this11.errores.push({ nombre_archivo: documentos[indice].nombre_archivo, error: _context.t0 });

              case 11:
                indice++;
                _context.next = 14;
                return _this11.firmarAsincrono(documentos, indice, alias);

              case 14:
                _context.next = 28;
                break;

              case 16:
                _this11.$store.commit('setLoading', false);
                _this11.$store.commit('closeModal', 2);
                _this11.$store.commit('closeModal', 3);
                _this11.$store.commit('closeModal', 4);
                _this11.$store.commit('closeModal', 5);
                _this11.$store.commit('closeModal', 7);
                _this11.$store.commit('setPin', undefined);
                _this11.$loading.hide();
                document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
                _this11.logout();
                _this11.firmando = false;
                return _context.abrupt('return');

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this11, [[1, 8]]);
      }))();
    },
    firmarOLD: function firmarOLD() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var aliasSeleccionado, contador, solicitudes;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Obtener el documento en blobs
                console.log('Revisando this', _this12);
                aliasSeleccionado = _this12.firmador.alias;
                contador = 0;

                _this12.firmando = true;
                _this12.firmados = 0;
                _this12.correctos = [];
                _this12.errores = [];
                _this12.$loading.show('Firmando documento, espere por favor.');
                _this12.$store.commit('setLoading', true);
                solicitudes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this12.solicitudes));
                _context2.next = 12;
                return _this12.firmarAsincrono(solicitudes, contador, aliasSeleccionado);

              case 12:
                if (_this12.errores.length > 0) {
                  _this12.solicitud.mensajeError = _this12.correctos.length + ' correctos, ' + _this12.errores.length + ' con error';
                }
                if (typeof _this12.onSuccess === 'function') {
                  _this12.onSuccess(_this12.solicitud);
                }

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12);
      }))();
    },
    firmar: function firmar() {
      var _this13 = this;

      var aliasSeleccionado = this.firmador.alias;
      // const contador = 0;
      this.firmando = true;
      this.$loading.show('Firmando documento, espere por favor.');
      this.$store.commit('setLoading', true);
      var config = { headers: { Authorization: 'Bearer ' + this.$storage.get('token') } };
      var solicitudes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.solicitudes));
      var solicitud = solicitudes[0];
      var url = '';
      var datos = {
        codigo_archivo: solicitud.codigo_archivo,
        idTramiteDoc: solicitud.id,
        emailTramiteDoc: solicitud.tramite_solicitante_email,
        id_archivo: solicitud.id_archivo
      };
      return this.obtenerPdfBase64(solicitud.url_source_pdf, this.firmador).then(function (base64Pdf) {
        if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
        var datosFirmar = {
          nombre_archivo: solicitud.nombre_archivo,
          pdf_base64: base64Pdf,
          alias: aliasSeleccionado
        };
        return _this13.sign(datosFirmar);
      }).then(function (respuestaFirma) {
        respuestaFirma = respuestaFirma.data;
        if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
          throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
        }
        if (!_this13.solicitud) throw Error('No existe la solicitud');
        datos.pdf_base64_signed = respuestaFirma.datos.pdf_base64;
        datos.certificado = respuestaFirma.datos.certificado;
        url = _this13.$apiUrl + 'eapostilla/update/' + datos.id_archivo;
        // return this.logout();
        return;
      }).then(function () {
        _this13.$loading.show('Guardando documento firmado.');
        return _this13.$http.post(url, datos, config);
      }).then(function (respuestaActualizacion) {
        _this13.$store.commit('setLoading', false);
        _this13.$store.commit('closeModal', 2);
        _this13.$store.commit('closeModal', 3);
        _this13.$store.commit('closeModal', 4);
        _this13.$store.commit('closeModal', 5);
        _this13.$store.commit('closeModal', 7);
        _this13.$store.commit('setPin', undefined);
        _this13.$loading.hide();
        document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        _this13.logout();
        _this13.firmando = false;
        return;
      }).catch(function (error) {
        _this13.$store.commit('setLoading', false);
        _this13.$store.commit('closeModal', 2);
        _this13.$store.commit('closeModal', 3);
        _this13.$store.commit('closeModal', 4);
        _this13.$store.commit('closeModal', 5);
        _this13.$store.commit('closeModal', 7);
        _this13.$store.commit('setPin', undefined);
        _this13.$loading.hide();
        document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        console.log('Error al firmar el documento', error);
        _this13.$loading.hide();
        _this13.mostrar_progress = false;
      });
    }
  },
  watch: {
    'firmadorSeleccionado': function firmadorSeleccionado(val) {
      var _this14 = this;

      var seleccionado = {};
      // console.log('{+} revisando el firmador seleccionado', val);
      for (var item in this.certificados) {
        console.log('{+} es igual a ', this.certificados[item].numeroSerie);
        if (this.certificados[item].numeroSerie === val) {
          seleccionado = this.certificados[item];
        }
      }
      this.segmento = false;
      this.$nextTick(function () {
        _this14.segmento = true;
        _this14.firmador = seleccionado;
      });

      if (this.certificados.length > 0) {
        this.existeCertificados = false;
        this.$nextTick(function () {
          _this14.existeCertificados = true;
        });
      }
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */]],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.iniciado = false;

              _this.solicitud = _this.$store.state.selected;

              if (_this.solicitud) {
                if (!Array.isArray(_this.solicitud)) {
                  _this.solicitudes = [{
                    url_source_pdf: _this.$apiUrl + 'eapostilla/apostilla/' + _this.solicitud.id_archivo + '/' + _this.solicitud.id,
                    id: _this.solicitud.id,
                    id_archivo: _this.solicitud.id_archivo,
                    tramite_solicitante_email: _this.solicitud.tramite_solicitante_email,
                    nombre_archivo: 'documento.pdf',
                    codigo_archivo: 'asada-adas-a-fwq-rfqw-rqasa-wrqw'
                  }];
                } else {
                  _this.solicitudes = [];
                  _this.solicitud.map(function (item) {
                    console.log('Es item', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
                    _this.solicitudes.push({
                      url_source_pdf: _this.$apiUrl + 'eapostilla/apostilla/' + item.id_archivo + '/' + item.id,
                      id: item.id,
                      id_archivo: item.id_archivo,
                      tramite_solicitante_email: item.tramite_solicitante_email,
                      nombre_archivo: 'documento-' + item.id_archivo + '.pdf',
                      codigo_archivo: 'asada-adas-a-fwq-rfqw-rqasa-wrqw - ' + item.id_archivo
                    });
                  });
                }
              }

              _this.url = 'https://localhost:3200';
              _this.urlTokens = _this.url + '/tokens';
              _this.urlStart = _this.url + '/start';
              _this.urlCerts = _this.url + '/certs';
              _this.urlSign = _this.url + '/sign';
              _this.urlFinish = _this.url + '/finish';
              _this.urlKill = _this.url + '/matarProceso';
              _this.verificarTokenConectado();

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      url: '',
      noDemofi: 'Demofi no se est\xE1 ejecutando en su equipo. Verifique que el programa se est\xE9 ejecutando en su m\xE1quina.',
      pin: null,
      tokens: [],
      certificados: [],
      firmados: 0,
      iniciado: false,
      iniciando: false,
      firmador: null,
      solicitudes: [],
      autenticado: false,
      autenticando: false,
      firmando: false,
      demofi_ejecutandose: false,
      token_conectado: false,
      boton_autenticar_habilitado: false,
      mostrar_progress: false,
      limite: 0,
      size: 0,
      firmadorSeleccionado: null,
      segmento: true,
      existeCertificados: false
    };
  },

  props: {
    solicitud: {
      type: Array,
      default: function _default() {}
    },
    onSuccess: {
      type: Function,
      default: null
    }
  },
  methods: {
    listTokens: function listTokens() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$loading.show('Obteniendo información del token 1');
        _this2.$http.get(_this2.urlTokens).then(function (data) {
          _this2.$loading.hide();
          if (data.finalizado === false) return reject(data);
          return resolve(data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this2.noDemofi,
            data: error
          });
        });
      });
    },
    kill: function kill() {
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.urlKill);
    },
    login: function login(pin) {
      var _this3 = this;

      this.$loading.show('Autenticando token');
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(_this3.urlStart + '?pin=' + pin).then(function (data) {
          _this3.$loading.hide();
          if (data.data.finalizado === false) return reject(data);else return resolve(data);
        }).catch(function (error) {
          _this3.$loading.hide();
          return reject({
            finalizado: false,
            mensaje: _this3.noDemofi,
            data: error
          });
        });
      });
    },
    listCertificates: function listCertificates() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // this.$loading.show('Obteniendo información del token.');
        _this4.$http.get(_this4.urlCerts).then(function (data) {
          if (data.data.finalizado === false) {
            return reject(data);
          }
          return resolve(data.data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this4.noDemofi,
            data: error
          });
        });
      });
    },
    sign: function sign(solicitudFirma, aliasParaFirmar) {
      var _this5 = this;

      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      console.log('Firmando', solicitudFirma.nombre_archivo);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var infoFirma = {
          nombre_archivo: solicitudFirma.nombre_archivo,
          pdf_base64: solicitudFirma.pdf_base64,
          alias: aliasParaFirmar
        };
        _this5.$loading.show('Firmando documento.' + message);
        return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_this5.urlSign, infoFirma, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (data) {
          _this5.$loading.hide();
          return resolve(data);
        }).catch(function (error) {
          _this5.$loading.hide();
          return reject({
            finalizado: false,
            mensaje: 'Demofi no se est\xE1 ejecutando en su equipo.',
            data: error
          });
        });
      });
    },
    logout: function logout() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return _this6.$http.get(_this6.urlFinish).then(function (data) {
          if (data.finalizado === false) return reject(data);
          return resolve(data);
        }).catch(function (error) {
          return reject({
            finalizado: false,
            mensaje: _this6.noDemofi,
            data: error
          });
        });
      });
    },
    getFileBase64: function getFileBase64(urlFile) {
      var _this7 = this;

      console.log('Obteniendo documento', urlFile);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.$loading.show('Obteniendo documento.');
        _this7.$http.post(urlFile, _this7.firmador, { responseType: 'arraybuffer', headers: { Authorization: 'Bearer ' + _this7.$storage.get('token') } }).then(function (response) {
          _this7.$loading.hide();
          if (response) {
            var enBase64 = new Buffer(response.data, 'binary').toString('base64');
            return resolve(enBase64);
          } else {
            return reject(new Error('La respuesta es incorrecta'));
          }
        }).catch(function (error) {
          console.log('Error al obtener archivo en base 64: ' + error);
          _this7.$message.error(error);
          return reject(error);
        });
      });
    },
    verCertificado: function verCertificado() {
      // ------------------------------ COMENZANDO CON LAS PANTALLAS
      var w = 800;
      var h = 400;
      var y = window.outerHeight / 2 + window.screenY - h / 2;
      var x = window.outerWidth / 2 + window.screenX - w / 2;
      window.open('' + this.url, '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=yes,left=' + x + ',top=' + y + ',width=' + w + ',height=' + h + ',visible=none', '');
    },
    verificarTokenConectado: function verificarTokenConectado() {
      var _this8 = this;

      if (this.iniciando === false) {
        this.iniciando = true;
        this.listTokens().then(function (response) {
          _this8.iniciando = false;
          _this8.iniciado = true;
          _this8.demofi_ejecutandose = true;
          _this8.tokens = response.data.datos;
          _this8.token_conectado = response.data.datos.length > 0;
        }).catch(function (error) {
          _this8.iniciando = false;
          _this8.iniciado = true;
          _this8.token_conectado = false;
          _this8.demofi_ejecutandose = false;
          console.error(error);
        });
      }
    },
    autenticar: function autenticar() {
      var _this9 = this;

      if (this.$refs.form.validate()) {
        this.mostrar_progress = true;
        this.autenticando = true;
        this.$loading.show('Autenticando token');
        return this.login(this.pin).then(function (respLogin) {
          _this9.mostrar_progress = false;
          _this9.autenticando = false;
          _this9.$loading.hide();
          if (respLogin.data.finalizado === true) {
            _this9.boton_autenticar_habilitado = false;
            _this9.autenticado = true; // Obtener certificados
            _this9.$loading.show('Obteniendo información del token 2');
            return _this9.listCertificates() // Una ves autenticado actualizamos la lista de certificados
            .then(function (respCert) {
              _this9.$loading.hide();
              _this9.certificados = respCert.datos;
              _this9.firmador = respCert.datos[0];
              _this9.firmadorSeleccionado = _this9.firmador.numeroSerie;
            }).catch(function (error) {
              console.log(error);
            });
          }
        }).catch(function (error) {
          _this9.$loading.hide();
          _this9.$message.error(error.data.mensaje || 'No se pudo acceder al token');
          _this9.mostrar_progress = false;
          _this9.autenticando = false;
          _this9.pin = undefined;
          _this9.autenticado = false;
          _this9.boton_autenticar_habilitado = true;
          console.log(error);
          // this.logout();
          _this9.kill();
        });
      }
    },
    cancelar: function cancelar() {
      // Cerrando session con el token
      this.logout().then(function (respLogin) {});
    },
    firmarDocumento: function firmarDocumento(documento, alias, indice, total) {
      var _this10 = this;

      var config = { headers: { Authorization: 'Bearer ' + this.$storage.get('token') } };
      this.mostrar_progress = true;
      // console.log('Revisando si es un array', typeof this.solicitud, Array.isArray(this.solicitud));
      // console.log('Revisando el documento', JSON.stringify(documento));
      var promesa = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        documento.estado = 'DESCARGANDO';
        _this10.$loading.show('Obteniendo documento para firmar.' + ('<br />' + (parseInt(indice) + 1) + ' de ' + total + ' documentos.'));
        return _this10.getFileBase64(documento.url_source_pdf).then(function (base64Pdf) {
          // console.log('--------> Revisando la obtencion del documento', base64Pdf);
          if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
          documento.pdf_base64 = base64Pdf;
          documento.estado = 'FIRMANDO';
          return _this10.sign(documento, alias);
        }).then(function (respuestaFirma) {
          respuestaFirma = respuestaFirma.data;
          // console.log('---------> Revisando la respuesta de la firma', respuestaFirma);
          if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
            throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
          }
          documento.estado = 'ACTUALIZANDO';
          if (!_this10.solicitud) throw Error('No existe la solicitud');
          var datos = {
            codigo_archivo: documento.codigo_archivo,
            pdf_base64_signed: respuestaFirma.datos.pdf_base64,
            certificado: respuestaFirma.datos.certificado,
            idTramiteDoc: documento.id,
            emailTramiteDoc: documento.tramite_solicitante_email,
            id_archivo: documento.id_archivo
          };
          var url = _this10.$apiUrl + 'eapostilla/update/' + datos.id_archivo;
          _this10.$loading.show('Guardando documento firmado.' + ('<br />' + (parseInt(indice) + 1) + ' de ' + total + ' documentos.'));
          // console.log(datos, url, config);
          return _this10.$http.post(url, datos, config);
        }).then(function (respuestaActualizacion) {
          // console.log('--------> Revisando la respuesta del backend', respuestaActualizacion);
          documento.estado = 'ACTUALIZADO';
          return resolve(respuestaActualizacion);
        }).catch(function (error) {
          // console.log('Error al firmar el documento', error);
          _this10.$loading.hide();
          _this10.mostrar_progress = false;
          documento.estado = 'ERROR_DESCARGA';
          return reject(error);
        });
      });
      return promesa;
    },
    firmarAsincrono: function firmarAsincrono(documentos, indice, alias) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var respuesta;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(indice < documentos.length)) {
                  _context2.next = 16;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this11.firmarDocumento(documentos[indice], alias, indice, documentos.length);

              case 4:
                respuesta = _context2.sent;

                // console.log('Revisando la repsuesta de la firma de documento', respuesta);
                _this11.correctos.push({ nombre_archivo: documentos[indice].nombre_archivo, data: respuesta });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                _this11.errores.push({ nombre_archivo: documentos[indice].nombre_archivo, error: _context2.t0 });

              case 11:
                indice++;
                _context2.next = 14;
                return _this11.firmarAsincrono(documentos, indice, alias);

              case 14:
                _context2.next = 31;
                break;

              case 16:
                // console.log('DEMOFI logout');
                console.log('correctos', _this11.correctos);
                console.log('errores', _this11.errores);
                _this11.$store.commit('setLoading', false);
                _this11.$store.commit('closeModal', 2);
                _this11.$store.commit('closeModal', 3);
                _this11.$store.commit('closeModal', 4);
                _this11.$store.commit('closeModal', 5);
                _this11.$store.commit('closeModal', 7);
                _this11.$store.commit('setPin', null);
                _this11.$loading.hide();
                document.querySelector('div.input-group--selection-controls__ripple').dispatchEvent(new window.Event('click'));
                document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
                _this11.logout();
                _this11.firmando = false;
                return _context2.abrupt('return');

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11, [[1, 8]]);
      }))();
    },
    firmar: function firmar() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var aliasSeleccionado, contador;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Obtener el documento en blobs
                aliasSeleccionado = _this12.firmador.alias;

                _this12.firmando = true;
                _this12.firmados = 0;
                _this12.correctos = [];
                _this12.errores = [];

                _this12.$loading.show('Firmando documentos, espere por favor');

                // console.log('Documentos firmar', JSON.stringify(this.solicitudes));

                _this12.$store.commit('setLoading', true);
                contador = 0;
                _context3.next = 10;
                return _this12.firmarAsincrono(_this12.solicitudes, contador, aliasSeleccionado);

              case 10:

                if (_this12.errores.length > 0) {
                  _this12.solicitud.mensajeError = _this12.correctos.length + ' correctos, ' + _this12.errores.length + ' con error';
                }

                if (typeof _this12.onSuccess === 'function') {
                  _this12.onSuccess(_this12.solicitud);
                }

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    }
  },
  watch: {
    'firmadorSeleccionado': function firmadorSeleccionado(val) {
      var _this13 = this;

      var seleccionado = {};
      for (var item in this.certificados) {
        if (this.certificados[item].numeroSerie === val) {
          seleccionado = this.certificados[item];
        }
      }
      this.segmento = false;
      this.$nextTick(function () {
        _this13.segmento = true;
        _this13.firmador = seleccionado;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20).Buffer))

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    url: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Arrastra tus archivos aquí'
    },
    name: {
      type: String,
      default: 'file'
    },
    types: {
      type: String,
      default: 'application/pdf'
    },
    maxFilesize: {
      type: Number,
      default: 5
    }
  },
  data: function data() {
    return {
      dropzoneOptions: {
        url: this.url,
        maxFilesize: this.maxFilesize,
        paramName: this.name,
        acceptedFiles: this.types,
        maxFiles: 1,
        addRemoveLinks: true,
        dictDefaultMessage: '<i aria-hidden="true" class="material-icons icon primary--text">cloud_upload</i> ' + this.label,
        dictFallbackMessage: 'Tu navegador no soporta drag and drop.',
        dictFallbackText: 'Usa el formulario de abajo para subir tus archivos como en los viejos tiempos.',
        dictFileTooBig: 'Archivo muy grande ({{filesize}}MiB). Máximo permitido: {{maxFilesize}}MiB.',
        dictInvalidFileType: 'No puede subir este tipo de archivo',
        dictResponseError: 'El servidor respondió con código {{statusCode}}.',
        dictCancelUpload: 'Cancelar subida.',
        dictCancelUploadConfirmation: 'Esta seguro que quiere cancelar?',
        dictRemoveFile: 'Eliminar archivo',
        dictMaxFilesExceeded: 'No puede subir mas archivos.',
        headers: {
          Authorization: this.$authToken + ' ' + this.$storage.get('token')
        }
      }
    };
  },

  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a
  },
  methods: {
    vdropzoneSuccess: function vdropzoneSuccess(file, response) {
      console.log('Archivo subido', file, response);
      if (response && response.data && response.data.id_archivo) {
        this.$store.commit('setArchivo', response.data.id_archivo);
      }
    },
    vdropzoneError: function vdropzoneError(file, message, xhr) {
      this.$message.error(message);
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__["a" /* default */]],
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    store: {
      type: String,
      default: ''
    },
    maxYear: {
      type: Number,
      default: 2100
    },
    value: {
      type: Date,
      default: null
    }
  },
  mounted: function mounted() {
    console.log(this.model, ':', this.value);
    if (this.$datetime.isDate(this.value)) {
      this.setValueDefault(this.value);
    }
  },
  data: function data() {
    return {
      form: {
        day: '',
        month: '',
        year: ''
      },
      meses: this.$datetime.months
    };
  },

  methods: {
    setDate: function setDate() {
      console.log('set', this.form.year, this.form.month, this.form.day, '-', (this.form.year + '').length);
      if (this.form.year && (this.form.year + '').length === 4 && this.form.month && this.form.day) {
        var date = new Date(this.form.year, this.form.month - 1, this.form.day);
        this.$store.commit('setDate', this.model.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.model, date) : date);
        this.setValue(date);
      } else {
        this.$store.commit('setDate', this.model.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.model, null) : null);
        this.setValue();
      }
    },
    setValue: function setValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var key = arguments[1];

      if (this.model.length && this.store.length) {
        this.$store.commit(this.store + 'updateField', { path: this.model, value: value });
      }
      if (key) {
        this.$store.commit('setDate', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
      }
    },
    setValueDefault: function setValueDefault(value) {
      var _this = this;

      var _$datetime$getDate = this.$datetime.getDate(value),
          day = _$datetime$getDate.day,
          month = _$datetime$getDate.month,
          year = _$datetime$getDate.year;

      this.form.day = day;
      this.form.month = month;
      this.form.year = year;
      setTimeout(function () {
        _this.$store.commit('setDate', _this.model.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, _this.model, value) : value);
      });
    }
  },
  watch: {
    'form.day': function formDay(val) {
      if (val && (val > 31 || val.length === 2 && val <= 0)) {
        this.form.day = '';
      }
      this.setDate();
    },
    'form.month': function formMonth(val) {
      if (val && (val > 12 || val.length === 2 && val <= 0)) {
        this.form.month = '';
      }
      this.setDate();
    },
    'form.year': function formYear(val) {
      if (val && val.length === 4 && (val > this.maxYear || val < 1900)) {
        this.form.year = '';
      }
      this.setDate();
    },
    '$store.state.clean': function $storeStateClean(val) {
      if (val === this.model) {
        this.form.year = '';
        this.form.month = '';
        this.form.day = '';
        this.$store.commit('setDate', this.model.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.model, null) : null);
      }
      this.$store.commit('cleanDate', false);
    },
    '$store.state.action': function $storeStateAction(val) {
      var _this2 = this;

      if (val.action === 'setDateValue') {
        var _$datetime$getDate2 = this.$datetime.getDate(val.value),
            day = _$datetime$getDate2.day,
            month = _$datetime$getDate2.month,
            year = _$datetime$getDate2.year;

        this.form.day = day;
        this.form.month = month;
        this.form.year = year;
        setTimeout(function () {
          _this2.setValue(val.value, val.key);
        }, 500);
      }
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    url: {
      type: String,
      default: this.$apiUrl
    },
    filter: {
      type: Boolean,
      default: false
    },
    idRefresh: {
      type: String,
      default: 'btn-refresh-list'
    },
    idFilter: {
      type: String,
      default: 'btn-filter'
    },
    filters: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    order: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    widthModal: {
      type: Number,
      default: 480
    },
    graphql: {
      type: Boolean,
      default: false
    },
    dataGraphql: {
      type: String,
      default: ''
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: [],
      search: {},
      totalItems: 0,
      items: [],
      loading: true,
      pagination: {
        rowsPerPage: 10
      },
      load: false,
      // rowsPerPageItems: [5, 10, 25, { text: 'Todos', value: -1 }]
      rowsPerPageItems: [5, 10, 25],
      showFilterActive: this.showFilter
    };
  },
  created: function created() {
    if (this.$util.toType(this.order) === 'array' && this.order.length) {
      this.pagination.sortBy = this.order[0];
      if (this.order[1]) {
        this.pagination.descending = this.order[1] === 'DESC';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getData();

    this.$bus.$on('updateList', function () {
      _this.getData();
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['modal']), {
    getHeaders: function getHeaders() {
      var items = [];
      this.headers.map(function (el) {
        el.align = 'left';
        items.push(el);
      });
      return items;
    }
  }),
  methods: {
    getValues: function getValues() {
      if (this.dataGraphql.length) {
        return this.dataGraphql || 'id';
      } else {
        var values = [];
        this.headers.map(function (el) {
          if (el.value) {
            values.push(el.value);
          }
        });
        return values.join('\n');
      }
    },
    getFilterTypes: function getFilterTypes() {
      var values = [];
      this.filters.map(function (el) {
        if (el.typeG) {
          if (el.type !== 'hidden') {
            values.push('$' + el.field + ': ' + el.typeG);
          }
        }
      });
      return values.join(',\n');
    },
    getFilterParams: function getFilterParams() {
      var values = [];
      this.filters.map(function (el) {
        if (el.typeG) {
          if (el.type === 'hidden') {
            if (el.typeG === 'String') {
              values.push(el.field + ': "' + el.value + '"');
            } else {
              values.push(el.field + ': ' + el.value);
            }
          } else {
            values.push(el.field + ': $' + el.field);
          }
        }
      });
      return values.join(',\n');
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          descending = _pagination.descending,
          page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;


      var query = {
        limit: rowsPerPage,
        page: page
      };

      if (sortBy) {
        query.order = (descending ? '-' : '') + sortBy;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.search).length) {
        for (var key in this.search) {
          if (!this.$filter.empty(this.search[key])) {
            query[key] = this.search[key];
          }
          if (this.search[key] === 'false') {
            query[key] = false;
          }
        }
      }

      if (this.graphql) {
        this.$service.graphql({
          query: '\n            query getLista(\n              $order: String,\n              $limit: Int,\n              $page: Int,\n              ' + this.getFilterTypes() + '\n            ) {\n              ' + this.url + '(\n                limit: $limit,\n                order: $order,\n                page: $page,\n                ' + this.getFilterParams() + '\n              ) {\n                count\n                rows {\n                  id\n                  ' + this.getValues() + '\n                }\n              }\n            }\n          ',
          variables: query
        }).then(function (response) {
          if (response) {
            _this2.selected = [];
            var items = response[_this2.url].rows;
            items.map(function (el) {
              if (el.estado !== undefined) {
                el.active = el.estado === 'INACTIVO' ? 'INACTIVE' : 'ACTIVE';
              }
            });

            _this2.items = items;
            _this2.totalItems = response[_this2.url].count;
            // if (response.totalFiltro !== undefined && response.totalFiltro < response.total && response.totalFiltro < this.pagination.rowsPerPage) {
            //   this.pagination.page = 1;
            // }
            _this2.loading = false;
            _this2.load = true;
          }
        });
      } else {
        this.$service.list(this.url.list || this.url, query).then(function (response) {
          if (response) {
            _this2.selected = [];
            var items = response.datos;
            items.map(function (el) {
              if (el.estado !== undefined) {
                el.active = el.estado === 'INACTIVO' ? 'INACTIVE' : 'ACTIVE';
              }
            });

            _this2.items = items;
            _this2.totalItems = response.totalFiltro || response.total;
            if (response.totalFiltro !== undefined && response.totalFiltro < response.total && response.totalFiltro < _this2.pagination.rowsPerPage) {
              _this2.pagination.page = 1;
            }
            _this2.loading = false;
            _this2.load = true;
          }
        });
      }
    },
    filtrar: function filtrar() {
      this.showFilterActive = !this.showFilterActive;

      if (!this.showFilterActive) {
        for (var key in this.search) {
          this.search[key] = '';
        }
      }
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        if (this.load) {
          this.getData();
        }
      },

      deep: true
    },
    search: {
      handler: function handler() {
        if (this.load) {
          this.getData();
        }
      },

      deep: true
    },
    selected: function selected(val) {
      /*  let items = [];
        val.map(item => {
          items.push(item.id);
        });
        console.log('items', items);
        this.$store.commit('setSelected', items); */
      this.$store.commit('setSelected', val);
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfjs_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'app-pdf-viewer'
    },
    url: {
      type: String,
      default: ''
    },
    valido: {
      type: Function,
      default: function _default(val) {
        return val;
      }
    }
  },
  data: function data() {
    return {
      page_num: 0,
      page_count: 0
    };
  },
  created: function created() {
    this.pdfDoc = null;
    this.pageNum = 1;
    this.pageRendering = false;
    this.pageNumPending = null;
    this.scale = 1.6;
  },
  mounted: function mounted() {
    this.canvas = document.getElementById(this.id);
    this.ctx = this.canvas.getContext('2d');

    if (this.data) {
      this.render(this.data);
    }
  },

  methods: {
    render: function render(data) {
      var _this = this;

      // let pdfData = atob(btoa(String.fromCharCode(...new Uint8Array(data))));
      var pdfData = atob(data);

      // Disable workers to avoid yet another cross-origin issue (workers need
      // the URL of the script to be loaded, and dynamically loading a cross-origin
      // script does not work).
      // PDFJS.disableWorker = true;

      // The workerSrc property shall be specified.
      // window.PDFJS.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

      // Using DocumentInitParameters object to load binary data.
      var loadingTask = window.PDFJS.getDocument({ data: pdfData });
      loadingTask.promise.then(function (pdsfDoc_) {
        _this.pdfDoc = pdsfDoc_;
        _this.page_count = _this.pdfDoc.numPages;
        _this.valido(true);
        _this.renderPage(_this.pageNum);
      }, function (error) {
        // PDF loading error
        this.valido(false);
        console.error('Error PDF', error);
      }.bind(this));
    },

    /**
     * Get page info from document, resize canvas accordingly, and render page.
     * @param num Page number.
     */
    renderPage: function renderPage(num) {
      var _this2 = this;

      this.pageRendering = true;
      // Using promise to fetch the page
      this.pdfDoc.getPage(num).then(function (page) {
        var viewport = page.getViewport(_this2.scale);
        _this2.canvas.height = viewport.height;
        _this2.canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: _this2.ctx,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(function () {
          _this2.pageRendering = false;
          if (_this2.pageNumPending !== null) {
            // New page rendering is pending
            _this2.renderPage(_this2.pageNumPending);
            _this2.pageNumPending = null;
          }
        });
      });

      // Update page counters
      this.page_num = num;
    },

    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     */
    queueRenderPage: function queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },

    /**
     * Displays previous page.
     */
    onPrevPage: function onPrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },

    /**
     * Displays next page.
     */
    onNextPage: function onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    },
    descargar: function descargar(url) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: url,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$storage.get('token')
        },
        json: true,
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        var d = new Date();
        link.setAttribute('download', _this3.$store.state.user.usuario + d.getTime() + '.pdf');
        document.body.appendChild(link);
        link.click();
      });
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_auth_mixins_auth__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FileUpload from '@/common/util/FileUpload.vue';
// import Demofi from '@/common/util/Demofi.vue';


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_admin_auth_mixins_auth__["a" /* default */]],
  created: function created() {
    if (!this.$storage.existUser()) {
      this.logout();
    }
  }
  // components: {
  //   // FileUpload,
  //   Demofi
  // },
  // methods: {
  //   showMessage (type) {
  //     console.log(type, this.$message);
  //     this.$message[type](`Mensaje tipo ${type}`);
  //   },
  //   showAlert () {
  //     this.$alert('Mensaje de alerta', function () {
  //       console.log('callback!!');
  //     });
  //   },
  //   showConfirm () {
  //     this.$confirm('Mensaje de confirmación', function () {
  //       console.log('ok!!');
  //     }, function () {
  //       console.log('cancel!!');
  //     });
  //   }
  // }

});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__["a" /* default */]],
  data: function data() {
    return {
      graphql: true,
      url: 'logs',
      headers: [{ text: this.$t('log.crud.nivel'), value: 'nivel' }, { text: this.$t('log.crud.tipo'), value: 'tipo' }, { text: this.$t('log.crud.mensaje'), value: 'mensaje' }, { text: this.$t('log.crud.referencia'), value: 'referencia' }, { text: this.$t('log.crud.ip'), value: 'ip' }, { text: this.$t('log.crud.fecha'), value: 'fecha' }, { text: this.$t('log.crud.id_usuario'), value: 'id_usuario' }],
      order: ['fecha', 'DESC'],
      dataGraphql: '\n        id\n        nivel\n        tipo\n        mensaje\n        referencia\n        ip\n        fecha\n        id_usuario\n        usuario_usuario\n        usuario_nombres\n        usuario_primer_apellido\n        usuario_segundo_apellido\n      ',
      filters: [{
        field: 'mensaje',
        label: this.$t('log.crud.mensaje'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'tipo',
        label: this.$t('log.crud.tipo'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nivel',
        label: this.$t('log.crud.nivel'),
        type: 'select',
        typeG: 'NivelLog',
        items: [{ value: '', text: 'TODOS' }, { value: 'ERROR', text: 'ERROR' }, { value: 'INFO', text: 'INFO' }, { value: 'ADVERTENCIA', text: 'ADVERTENCIA' }]
      }]
    };
  },

  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountPass__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountPass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AccountPass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_layout_mixins_layout__ = __webpack_require__(84);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_admin_auth_mixins_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_layout_mixins_layout__["a" /* default */]],
  mounted: function mounted() {
    this.setActive('account');
  },
  data: function data() {
    return {
      modalDeactivate: false,
      hidePass: true,
      form: {
        password: ''
      }
    };
  },

  components: { AccountPass: __WEBPACK_IMPORTED_MODULE_3__AccountPass___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['user']), {
    inicial: function inicial() {
      var user = this.$store.state.user;
      if (user.usuario) {
        return (user.usuario[0] || '?').toUpperCase();
      }
      return '?';
    },
    getIcon: function getIcon() {
      return this.form.password.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }),
  methods: {
    openPass: function openPass() {
      this.$store.commit('openModal');
    },
    openDeactivate: function openDeactivate() {
      this.form.password = '';
      this.hidePass = true;
      this.modalDeactivate = true;
    },
    deactivate: function deactivate() {
      var _this = this;

      this.$service.patch('system/desactivar_cuenta/' + this.$store.state.user.id, { password: this.form.password }).then(function (resp) {
        if (resp.finalizado) {
          _this.$message.success(resp.mensaje);
          _this.$store.commit('closeModal');
          _this.logout();
        } else {
          _this.$message.error(resp.mensaje);
        }
      });
    },
    changeIcon: function changeIcon() {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    }
  },
  watch: {
    'form.password': function formPassword(val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_admin_auth_mixins_auth__["a" /* default */]],
  data: function data() {
    return {
      hidePass: true,
      form: {
        password: '',
        newPassword: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['user', 'modal']), {
    getIcon: function getIcon() {
      return this.form.password.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }),
  methods: {
    changePassword: function changePassword() {
      var _this = this;

      this.$service.patch('system/cambiar_pass/' + this.$store.state.user.id, this.form).then(function (resp) {
        if (resp.finalizado) {
          _this.$message.success(resp.mensaje);
          _this.$store.commit('closeModal');
        } else {
          _this.$message.error(resp.mensaje);
        }
      });
    },
    changeIcon: function changeIcon() {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    }
  },
  watch: {
    'form.password': function formPassword(val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    },
    'form.newPassword': function formNewPassword(val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_layout_AppLang__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_layout_AppLang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_layout_AppLang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_mixins_validate__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__common_mixins_validate__["a" /* default */]],
  data: function data() {
    return {
      valid: true,
      form: {
        username: '',
        password: ''
      },
      hidePass: true,
      remember: false
    };
  },

  methods: {
    changeIcon: function changeIcon() {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        this.login(this.form);
      }
    }
  },
  components: { AppLang: __WEBPACK_IMPORTED_MODULE_1__common_layout_AppLang___default.a },
  computed: {
    getIcon: function getIcon() {
      return this.form.password.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  },
  watch: {
    'form.password': function formPassword(val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_auxiliar__ = __webpack_require__(292);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_auxiliar__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.entidades = [];
    // this.getEntidades(3);
    this.roles = [];
    // this.getRoles(4);
    this.getRegionales(5);
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'auxiliares',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('common.active'), sortable: false }, { text: this.$t('auxiliar.crud.user'), value: 'usuario' }, { text: this.$t('auxiliar.crud.fullname'), value: 'primer_apellido' }, { text: this.$t('auxiliar.crud.email'), value: 'email' }, { text: 'Regional', value: 'departamento' }, { text: this.$t('auxiliar.crud.status'), value: 'estado' }],
      dataGraphql: '\n        id\n        usuario\n        email\n        nombres\n        primer_apellido\n        segundo_apellido\n        telefono\n        cargo\n        estado\n        departamento\n      ',
      form: {
        'usuario': '',
        'contrasena': '',
        'nombres': '',
        'primer_apellido': '',
        'segundo_apellido': '',
        'email': '',
        'cargo': '',
        'telefono': ''
      },
      filters: [{
        field: 'usuario',
        label: this.$t('auxiliar.crud.user'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nombre_completo',
        label: this.$t('auxiliar.crud.fullname'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'email',
        label: this.$t('auxiliar.crud.email'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'departamento',
        label: 'Regional',
        type: 'select',
        typeG: 'String',
        items: []
      }, {
        field: 'estado',
        label: this.$t('auxiliar.crud.status'),
        type: 'select',
        typeG: 'EstadoAuxiliar',
        items: [{ value: '', text: 'TODOS' }, { value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }]
      }],
      regionales: [],
      hidePass: true,
      usuario: null,
      valid: true
    };
  },

  methods: {
    changeIcon: function changeIcon() {
      if (this.form.contrasena.length) {
        this.hidePass = !this.hidePass;
      }
    },
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
      } else {
        this.form = {
          'usuario': '',
          'contrasena': '',
          'nombres': '',
          'primer_apellido': '',
          'segundo_apellido': '',
          'email': '',
          'cargo': '',
          'telefono': ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        console.log('Revisando la data a guardar', data);
        // data._usuario_creacion = 1;
        data.id_rol = 6; // FIXME: Como obtenemos este dato??
        data.id_entidad = this.$store.state.user.id_entidad;
        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $auxiliar: EditAuxiliar!) {\n                auxiliarEdit(id: $id, auxiliar: $auxiliar) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              auxiliar: data
            }
          }).then(function (response) {
            if (response) {
              if (_this.usuario === _this.form.usuario) {
                _this.$message.warning('Sus datos fueron actualizados, debe ingresar de nuevo al sistema.');
                _this.logout();
              } else {
                _this.$store.commit('closeModal');
                _this.updateList();
                _this.$message.success('Se actualizó el registro correctamente');
              }
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($auxiliar: NewAuxiliar!) {\n                auxiliarAdd(auxiliar: $auxiliar) {\n                  id\n                }\n              }\n            ',
            variables: {
              auxiliar: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    regenerar: function regenerar(item) {
      var _this2 = this;

      this.$confirm('¿Está seguro que desea regenerar esta contraseña ?', function () {
        _this2.$service.post('system/generar_pass_auxiliar/' + item.id).then(function (response) {
          if (response.finalizado) {
            _this2.$message.success(response.mensaje);
            _this2.$store.commit('closeModal');
          } else {
            _this2.$message.error(response.mensaje);
          }
        });
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a
  },
  computed: {
    getIcon: function getIcon() {
      return this.form.contrasena.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Permisos__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Permisos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Permisos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_usuario_mixins_usuario__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_modulo__ = __webpack_require__(293);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_admin_usuario_mixins_usuario__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_modulo__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.modulos = [];
    this.getModulos();
    this.roles = [];
    this.getRoles();

    this.$store.state.modal2 = false;
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'modulos',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('module.crud.permissions'), sortable: false }, { text: this.$t('common.active'), sortable: false }, { text: this.$t('module.crud.visible'), sortable: false }, { text: this.$t('module.crud.label'), value: 'label' }, { text: this.$t('module.crud.path'), value: 'ruta' }, { text: this.$t('module.crud.icon'), value: 'icono' }, { text: this.$t('module.crud.module'), value: 'id_modulo' }, { text: this.$t('module.crud.order'), value: 'orden' }, { text: this.$t('module.crud.visible'), value: 'visible' }, { text: this.$t('common.status'), value: 'estado' }],
      form: {
        label: '',
        ruta: '',
        icono: '',
        orden: '',
        visible: true,
        id_modulo: ''
      },
      dataGraphql: '\n        id\n        ruta\n        label\n        icono\n        orden\n        estado\n        visible\n        id_modulo\n        modulo_label\n        seccion_label\n      ',
      filters: [{
        field: 'label',
        label: this.$t('module.crud.label'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'id_modulo',
        label: this.$t('module.crud.module'),
        type: 'select',
        typeG: 'Int',
        items: []
      }, {
        field: 'estado',
        label: this.$t('module.crud.status'),
        type: 'select',
        typeG: 'EstadoModulo',
        items: [{ value: '', text: 'TODOS' }, { value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }]
      }],
      modulos: [],
      valid: true,
      modulo: {},
      isSection: false
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
        this.form.id_modulo = this.getValue(this.form.id_modulo, this.modulos);
        if (this.form.id_modulo) {
          this.isSection = true;
        }
      } else {
        this.form = {
          label: '',
          ruta: '',
          icono: '',
          orden: '',
          visible: true,
          id_modulo: ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id_modulo && data.id_modulo.value) {
          data.id_modulo = data.id_modulo.value;
          if (data.id_modulo) {
            data.icono = '';
          }
        } else {
          delete data.id_modulo;
        }

        if (data.id) {
          delete data.id;
          delete data.modulo_label;
          delete data.seccion_label;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $modulo: EditModulo!) {\n                moduloEdit(id: $id, modulo: $modulo) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              modulo: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
              _this.getMenu();
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($modulo: NewModulo!) {\n                moduloAdd(modulo: $modulo) {\n                  id\n                  label\n                }\n              }\n            ',
            variables: {
              modulo: data
            }
          }).then(function (response) {
            if (response) {
              _this.openPermisos(response.moduloAdd);
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    getModulos: function getModulos() {
      var _this2 = this;

      this.$service.graphql({
        query: '\n          query getModulos($estado: EstadoModulo, $id_modulo: Int) {\n            modulos(estado: $estado, id_modulo: $id_modulo) {\n              count\n              rows {\n                id\n                label\n                icono\n              }\n            }\n          }\n        ',
        variables: {
          estado: 'ACTIVO',
          id_modulo: 0
        }
      }).then(function (response) {
        if (response) {
          var items = response.modulos.rows;
          var modulos = [];
          items.map(function (mod) {
            modulos.push({ value: mod.id, text: mod.label });
          });
          _this2.modulos = _this2.filters[1].items = modulos;
        }
      });
    },
    changeVisible: function changeVisible(obj, id) {
      var _this3 = this;

      var visible = !!obj.visible;
      this.$confirm('\xBFEst\xE1 seguro de ' + (visible ? 'mostrar' : 'ocultar') + ' el m\xF3dulo en el men\xFA?.', function () {
        _this3.$service.graphql({
          query: '\n            mutation edit($id: Int!, $modulo: EditModulo!) {\n              moduloEdit(id: $id, modulo: $modulo) {\n                id\n              }\n            }\n          ',
          variables: {
            id: id,
            modulo: {
              visible: visible
            }
          }
        }).then(function (response) {
          if (response) {
            if (visible) {
              _this3.$message.success('\xA1M\xF3dulo visible!', null, { timeout: 1500 });
            } else {
              _this3.$message.warning('\xA1M\xF3dulo oculto!', null, { timeout: 1500 });
            }
            _this3.updateList();
            _this3.getMenu();
          }
        });
      }, function () {
        return obj.visible = !visible;
      });
    },
    getModulo: function getModulo(id) {
      for (var i in this.modulos) {
        if (id) {
          if (parseInt(this.modulos[i].value) === id) {
            return this.modulos[i].text;
          }
        }
      }
      return '';
    },
    openPermisos: function openPermisos(modulo) {
      this.modulo = modulo;
      this.$store.commit('openModal', 2);
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a,
    Permisos: __WEBPACK_IMPORTED_MODULE_4__Permisos___default.a
  },
  watch: {
    '$store.state.modal2': function $storeStateModal2(val) {
      if (val === false && this.$store.state.changes) {
        this.$store.commit('setChanges', 0);
        this.getMenu();
      }
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    roles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modulo: {
      type: Object,
      default: function _default() {}
    }
  },
  created: function created() {
    this.getPermisos(this.modulo.id);
  },
  data: function data() {
    return {
      permisos: [],
      activo: true
    };
  },

  methods: {
    setPermiso: function setPermiso(data) {
      var _this = this;

      var permiso = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
      delete permiso.id;
      delete permiso.rol_nombre;
      delete permiso.rol_descripcion;
      this.$service.graphql({
        query: '\n          mutation update($id: Int!, $permiso: EditPermiso!) {\n            permisoEdit(id: $id, permiso: $permiso) {\n              id\n            }\n          }\n        ',
        variables: {
          id: data.id,
          permiso: permiso
        }
      }).then(function (response) {
        if (response) {
          console.log('changes', _this.$store.state.changes);
          _this.$store.commit('setChanges', _this.$store.state.changes + 1);
          _this.$message.success('¡Permiso actualizado!', null, { timeout: 1500 });
        }
      });
    },
    getPermisos: function getPermisos(idModulo) {
      var _this2 = this;

      this.permisos = [];
      this.$service.graphql({
        query: '\n          query getPermisos($id_modulo: Int) {\n            permisos(id_modulo: $id_modulo, order: "id_rol") {\n              count\n              rows {\n                id\n                create\n                read\n                update\n                delete\n                firma\n                csv\n                activo\n                id_modulo\n                id_rol\n                rol_nombre\n                rol_descripcion\n              }\n            }\n          }\n        ',
        variables: {
          id_modulo: idModulo
        }
      }).then(function (response) {
        if (response) {
          _this2.permisos = response.permisos.rows;
        }
      });
    }
  },
  watch: {
    'modulo.id': function moduloId(val) {
      this.getPermisos(val);
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.idParametro = this.user.id_parametro;
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'parametros',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('parametro.crud.name'), value: 'nombre' }, { text: this.$t('parametro.crud.value'), value: 'valor' }, { text: this.$t('parametro.crud.label'), value: 'label' }, { text: this.$t('parametro.crud.description'), value: 'descripcion' }],
      form: {
        nombre: '',
        valor: '',
        label: '',
        descripcion: ''
      },
      dataGraphql: '\n        id\n        nombre\n        valor\n        label\n        descripcion\n      ',
      filters: [{
        field: 'nombre',
        label: this.$t('parametro.crud.name'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'valor',
        label: this.$t('parametro.crud.value'),
        type: 'text',
        typeG: 'String'
      }],
      idParametro: null,
      valid: true
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
      } else {
        this.form = {
          nombre: '',
          valor: '',
          label: '',
          descripcion: ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $parametro: EditParametro!) {\n                parametroEdit(id: $id, parametro: $parametro) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              parametro: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($parametro: NewParametro!) {\n                parametroAdd(parametro: $parametro) {\n                  id\n                }\n              }\n            ',
            variables: {
              parametro: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rol__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Rol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Parametro__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Parametro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Parametro__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active: 'parametros'
    };
  },

  components: {
    Rol: __WEBPACK_IMPORTED_MODULE_0__Rol___default.a,
    Parametro: __WEBPACK_IMPORTED_MODULE_1__Parametro___default.a
  },
  watch: {
    active: function active(val) {
      console.log(val);
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.idRol = this.user.id_rol;
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'roles',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('rol.crud.name'), value: 'nombre' }, { text: this.$t('rol.crud.description'), value: 'descripcion' }],
      form: {
        nombre: '',
        descripcion: ''
      },
      dataGraphql: '\n        id\n        nombre\n        descripcion\n      ',
      filters: [],
      idRol: null,
      valid: true,
      tipos: [{ text: 'ADMIN' }, { text: 'CANCILLERIA' }, { text: 'ENTIDAD' }]
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
      } else {
        this.form = {
          nombre: '',
          descripcion: ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $rol: EditRol!) {\n                rolEdit(id: $id, rol: $rol) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              rol: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($rol: NewRol!) {\n                rolAdd(rol: $rol) {\n                  id\n                }\n              }\n            ',
            variables: {
              rol: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_usuario__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_usuario__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.entidades = [];
    this.getEntidades(3);
    this.roles = [];
    this.getRoles(4);
    this.getRegionales(5);
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'usuarios',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('common.active'), sortable: false }, { text: this.$t('user.crud.user'), value: 'usuario' }, { text: this.$t('user.crud.fullname'), value: 'primer_apellido' }, { text: this.$t('user.crud.email'), value: 'email' }, { text: this.$t('user.crud.entity'), value: 'id_entidad' }, { text: this.$t('user.crud.role'), value: 'id_rol' }, { text: 'Regional', value: 'departamento' }, { text: this.$t('user.crud.status'), value: 'estado' }],
      dataGraphql: '\n        id\n        usuario\n        email\n        nombres\n        primer_apellido\n        segundo_apellido\n        telefono\n        cargo\n        estado\n        departamento\n        id_entidad\n        id_rol\n        entidad_nombre\n        rol_nombre\n      ',
      form: {
        'usuario': '',
        'contrasena': '',
        'nombres': '',
        'primer_apellido': '',
        'segundo_apellido': '',
        'email': '',
        'cargo': '',
        'telefono': '',
        'id_entidad': '',
        'id_rol': ''
      },
      filters: [{
        field: 'usuario',
        label: this.$t('user.crud.user'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nombre_completo',
        label: this.$t('user.crud.fullname'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'email',
        label: this.$t('user.crud.email'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'id_entidad',
        label: this.$t('user.crud.entity'),
        type: 'select',
        typeG: 'Int',
        items: []
      }, {
        field: 'id_rol',
        label: this.$t('user.crud.role'),
        type: 'select',
        typeG: 'Int',
        items: []
      }, {
        field: 'departamento',
        label: 'Regional',
        type: 'select',
        typeG: 'String',
        items: []
      }, {
        field: 'estado',
        label: this.$t('user.crud.status'),
        type: 'select',
        typeG: 'EstadoUsuario',
        items: [{ value: '', text: 'TODOS' }, { value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }]
      }],
      regionales: [],
      regionalesSeleccionadas: [],
      hidePass: true,
      usuario: null,
      valid: true
    };
  },

  methods: {
    changeIcon: function changeIcon() {
      if (this.form.contrasena.length) {
        this.hidePass = !this.hidePass;
      }
    },
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
        this.form.id_rol = this.getValue(this.form.id_rol, this.roles);
        this.form.id_entidad = this.getValue(this.form.id_entidad, this.entidades);
        this.form.departamento = data.departamento.split(',');
        this.regionalesSeleccionadas = this.form.departamento;
      } else {
        this.form = {
          'usuario': '',
          'contrasena': '',
          'nombres': '',
          'primer_apellido': '',
          'segundo_apellido': '',
          'email': '',
          'cargo': '',
          'telefono': '',
          'id_entidad': '',
          'id_rol': ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$store.state.user.id_rol === 5) {
        this.form.id_entidad = this.$store.state.user.id_entidad;
      }
      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id_rol.value) {
          data.id_rol = data.id_rol.value;
        }
        if (data.id_entidad.value) {
          data.id_entidad = data.id_entidad.value;
        }

        var departamentosFiltrado = this.regionalesSeleccionadas.filter(function (departamento) {
          return departamento.length > 1;
        });

        data.departamento = departamentosFiltrado.join(',');
        if (data.id) {
          delete data.id;
          delete data.entidad_nombre;
          delete data.rol_nombre;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $usuario: EditUsuario!) {\n                usuarioEdit(id: $id, usuario: $usuario) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              usuario: data
            }
          }).then(function (response) {
            if (response) {
              if (_this.usuario === _this.form.usuario) {
                _this.$message.warning('Sus datos fueron actualizados, debe ingresar de nuevo al sistema.');
                _this.logout();
              } else {
                _this.$store.commit('closeModal');
                _this.updateList();
                _this.$message.success('Se actualizó el registro correctamente');
              }
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($usuario: NewUsuario!) {\n                usuarioAdd(usuario: $usuario) {\n                  id\n                }\n              }\n            ',
            variables: {
              usuario: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    regenerar: function regenerar(item) {
      var _this2 = this;

      this.$confirm('¿Está seguro que desea regenerar esta contraseña ?', function () {
        _this2.$service.post('system/generar_pass/' + item.id).then(function (response) {
          if (response.finalizado) {
            _this2.$message.success(response.mensaje);
            _this2.$store.commit('closeModal');
          } else {
            _this2.$message.error(response.mensaje);
          }
        });
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a
  },
  computed: {
    getIcon: function getIcon() {
      return this.form.contrasena.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      documento: null,
      usuarioapp: null,
      show: false,
      showUsuariosApp: false,
      idEntidadPPTE: null,
      idTramtie: null,
      loading: false
    };
  },

  props: ['mydocs'],
  methods: {
    obtainTokenForDocument: function obtainTokenForDocument() {
      var _this = this;

      // get number of tramites. send idEndidad e idTramite en PPTE
      var datos = this.mydocs.portal.filter(function (x) {
        return x.codigo_portal === _this.documento;
      })[0]; // this.documento tiene el codigo_portal en objetos de mydocs.portal
      var montosDatosTramitesEntidadPpte = this.montos; // Obteniendo montos de datosTramitesEntidadPpte

      var montosCuentas = [];
      for (var i in montosDatosTramitesEntidadPpte) {
        var Monto = montosDatosTramitesEntidadPpte[i].monto;
        var Cuenta = montosDatosTramitesEntidadPpte[i].cuenta.cuenta;
        montosCuentas.push({ monto: Monto, cuenta: Cuenta });
      }
      datos.monto = montosCuentas;

      this.loading = true;
      this.$service.post('eapostilla/obtener_token_tramite/' + this.idEntidadPPTE + '/' + this.idTramite + '/' + (this.usuarioapp.id_usuario_app ? this.usuarioapp.id_usuario_app : this.usuarioapp), datos).then(function (response) {
        _this.loading = false;
        if (response) {
          _this.show = false;
          _this.showUsuariosApp = false;
          _this.idEntidadPPTE = null;
          _this.idTramite = null;
          _this.$store.commit('closeModal', 3);
          _this.$message.success('Se agregó el documento correctamente.');
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    }
  },
  computed: {
    obtenerCodigosPortalDeTramitesEnPpte: function obtenerCodigosPortalDeTramitesEnPpte() {
      return this.mydocs.datosTramitesEntidadPpte.map(function (x) {
        return x.codigoPortalUnico;
      });
    }
  },
  watch: {
    documento: function documento(val) {
      if (this.obtenerCodigosPortalDeTramitesEnPpte.includes(val.toString())) {
        // codigo PortalTramites existe en PPTE?
        this.showUsuariosApp = true;
        this.idTramite = this.mydocs.datosTramitesEntidadPpte.filter(function (x) {
          return x.codigoPortalUnico === val.toString();
        })[0].id;
        this.montos = this.mydocs.datosTramitesEntidadPpte.filter(function (x) {
          return x.codigoPortalUnico === val.toString();
        })[0].montos;

        if (this.mydocs.usuariosApp && this.mydocs.usuariosApp.length === 1) {
          this.usuarioapp = this.mydocs.usuariosApp[0];
        }
      } else {
        this.showUsuariosApp = false;
        this.usuarioapp = null;
      }
      console.log('Documentos del portal de trámites: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.mydocs));

      this.show = false;
    },
    usuarioapp: function usuarioapp(val) {
      if (val) {
        this.show = true;
        if (this.mydocs.usuariosApp.length === 1) {
          if (val.id_entidad) {
            this.idEntidadPPTE = val.id_entidad;
          }
        } else {
          this.idEntidadPPTE = this.mydocs.usuariosApp.filter(function (x) {
            return x.id_usuario_app === val;
          })[0].id_entidad;
        }
      }
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_usuario_mixins_usuario__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginPpte__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginPpte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LoginPpte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddDocs__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AddDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Regenerar__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Regenerar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Regenerar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_admin_usuario_mixins_usuario__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.entidades = [];
    this.derivar_opciones = ['ENTIDAD', 'CANCILLERIA'];
    this.getEntidades(1);
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'documentos',
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('common.active'), sortable: false }, { text: this.$t('documento.crud.name'), value: 'nombre' }, { text: this.$t('documento.crud.description'), value: 'descripcion' }, { text: 'Código del portal único', value: 'codigo_portal' }, { text: 'Entidad', value: 'id_entidad' }, { text: 'Derivar a:', value: 'derivar' }, { text: 'Precio', value: 'precio' }, { text: this.$t('documento.crud.status'), value: 'estado' }],
      dataGraphql: '\n        id\n        nombre\n        descripcion\n        codigo_portal\n        derivar\n        precio\n        cuenta\n        monto\n        token_ppte\n        duracion\n        estado\n        id_entidad\n        entidad_nombre\n      ',
      form: {
        'nombre': '',
        'descripcion': '',
        'codigo_portal': '',
        'precio': '',
        'token_ppte': '',
        'derivar': '',
        'id_entidad': ''
      },
      filters: [{
        field: 'nombre',
        label: this.$t('documento.crud.name'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'id_entidad',
        label: this.$t('documento.crud.entity'),
        type: 'select',
        typeG: 'Int',
        items: []
      }, {
        field: 'estado',
        label: this.$t('documento.crud.status'),
        type: 'select',
        typeG: 'EstadoDocumento',
        items: [{ value: '', text: 'TODOS' }, { value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }]
      }],
      documento: null,
      doc: null,
      valid: true,
      mydocs: null
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
        this.form.id_entidad = this.getValue(this.form.id_entidad, this.entidades);
      } else {
        this.form = {
          'nombre': '',
          'descripcion': '',
          'token_ppte': '',
          'derivar': '',
          'id_entidad': ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id_entidad.value) {
          data.id_entidad = data.id_entidad.value;
        }
        if (data.id) {
          delete data.id;
          delete data.entidad_nombre;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $documento: EditDocumento!) {\n                documentoEdit(id: $id, documento: $documento) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              documento: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($documento: NewDocumento!) {\n                documentoAdd(documento: $documento) {\n                  id\n                }\n              }\n            ',
            variables: {
              documento: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    openDocs: function openDocs() {
      var _this2 = this;

      // verificar si existe usuario y password de ppte.
      this.$service.get('eapostilla/verificar_datos_usuario_ppte').then(function (response) {
        if (response && response.redirect) {
          if (response.redirect === 'auth') {
            _this2.$store.commit('openModal', 5);
          } else {
            _this2.getDocumentos();
          }
        }
      });
    },
    regenerar: function regenerar(id) {
      var _this3 = this;

      // verificar si existe usuario y password de ppte.
      this.$service.get('eapostilla/verificar_datos_usuario_ppte').then(function (response) {
        if (response && response.redirect) {
          if (response.redirect === 'auth') {
            _this3.$store.commit('openModal', 5);
          } else {
            _this3.getDoc(id);
          }
        }
      });
    },
    getDoc: function getDoc(id) {
      var _this4 = this;

      this.doc = null;
      this.$service.get('eapostilla/obtener_doc/' + id).then(function (response) {
        if (response) {
          _this4.doc = response;
          _this4.$store.commit('openModal', 4);
        }
      });
    },
    getDocumentos: function getDocumentos() {
      var _this5 = this;

      this.mydocs = null;
      this.$service.get('eapostilla/obtener_docs').then(function (response) {
        if (response) {
          _this5.mydocs = response;
          if (_this5.mydocs.length === 0) {
            _this5.$alert('La entidad ya no cuenta con trámites en el Portal único de trámites para agregar');
          } else {
            _this5.$store.commit('openModal', 3);
          }
        }
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a,
    AddDocs: __WEBPACK_IMPORTED_MODULE_6__AddDocs___default.a,
    LoginPpte: __WEBPACK_IMPORTED_MODULE_5__LoginPpte___default.a,
    Regenerar: __WEBPACK_IMPORTED_MODULE_7__Regenerar___default.a
  },
  watch: {
    '$store.state.action': function $storeStateAction(val) {
      if (val === 'getDocumentos') {
        this.getDocumentos();
      }
      if (val === 'getDoc') {
        this.getDoc(this.$store.state.data);
      }
      this.$store.commit('setAction', null);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_layout_AppLang__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_layout_AppLang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_layout_AppLang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__["a" /* default */]],
  data: function data() {
    return {
      valid: true,
      form: {
        username: '',
        password: ''
      },
      hidePass: true,
      remember: false,
      loading: false
    };
  },

  methods: {
    changeIcon: function changeIcon() {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    },
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$service.post('eapostilla/login_ppte', this.form).then(function (response) {
          _this.loading = false;
          if (response) {
            // resultado ok
            _this.$message.success('Se ha establecido la conexión con la Plataforma de Pagos.');
            _this.$store.commit('closeModal', 5);
            _this.$store.commit('setAction', 'getDocumentos');
          }
        });
      }
    }
  },
  components: { AppLang: __WEBPACK_IMPORTED_MODULE_0__common_layout_AppLang___default.a },
  computed: {
    getIcon: function getIcon() {
      return this.form.password.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  },
  watch: {
    'form.password': function formPassword(val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['doc'],
  data: function data() {
    return {
      documento: null,
      usuarioapp: null,
      show: false,
      showUsuariosApp: false,
      idEntidadPPTE: null,
      idTramtie: null,
      loading: false
    };
  },
  created: function created() {
    this.documento = this.doc.documento.codigo_portal;
    this.getTramite(this.documento);
  },

  methods: {
    obtainTokenForDocument: function obtainTokenForDocument() {
      var _this = this;

      // get number of tramites. send idEndidad e idTramite en PPTE
      this.loading = true;
      var datos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.doc.documento);
      delete datos.id;
      this.$service.post('eapostilla/obtener_token_tramite/' + this.idEntidadPPTE + '/' + this.idTramite + '/' + (this.usuarioapp.id_usuario_app ? this.usuarioapp.id_usuario_app : this.usuarioapp), datos).then(function (response) {
        _this.loading = false;
        if (response) {
          _this.show = false;
          _this.showUsuariosApp = false;
          _this.idEntidadPPTE = null;
          _this.idTramite = null;
          _this.$store.commit('closeModal', 4);
          _this.$message.success('El token se regeneró correctamente.');
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    },
    getTramite: function getTramite(val) {
      if (this.obtenerCodigosPortalDeTramitesEnPpte.includes(val.toString())) {
        // codigo PortalTramites existe en PPTE?
        this.showUsuariosApp = true;
        this.idTramite = this.doc.datosTramitesEntidadPpte.filter(function (x) {
          return x.codigoPortalUnico === val.toString();
        })[0].id;

        if (this.doc.usuariosApp && this.doc.usuariosApp.length === 1) {
          this.usuarioapp = this.doc.usuariosApp[0];
        }
        this.show = true;
      } else {
        this.showUsuariosApp = false;
        this.usuarioapp = null;
        this.show = false;
      }
    }
  },
  computed: {
    obtenerCodigosPortalDeTramitesEnPpte: function obtenerCodigosPortalDeTramitesEnPpte() {
      return this.doc.datosTramitesEntidadPpte.map(function (x) {
        return x.codigoPortalUnico;
      });
    }
  },
  watch: {
    documento: function documento(val) {
      this.getTramite(val);
    },
    usuarioapp: function usuarioapp(val) {
      if (val) {
        this.show = true;
        if (this.doc.usuariosApp.length === 1) {
          if (val.id_entidad) {
            this.idEntidadPPTE = val.id_entidad;
          }
        } else {
          this.idEntidadPPTE = this.doc.usuariosApp.filter(function (x) {
            return x.id_usuario_app === val;
          })[0].id_entidad;
        }
      }
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.$store.commit('closeModal', 2);
  },
  mounted: function mounted() {
    if (this.$store.state.user.id_rol === 5) {
      this.editItem(this.$store.state.user.id_entidad, 'entidad', this.dataGraphql, false);
    }
  },
  data: function data() {
    return {
      successAlert: false,
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'entidades',
      token: null,
      nombre: null,
      headers: [{ text: this.$t('common.actions'), sortable: false }, { text: this.$t('common.active'), sortable: false }, { text: this.$t('entity.crud.name'), value: 'nombre' }, { text: this.$t('entity.crud.acronym'), value: 'sigla' }, { text: this.$t('entity.crud.web'), value: 'web' }, { text: this.$t('entity.crud.address'), value: 'direccion' }, { text: this.$t('common.status'), value: 'estado' }],
      form: {
        nombre: '',
        sigla: '',
        descripcion: '',
        email: '',
        web: '',
        direccion: '',
        telefonos: [],
        estado: ''
      },
      dataGraphql: '\n        id\n        nombre\n        sigla\n        descripcion\n        email\n        token\n        telefonos\n        direccion\n        codigo_portal\n        web\n        estado\n      ',
      filters: [{
        field: 'nombre',
        label: this.$t('entity.crud.name'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'sigla',
        label: this.$t('entity.crud.acronym'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'estado',
        label: this.$t('entity.crud.status'),
        type: 'select',
        typeG: 'EstadoEntidad',
        items: [{ value: '', text: 'TODOS' }, { value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }]
      }],
      idEntidad: null,
      valid: true
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.valid = true;
      this.$refs.form.reset();
      if (data.id) {
        if (data.telefonos) {
          data.telefonos = data.telefonos.split(',');
        } else {
          data.telefonos = [];
        }
        this.form = data;
      } else {
        this.form = {
          nombre: '',
          sigla: '',
          descripcion: '',
          email: '',
          web: '',
          direccion: '',
          telefonos: [],
          estado: ''
        };
      }
      if (form) {
        this.$store.commit('openModal');
      }
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.form);
        data.telefonos = data.telefonos.join(',');
        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $entidad: EditEntidad!) {\n                entidadEdit(id: $id, entidad: $entidad) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              entidad: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          data.estado = 'ACTIVO';
          this.$service.graphql({
            query: '\n              mutation add($entidad: NewEntidad!) {\n                entidadAdd(entidad: $entidad) {\n                  id\n                }\n              }\n            ',
            variables: {
              entidad: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    remove: function remove(item) {
      this.form.telefonos.splice(this.form.telefonos.indexOf(item), 1);
      this.form.telefonos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.form.telefonos));
    },
    descargarTodo: function descargarTodo() {
      var _this2 = this;

      this.$service.post('eapostilla/descargar_entidades_docs').then(function (response) {
        if (response) {
          _this2.updateList();
          _this2.$message.success('La sincronizaci\xF3n se realiz\xF3 correctamente.');
        }
      });
    },
    regenerar: function regenerar(item) {
      var _this3 = this;

      this.$service.post('eapostilla/generar_token/' + item.id).then(function (response) {
        if (response) {
          _this3.token = response.token;
          _this3.nombre = item.nombre;
          _this3.$store.commit('openModal', 2);
        }
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__["a" /* default */]],
  data: function data() {
    return {
      graphql: true,
      url: 'pagos',
      headers: [{ text: this.$t('pago.crud.estado'), value: 'estado' }, { text: this.$t('pago.crud.tipo'), value: 'tipo' }, { text: this.$t('pago.crud.titular_factura'), value: 'titular_factura' }, { text: this.$t('pago.crud.nro_documento'), value: 'nro_documento' }, { text: this.$t('pago.crud.cpt'), value: 'id' }, { text: 'Nro. Tramite', value: 'id_tramite_doc' }, { text: 'Fecha de autorización - Pago', value: '_created_at' }, { text: this.$t('pago.crud.fecha_pago'), value: 'fecha_pago' }],
      order: ['_created_at', 'DESC'],
      dataGraphql: '\n        id\n        id_tramite_doc\n        cpt\n        tipo\n        estado\n        fecha_pago\n        _created_at\n        nro_documento\n        titular_factura\n      ',
      filters: [{
        field: 'cpt',
        label: this.$t('pago.crud.cpt'),
        type: 'text',
        typeG: 'JSON'
      }, {
        field: 'nro_documento',
        label: this.$t('pago.crud.nro_documento'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'fecha_pago',
        label: this.$t('pago.crud.fecha_pago'),
        type: 'text',
        typeG: 'Date'
      }, {
        field: 'titular_factura',
        label: this.$t('pago.crud.titular_factura'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'tipo',
        label: this.$t('pago.crud.tipo'),
        type: 'select',
        typeG: 'TipoPago',
        items: [{ value: '', text: 'TODOS' }, { value: 'ENTIDAD', text: 'ENTIDAD' }, { value: 'CANCILLERIA', text: 'CANCILLERIA' }]
      }, {
        field: 'estado',
        label: this.$t('pago.crud.estado'),
        type: 'select',
        typeG: 'EstadoPago',
        items: [{ value: '', text: 'TODOS' }, { value: 'PENDIENTE', text: 'PENDIENTE' }, { value: 'HABILITADO', text: 'HABILITADO' }, { value: 'PAGADO', text: 'PAGADO' }]
      }]
    };
  },

  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_solicitante__ = __webpack_require__(294);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_admin_auth_mixins_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_solicitante__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'solicitantes',
      headers: [{ text: this.$t('applicants.crud.names'), value: 'nombres' }, { text: this.$t('applicants.crud.email'), value: 'email' }, { text: this.$t('applicants.crud.type_document'), value: 'tipo_documento' }, { text: this.$t('applicants.crud.type'), value: 'tipo' }, { text: this.$t('applicants.crud.departament'), value: 'id_departamento' }, { text: this.$t('applicants.crud.province'), value: 'id_provincia' }, { text: this.$t('applicants.crud.municipio'), value: 'id_municipio' }],
      dataGraphql: '\n        tipo\n        nombres\n        primer_apellido\n        segundo_apellido\n        email\n        telefono\n        fecha_nacimiento\n        tipo_documento\n        nro_documento\n        direccion\n        matricula\n        id_departamento\n        id_provincia\n        id_municipio\n        departamento_nombre\n        provincia_nombre\n        municipio_nombre\n\n      ',
      form: {
        'nombres': '',
        'primer_apellido': '',
        'segundo_apellido': ''
      },
      filters: [{
        field: 'nombre_completo',
        label: this.$t('applicants.crud.names'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'tipo_documento',
        label: this.$t('applicants.crud.type_document'),
        type: 'select',
        typeG: 'String',
        items: [{ value: '', text: 'TODOS' }, { value: 'CI', text: 'CI' }, { value: 'NIT', text: 'NIT' }, { value: 'PASAPORTE', text: 'PASAPORTE' }]
      }, {
        field: 'tipo',
        label: this.$t('applicants.crud.type'),
        type: 'select',
        typeG: 'String',
        items: [{ value: '', text: 'TODOS' }, { value: 'NATURAL', text: 'NATURAL' }, { value: 'JURIDICA', text: 'JURIDICA' }]
      }, {
        field: 'nro_documento',
        label: this.$t('applicants.crud.number_document'),
        type: 'Integer',
        typeG: 'Int'
      }],
      hidePass: true,
      solicitante: null,
      valid: true
    };
  },

  methods: {
    changeIcon: function changeIcon() {
      if (this.form.contrasena.length) {
        this.hidePass = !this.hidePass;
      }
    },
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
      } else {
        this.form = {
          'nombres': '',
          'primer_apellido': '',
          'segundo_apellido': ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form);
        if (data.id_rol.value) {
          data.id_rol = data.id_rol.value;
        }
        if (data.id_entidad.value) {
          data.id_entidad = data.id_entidad.value;
        }
        if (data.id) {
          delete data.id;
          delete data.entidad_nombre;
          delete data.rol_nombre;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $solicitante: EditSolicitante!) {\n                solicitanteEdit(id: $id, solicitante: $solicitante) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              solicitante: data
            }
          }).then(function (response) {
            if (response) {
              if (_this.solicitante === _this.form.solicitante) {
                _this.$message.warning('Sus datos fueron actualizados, debe ingresar de nuevo al sistema.');
                _this.logout();
              } else {
                _this.$store.commit('closeModal');
                _this.updateList();
                _this.$message.success('Se actualizó el registro correctamente');
              }
            }
          });
        } else {
          this.$service.graphql({
            query: '\n              mutation add($solicitante: NewSolicitante!) {\n                solicitanteAdd(solicitante: $solicitante) {\n                  id\n                }\n              }\n            ',
            variables: {
              solicitante: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a
  },
  computed: {
    getIcon: function getIcon() {
      return this.form.contrasena.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetalleDoc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetalleDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DetalleDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      estados: estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__["a" /* default */]],
  created: function created() {
    // Cargando tramite
    this.getTramite(this.solicitud.id);
  },

  components: {
    DetalleDoc: __WEBPACK_IMPORTED_MODULE_1__DetalleDoc___default.a,
    PdfView: __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView___default.a
  },
  methods: {
    imprimir: function imprimir() {
      var _this = this;

      // alert(JSON.stringify(this.tramite));
      var url = this.$apiUrl + 'eapostilla/apostilla_para_imprimir/' + this.tramite.id_archivo + '/' + this.tramite.id;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: url,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + this.$storage.get('token')
        },
        json: true,
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        var d = new Date();
        link.setAttribute('download', _this.$store.state.user.usuario + d.getTime() + '.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    cerrar_ventana: function cerrar_ventana() {
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function $storeStateArchivo(val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_SelectDate__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_SelectDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_SelectDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var regionales = ['LA PAZ', 'COCHABAMBA', 'SANTA CRUZ'];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__["a" /* default */]],
  components: {
    SelectDate: __WEBPACK_IMPORTED_MODULE_1__common_util_SelectDate___default.a
  },
  data: function data() {
    return {
      menu: false,
      menu2: false,
      regionales: regionales,
      regional: ''
    };
  },

  props: {
    solicitud: {
      type: Object,
      default: null
    },
    pagos: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isDisabled: function isDisabled() {
      // this.solicitud.documento_derivar === 'ENTIDAD'
      return this.$store.state.user.id_rol === 3 || this.$store.state.user.id_rol === 4 || this.solicitud && this.solicitud.estado === 'REVISADO_CANCILLERIA';
    }
  },
  methods: {
    formato_fecha: function formato_fecha(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_Demofi__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_Demofi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_util_Demofi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_pdf_PdfView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_pdf_PdfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_util_pdf_PdfView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Observar_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Observar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Observar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetalleDoc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetalleDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DetalleDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_tramite_doc__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

var mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_mixins_crud_table__["a" /* default */]],
  data: function data() {
    return {
      estados: estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true,
      pdfValido: false
    };
  },
  created: function created() {
    this.$store.state.modal5 = false;
    // segun rol, verificar que estado a tramite doc corresponde
    if (this.$store.state.user.id_rol === 4) {
      // firmante cancilleria
      this.solicitud.estadoTramiteDoc = 'APOSTILLADO';
    }
    if (this.$store.state.user.id_rol === 7) {
      // firmante entidad
      this.solicitud.estadoTramiteDoc = 'FIRMADO_ENTIDAD';
    }

    this.$store.commit('setLoading', false);
    if (this.solicitud) {
      this.getTramite(this.solicitud.id);
    }
  },

  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue___default.a,
    Demofi: __WEBPACK_IMPORTED_MODULE_2__common_util_Demofi___default.a,
    Observar: __WEBPACK_IMPORTED_MODULE_4__Observar_vue___default.a,
    DetalleDoc: __WEBPACK_IMPORTED_MODULE_5__DetalleDoc___default.a,
    PdfView: __WEBPACK_IMPORTED_MODULE_3__common_util_pdf_PdfView___default.a
  },
  methods: {
    validarPdf: function validarPdf(val) {
      if (val === false) this.pdfValido = false;else this.pdfValido = true;
    },
    cambiarDoc: function cambiarDoc() {
      this.tramite.id_archivo = 1;
    },
    cancelarCambio: function cancelarCambio() {
      this.tramite.id_archivo = this.$store.state.archivo;
    },
    cerrar_ventana: function cerrar_ventana() {
      this.$store.commit('closeModal', 3);
      this.$store.commit('setPin', undefined);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    },
    firm: function firm(item) {
      var _this = this;

      this.$confirm('¿Está seguro que desea aprobar este documento ?', function () {
        // let tipo = this.$store.state.user.id_rol === 4 ? 'CANCILLERIA' : 'ENTIDAD'; // deshabilitado dado que el pago ya no se hace en las entidades
        var tipo = 'CANCILLERIA';

        var pagos = _this.pagos.filter(function (item) {
          return item.tipo === tipo;
        });

        if (_this.$store.state.user.id_rol === 4) {
          // solo se verifican pagos en cancillería
          console.log('Iniciando el proceso de firma');
          if (_this.tramite.pago_entidad === true) {
            // Tramite pagado en entidad
            if (document.getElementById('btn-demofi-firm')) {
              _this.$store.commit('setData', item);
              document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
            } else {
              _this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
            }
          } else {
            if (pagos[0] && pagos[0].estado === 'PAGADO') {
              if (document.getElementById('btn-demofi-firm')) {
                _this.$store.commit('setData', item);
                document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
              } else {
                _this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
              }
            } else {
              _this.$message.warning('Debe realizar el pago correspondiente antes para poder firmar el documento');
            }
          }
        } else {
          // otro rol que no sea el firmante de cancilleria
          if (document.getElementById('btn-demofi-firm')) {
            _this.$store.commit('setData', item);
            document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
          } else {
            _this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
          }
        }
      });
    },
    openObservar: function openObservar(item) {
      this.solicitud = item;
      this.$store.commit('openModal', 5);
    },
    cambiarEstado: function cambiarEstado(item) {
      if (item.mensajeError) {
        console.log('Error al firmar: ' + item.mensajeError);
        this.$message.error(item.mensajeError);
      } else {
        var estado = this.$store.state.user.id_rol === 4 ? 'APOSTILLADO' : 'FIRMADO_ENTIDAD';
        this.$message.success(mensajes[estado]);
      }
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function $storeStateArchivo(val) {
      console.info('Revisando el valor de entrada', val);
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    },
    'solicitud.solicitud.pdfValido': function solicitudSolicitudPdfValido(pdf) {
      console.info('HOla desde el watch para el pdf', pdf);
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_DemofiGrupal__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_DemofiGrupal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_DemofiGrupal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observar_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Observar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetalleDoc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetalleDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DetalleDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_tramite_doc__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

var mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__common_util_crud_table_mixins_crud_table__["a" /* default */]],
  data: function data() {
    return {
      estados: estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true
    };
  },
  created: function created() {},

  components: {
    Demofi: __WEBPACK_IMPORTED_MODULE_1__common_util_DemofiGrupal___default.a,
    Observar: __WEBPACK_IMPORTED_MODULE_3__Observar_vue___default.a,
    DetalleDoc: __WEBPACK_IMPORTED_MODULE_4__DetalleDoc___default.a,
    PdfView: __WEBPACK_IMPORTED_MODULE_2__common_util_pdf_PdfView___default.a
  },
  methods: {
    firm: function firm(items) {
      var _this = this;

      var sinArchivos = [];
      for (var i in items) {
        if (parseInt(items[i].id_archivo) === 1) {
          sinArchivos.push(items[i].id);
        }
      }

      if (sinArchivos.length) {
        this.$message.warning('Debe adjuntar un archivo PDF para los tramites: ' + sinArchivos.join(' '));
      } else {
        if (this.$store.state.user.id_rol === 4) {
          var errores = [];
          for (var _i in items) {
            if (!items[_i].pago_cancilleria) {
              errores.push('Solicitud ' + items[_i].id);
            }
          } // validando pago en cancilleria

          if (errores.length) {
            this.$message.warning('Debe realizar el pago correspondiente antes para poder firmar los siguientes documentos: <br> <strong>' + errores.join('<br>') + '</strong>');
          } else {
            this.$confirm(items.length === 1 ? '¿Está seguro que desea aprobar este documento ?' : '¿Está seguro que desea aprobar estos documentos ?', function () {
              if (document.getElementById('btn-demofi-firm-grupal')) {
                document.getElementById('btn-demofi-firm-grupal').dispatchEvent(new window.Event('click'));
              } else {
                _this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
              }
            });
          }
        } else {
          this.$confirm(items.length === 1 ? '¿Está seguro que desea aprobar este documento ?' : '¿Está seguro que desea aprobar estos documentos ?', function () {
            if (document.getElementById('btn-demofi-firm-grupal')) {
              document.getElementById('btn-demofi-firm-grupal').dispatchEvent(new window.Event('click'));
            } else {
              _this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
            }
          });
        }
      }
    },
    cerrar_ventana: function cerrar_ventana() {
      this.$store.commit('closeModal', 7);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    },
    cambiarEstado: function cambiarEstado(item) {
      if (item.mensajeError) {
        console.log('Error al firmar: ' + item.mensajeError);
        this.$message.error(item.mensajeError);
      } else {
        var estado = this.$store.state.user.id_rol === 4 ? 'APOSTILLADO' : 'FIRMADO_ENTIDAD';
        this.$message.success(mensajes[estado]);
      }
      this.$store.commit('closeModal', 7);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function $storeStateArchivo(val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    },
    'solicitud.id': function solicitudId(val) {
      console.log('Cambiando solicitud', val);
      if (val > 0) {
        // Cargando tramite
        this.$store.commit('setLoading', false);
        this.getTramite(val);
      }
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Detalle__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Detalle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Detalle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_usuario_mixins_usuario__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var regionales = ['LA PAZ', 'COCHABAMBA', 'SANTA CRUZ'];

var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_admin_usuario_mixins_usuario__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.departamento = this.user.departamento;
    this.$store.state.modal2 = false;
    this.documentos = [];
    this.getDocumentos(1);

    this.regionales = this.user.departamento.split(',');

    if (this.regionales.length === 1 && this.regionales[0].length < 1) {
      this.getRegionales();
    }
    // this.regional = this.user.departamento;

    switch (this.user.id_rol) {
      case 6:
        // rol: Revisor Entidad
        this.filters[this.filters.length - 1].items = [{ value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }];
        break;
      case 7:
        // rol: Firmador Entidad
        this.filters[this.filters.length - 1].items = [{ value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }];
        break;
      case 3:
        // rol: Revisor Cancilleria
        this.filters[this.filters.length - 1].items = [{ value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }];
        break;
      case 4:
        // rol: Firmador Cancilleria
        this.filters[this.filters.length - 1].items = [{ value: 'APOSTILLADO', text: 'APOSTILLADO' }, { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }];
        break;
      default:
        this.filters[this.filters.length - 1].items = [{ value: 'CREADO', text: 'CREADO' }];
    }
    this.filters[this.filters.length - 2].value = this.departamento;
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'historial',
      headers: [{ text: this.$t('N° Trámite'), value: 'id' }, { text: this.$t('common.actions'), sortable: false }, { text: this.$t('tramite_doc.crud.estado'), value: 'estado' }, { text: this.$t('tramite_doc.crud.nro_apostilla'), value: 'nro_apostilla' }, { text: this.$t('tramite_doc.crud.cod_seguridad'), value: 'cod_seguridad' }, { text: this.$t('tramite_doc.crud.fecha_expedicion'), value: 'fecha_expedicion' }, { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'documento_nombre' }, { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' }, { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }, { text: this.$t('tramite_doc.crud.pago'), value: 'pago_entidad', sortable: true }],
      regionales: regionales,
      regional: '',
      dataGraphql: '\n        id\n        pago_entidad\n        pago_cancilleria\n        cod_seguridad\n        nro_apostilla\n        fecha_expedicion\n        estado\n        observacion\n        id_tramite\n        id_documento\n        id_archivo\n        documento_nombre\n        tramite_solicitante_nombres\n        tramite_solicitante_primer_apellido\n        tramite_solicitante_segundo_apellido\n        tramite_solicitante_nro_documento\n        tramite_solicitante_tipo_documento\n        tramite_solicitante_email\n        tramite_cod_seguimiento\n        _created_at\n      ',
      filters: [{
        field: 'id',
        label: 'Nro. de tramite',
        type: 'text',
        typeG: 'Int'
      }, {
        field: 'id_documento',
        label: this.$t('tramite_doc.crud.docName'),
        type: 'select',
        typeG: 'Int',
        items: []
      }, {
        field: 'cod_seguridad',
        label: this.$t('tramite_doc.crud.cod_seguridad'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'cod_seguimiento',
        label: 'Código de seguimiento',
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nro_apostilla',
        label: this.$t('tramite_doc.crud.nro_apostilla'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nro_documento',
        label: 'Nro. de documento solicitante',
        type: 'text',
        typeG: 'String'
      }, {
        field: 'nombre_completo',
        label: 'Nombre del solicitante',
        type: 'text',
        typeG: 'String'
      }, {
        field: 'departamento',
        label: 'Regional',
        type: 'hidden',
        typeG: 'String',
        value: ''
      }, {
        field: 'estado',
        label: this.$t('tramite_doc.crud.status'),
        type: 'select',
        typeG: 'EstadoTramiteDoc',
        items: []
      }],
      solicitud: null,
      estados: estados
    };
  },

  methods: {
    openDetalle: function openDetalle(item) {
      var _this = this;

      this.solicitud = null;
      this.$nextTick(function () {
        _this.solicitud = item;
        _this.$store.commit('openModal', 2);
      });
    },
    descargar: function descargar(item) {
      var _this2 = this;

      var url = item.estado === 'APOSTILLADO' ? this.$apiUrl + 'eregister/pdf-download_apostilla/' + item.id_archivo : this.$apiUrl + 'eregister/pdf-download/' + item.id_archivo;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({
        url: url,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$storage.get('token')
        },
        json: true,
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        var d = new Date();
        link.setAttribute('download', _this2.$store.state.user.usuario + d.getTime() + '.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        _this2.$message.error(error);
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a,
    Detalle: __WEBPACK_IMPORTED_MODULE_4__Detalle___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['modal2  ']), {
    title: function title() {
      var titulos = {
        '6': 'Historial de documentos revisados por la entidad',
        '7': 'Historial de documentos firmado por la entidad',
        '3': 'Historial de documentos revisado por la cancillería',
        '4': 'Historial de documentos apostillados'
      };
      if (titulos[this.user.id_rol]) {
        return titulos[this.user.id_rol];
      }
      return 'Historial';
    }
  }),
  watch: {
    '$store.state.modal2': function $storeStateModal2(val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    'regional': function regional(val) {
      if (val) {
        console.log('dep', val);
        this.filters[this.filters.length - 2].value = val;
        this.updateList();
      }
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__common_mixins_validate__["a" /* default */]],
  data: function data() {
    return {
      observacion: ''
    };
  },

  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Revisor__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Revisor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Revisor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmante__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Firmante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_usuario_mixins_usuario__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

var regionales = ['LA PAZ', 'COCHABAMBA', 'SANTA CRUZ'];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_admin_usuario_mixins_usuario__["a" /* default */]],
  created: function created() {
    this.$store.state.modal2 = false;
    this.$store.state.modal3 = false;
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.departamento = this.user.departamento;
    this.documentos = [];
    this.getDocumentos(1);

    this.regionales = this.user.departamento.split(',');

    if (this.regionales.length === 1 && this.regionales[0].length < 1) {
      this.getRegionales();
    }

    this.loadMaxFilesize();
    // this.regional = this.user.departamento;

    this.filters = [{
      field: 'id',
      label: 'Nro. de tramite',
      type: 'text',
      typeG: 'Int'
    }, {
      field: 'id_documento',
      label: this.$t('tramite_doc.crud.docName'),
      type: 'select',
      typeG: 'Int',
      items: []
    }, {
      field: 'cod_seguimiento',
      label: 'Código de seguimiento',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'nro_documento',
      label: 'Nro. de documento solicitante',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'nombre_completo',
      label: 'Nombre del solicitante',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'departamento',
      label: 'Regional',
      type: 'hidden',
      typeG: 'String',
      value: this.departamento

    }, {
      field: 'estado',
      label: this.$t('tramite_doc.crud.status'),
      type: 'select',
      typeG: 'EstadoTramiteDoc',
      items: [{ value: '', text: 'TODOS' }, { value: 'CREADO', text: 'CREADO' }, { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }, { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' }, { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' }, { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }, { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }, { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' }, { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }, { value: 'APOSTILLADO', text: 'APOSTILLADO' }]
    }];

    if ([6, 7, 3, 4].indexOf(this.user.id_rol) !== -1) {
      this.filters.push({
        field: 'no_estado',
        label: this.$t('tramite_doc.crud.status'),
        type: 'hidden',
        typeG: 'EstadoTramiteDoc',
        value: ''
      });

      switch (this.user.id_rol) {
        case 6:
          // rol: Revisor Entidad
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'CREADO', text: 'CREADO' }, { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' }, { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' }, { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' }];
          this.filters[this.filters.length - 1].value = 'REVISADO_ENTIDAD';
          break;
        case 7:
          // rol: Firmador Entidad
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }];
          this.filters[this.filters.length - 1].value = 'FIRMADO_ENTIDAD';
          break;
        case 3:
          // rol: Revisor Cancilleria
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }, { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }];
          this.filters[this.filters.length - 1].value = 'REVISADO_CANCILLERIA';
          break;
        case 4:
          // rol: Firmador Cancilleria
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }];
          this.filters[this.filters.length - 1].value = 'APOSTILLADO';
          break;
        default:
          this.filters[this.filters.length - 1].value = 'NINGUNO';
      }
    }
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'para_firma',
      firmador: false,
      headers_sin_pago: [{ text: 'N° Trámite', value: 'id' }, { text: this.$t('common.actions'), sortable: false }, { text: this.$t('tramite_doc.crud.estado'), value: 'estado' }, { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' }, { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' }, { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' }, { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }],
      headers_pago: [{ text: 'N° Trámite', value: 'id' }, { text: this.$t('common.actions'), sortable: false }, { text: this.$t('tramite_doc.crud.estado'), value: 'estado' }, { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' }, { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' }, { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' }, { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }, { text: this.$t('tramite_doc.crud.pago'), value: 'pago_entidad', sortable: true }],
      order: ['id', 'DESC'],
      regionales: regionales,
      regional: '',
      dataGraphql: '\n      id\n      pago_entidad\n      pago_cancilleria\n      cod_seguridad\n      nro_apostilla\n      fecha_expedicion\n      estado\n      observacion\n      firmante_documento_nombre\n      firmante_documento_cargo\n      firmante_documento_entidad\n      id_tramite\n      id_documento\n      id_archivo\n      documento_id_entidad\n      documento_nombre\n      documento_derivar\n      tramite_solicitante_nombres\n      tramite_solicitante_primer_apellido\n      tramite_solicitante_segundo_apellido\n      tramite_solicitante_nro_documento\n      tramite_solicitante_tipo_documento\n      tramite_solicitante_fecha_nacimiento\n      tramite_solicitante_email\n      tramite_cod_seguimiento\n      _created_at\n    ',
      filters: this.filters,
      tramite_doc: null,
      valid: true,
      solicitud: null,
      solicitudC: null,
      estados: estados,
      user: {}
    };
  },

  methods: {
    loadMaxFilesize: function loadMaxFilesize() {
      var _this = this;

      this.$service.graphql({
        query: '\n        query get {\n          parametroBuscar(name: "MAX_FILESIZE") {\n            valor\n          }\n        }\n      '
      }).then(function (response) {
        if (response) {
          _this.$store.commit('setMaxFilesize', parseInt(response.parametroBuscar.valor));
        }
      });
    },
    openRevisor: function openRevisor(item) {
      var _this2 = this;

      if (item.estado === 'FIRMADO_ENTIDAD' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get('eapostilla/mostrar_firmante/' + item.id_archivo).then(function (response) {
          item.firmante = response;
          _this2.solicitud = null;
          _this2.$nextTick(function () {
            _this2.solicitud = item;
            _this2.$store.commit('openModal', 2);
          });
        });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get('eapostilla/mostrar_firma/' + item.id_archivo).then(function (response) {
            item.firmante = response;
            _this2.solicitud = null;
            _this2.$nextTick(function () {
              _this2.solicitud = item;
              _this2.$store.commit('openModal', 2);
            });
          });
        } else {
          this.solicitud = null;
          this.$nextTick(function () {
            _this2.solicitud = item;
            _this2.$store.commit('openModal', 2);
          });
        }
      }
    },
    openFirmante: function openFirmante(item) {
      var _this3 = this;

      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
      if (item.estado === 'REVISADO_CANCILLERIA' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get('eapostilla/mostrar_firmante/' + item.id_archivo).then(function (response) {
          item.firmante = response;
          _this3.solicitudC = null;
          _this3.$nextTick(function () {
            _this3.solicitudC = item;
            _this3.$store.commit('openModal', 3);
          });
        });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get('eapostilla/mostrar_firma/' + item.id_archivo).then(function (response) {
            item.firmante = response;
            _this3.solicitudC = null;
            _this3.$nextTick(function () {
              _this3.solicitudC = item;
              _this3.$store.commit('openModal', 3);
            });
          });
        } else {
          this.solicitudC = null;
          this.$nextTick(function () {
            _this3.solicitudC = item;
            _this3.$store.commit('openModal', 3);
          });
        }
      }
    },
    openFirmanteGrupal: function openFirmanteGrupal() {
      var _this4 = this;

      if (this.$store.state.selected.length === 0) {
        this.$message.warning('Debe seleccionar por lo menos un documento para firmar.');
        return false;
      }
      this.firmador = false;
      this.$nextTick(function () {
        _this4.firmador = true;
        _this4.$store.commit('openModal', 7);
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a,
    Revisor: __WEBPACK_IMPORTED_MODULE_4__Revisor___default.a,
    Firmante: __WEBPACK_IMPORTED_MODULE_5__Firmante___default.a,
    Firmantegrupal: __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['modal2', 'modal3'])),
  watch: {
    '$store.state.modal2': function $storeStateModal2(val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    '$store.state.modal3': function $storeStateModal3(val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    'regional': function regional(val) {
      if (val) {
        console.log('dep', val);
        this.filters[5].value = val;
        this.updateList();
      }
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observar_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Observar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetalleDoc__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetalleDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DetalleDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_util_pdf_PdfView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_util_pdf_PdfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_util_pdf_PdfView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    solicitud: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      estados: estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true,
      pdfValido: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_tramite_doc__["a" /* default */]],
  created: function created() {
    this.$store.state.modal5 = false;

    // Cargando tramite
    if (this.solicitud) {
      this.getTramite(this.solicitud.id);
    }
  },

  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_0__common_util_FileUpload_vue___default.a,
    Observar: __WEBPACK_IMPORTED_MODULE_1__Observar_vue___default.a,
    DetalleDoc: __WEBPACK_IMPORTED_MODULE_3__DetalleDoc___default.a,
    PdfView: __WEBPACK_IMPORTED_MODULE_4__common_util_pdf_PdfView___default.a
  },
  methods: {
    validarPdf: function validarPdf(val) {
      if (val === false) this.pdfValido = false;else this.pdfValido = true;
    },
    openObservar: function openObservar(item) {
      this.solicitud = item;
      this.$store.commit('openModal', 5);
    },
    cambiarDoc: function cambiarDoc() {
      this.tramite.id_archivo = 1;
    },
    cancelarCambio: function cancelarCambio() {
      this.tramite.id_archivo = this.$store.state.archivo;
    },
    aprobarEntidad: function aprobarEntidad(solicitud) {
      if (this.$filter.empty(this.$store.state.date.fecha_inicio)) {
        this.$message.warning('Ingrese la <strong>fecha de inicio</strong> de la vigencia del documento');
        return false;
      }
      if (this.$filter.empty(this.$store.state.date.fecha_fin)) {
        this.$message.warning('Ingrese la <strong>fecha final</strong> de la vigencia del documento');
        return false;
      }
      if (this.$datetime.diff(this.$store.state.date.fecha_fin, this.$store.state.date.fecha_inicio) < 0) {
        this.$message.warning('<strong>Validez del documento</strong>.- La fecha final debe ser mayor a la fecha de inicio');
        return false;
      }
      // this.generarCpt(solicitud, 'ENTIDAD', () => { // La entidad ya no realizará el pago mediante la plataforma de pagos.
      this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_ENTIDAD');
      // });
    },
    aprobarCancilleria: function aprobarCancilleria(solicitud) {
      /* if (!solicitud.pago_cancilleria) {
        this.$message.warning('Antes de enviar para firma, el trámite debe haber sido pagado');
        return false;
      } */

      if (solicitud.firmante_documento_nombre && solicitud.firmante_documento_cargo && solicitud.firmante_documento_entidad) {
        this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_CANCILLERIA');
      } else {
        this.$message.warning('Debe ingresar todos los datos del Firmante del Documento');
      }
    },
    generarCptCancilleria: function generarCptCancilleria(solicitud) {
      this.generarCpt(solicitud, 'CANCILLERIA', function () {
        // this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_CANCILLERIA');
      });
    },
    cerrar_ventana: function cerrar_ventana() {
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function $storeStateArchivo(val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Revisor__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Revisor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Revisor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmante__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Firmante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_usuario_mixins_usuario__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

var regionales = ['LA PAZ', 'COCHABAMBA', 'SANTA CRUZ'];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_tramite_doc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_admin_usuario_mixins_usuario__["a" /* default */]],
  created: function created() {
    this.$store.state.modal2 = false;
    this.$store.state.modal3 = false;
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.departamento = this.user.departamento;
    this.documentos = [];
    this.getDocumentos(1);
    this.regionales = this.user.departamento.split(',');

    if (this.regionales.length === 1 && this.regionales[0].length < 1) {
      this.getRegionales();
    }

    this.loadMaxFilesize();
    // this.regional = this.user.departamento;

    this.filters = [{
      field: 'id',
      label: 'Nro. de tramite',
      type: 'text',
      typeG: 'Int'
    }, {
      field: 'id_documento',
      label: this.$t('tramite_doc.crud.docName'),
      type: 'select',
      typeG: 'Int',
      items: []
    }, {
      field: 'cod_seguimiento',
      label: 'Código de seguimiento',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'nro_documento',
      label: 'Nro. de documento solicitante',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'nombre_completo',
      label: 'Nombre del solicitante',
      type: 'text',
      typeG: 'String'
    }, {
      field: 'departamento',
      label: 'Regional',
      type: 'hidden',
      typeG: 'String',
      value: this.departamento

    }, {
      field: 'estado',
      label: this.$t('tramite_doc.crud.status'),
      type: 'select',
      typeG: 'EstadoTramiteDoc',
      items: [{ value: '', text: 'TODOS' }, { value: 'CREADO', text: 'CREADO' }, { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }, { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' }, { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' }, { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }, { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }, { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' }, { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }, { value: 'APOSTILLADO', text: 'APOSTILLADO' }]
    }];

    if ([6, 7, 3, 4].indexOf(this.user.id_rol) !== -1) {
      this.filters.push({
        field: 'no_estado',
        label: this.$t('tramite_doc.crud.status'),
        type: 'hidden',
        typeG: 'EstadoTramiteDoc',
        value: ''
      });

      switch (this.user.id_rol) {
        case 6:
          // rol: Revisor Entidad
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'CREADO', text: 'CREADO' }, { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' }, { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' }, { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' }];
          this.filters[this.filters.length - 1].value = 'REVISADO_ENTIDAD';
          break;
        case 7:
          // rol: Firmador Entidad
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }];
          this.filters[this.filters.length - 1].value = 'FIRMADO_ENTIDAD';
          break;
        case 3:
          // rol: Revisor Cancilleria
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }, { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }];
          this.filters[this.filters.length - 1].value = 'REVISADO_CANCILLERIA';
          break;
        case 4:
          // rol: Firmador Cancilleria
          this.filters[this.filters.length - 2].items = [{ value: '', text: 'TODOS' }, { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }];
          this.filters[this.filters.length - 1].value = 'APOSTILLADO';
          break;
        default:
          this.filters[this.filters.length - 1].value = 'NINGUNO';
      }
    }
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'tramiteDocs',
      firmador: false,
      headers_sin_pago: [{ text: 'N° Trámite', value: 'id' }, { text: this.$t('common.actions'), sortable: false }, { text: this.$t('tramite_doc.crud.estado'), value: 'estado' }, { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' }, { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' }, { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' }, { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }],
      headers_pago: [{ text: 'N° Trámite', value: 'id' }, { text: this.$t('common.actions'), sortable: false }, { text: this.$t('tramite_doc.crud.estado'), value: 'estado' }, { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' }, { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' }, { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' }, { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }, { text: this.$t('tramite_doc.crud.pago'), value: 'pago_entidad', sortable: true }],
      order: ['id', 'DESC'],
      regionales: regionales,
      regional: '',
      dataGraphql: '\n        id\n        pago_entidad\n        pago_cancilleria\n        cod_seguridad\n        nro_apostilla\n        fecha_expedicion\n        estado\n        observacion\n        firmante_documento_nombre\n        firmante_documento_cargo\n        firmante_documento_entidad\n        id_tramite\n        id_documento\n        id_archivo\n        documento_id_entidad\n        documento_nombre\n        documento_derivar\n        tramite_solicitante_nombres\n        tramite_solicitante_primer_apellido\n        tramite_solicitante_segundo_apellido\n        tramite_solicitante_nro_documento\n        tramite_solicitante_tipo_documento\n        tramite_solicitante_fecha_nacimiento\n        tramite_solicitante_email\n        _created_at\n        tramite_cod_seguimiento\n      ',
      filters: this.filters,
      tramite_doc: null,
      valid: true,
      solicitud: null,
      solicitudC: null,
      estados: estados,
      user: {}
    };
  },

  methods: {
    loadMaxFilesize: function loadMaxFilesize() {
      var _this = this;

      this.$service.graphql({
        query: '\n          query get {\n            parametroBuscar(name: "MAX_FILESIZE") {\n              valor\n            }\n          }\n        '
      }).then(function (response) {
        if (response) {
          _this.$store.commit('setMaxFilesize', parseInt(response.parametroBuscar.valor));
        }
      });
    },
    openRevisor: function openRevisor(item) {
      var _this2 = this;

      if (item.estado === 'FIRMADO_ENTIDAD' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get('eapostilla/mostrar_firmante/' + item.id_archivo).then(function (response) {
          item.firmante = response;
          _this2.solicitud = null;
          _this2.$nextTick(function () {
            _this2.solicitud = item;
            _this2.$store.commit('openModal', 2);
          });
        });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get('eapostilla/mostrar_firma/' + item.id_archivo).then(function (response) {
            item.firmante = response;
            _this2.solicitud = null;
            _this2.$nextTick(function () {
              _this2.solicitud = item;
              _this2.$store.commit('openModal', 2);
            });
          });
        } else {
          this.solicitud = null;
          this.$nextTick(function () {
            _this2.solicitud = item;
            _this2.$store.commit('openModal', 2);
          });
        }
      }
    },
    openFirmante: function openFirmante(item) {
      var _this3 = this;

      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
      if (item.estado === 'REVISADO_CANCILLERIA' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get('eapostilla/mostrar_firmante/' + item.id_archivo).then(function (response) {
          item.firmante = response;
          _this3.solicitudC = null;
          _this3.$nextTick(function () {
            _this3.solicitudC = item;
            _this3.$store.commit('openModal', 3);
          });
        });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get('eapostilla/mostrar_firma/' + item.id_archivo).then(function (response) {
            item.firmante = response;
            _this3.solicitudC = null;
            _this3.$nextTick(function () {
              _this3.solicitudC = item;
              _this3.$store.commit('openModal', 3);
            });
          });
        } else {
          this.solicitudC = null;
          this.$nextTick(function () {
            _this3.solicitudC = item;
            _this3.$store.commit('openModal', 3);
          });
        }
      }
    },
    openFirmanteGrupal: function openFirmanteGrupal() {
      var _this4 = this;

      if (this.$store.state.selected.length === 0) {
        this.$message.warning('Debe seleccionar por lo menos un documento para firmar.');
        return false;
      }
      this.firmador = false;
      this.$nextTick(function () {
        _this4.firmador = true;
        _this4.$store.commit('openModal', 7);
      });
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_1__common_util_crud_table_CrudTable_vue___default.a,
    Revisor: __WEBPACK_IMPORTED_MODULE_4__Revisor___default.a,
    Firmante: __WEBPACK_IMPORTED_MODULE_5__Firmante___default.a,
    Firmantegrupal: __WEBPACK_IMPORTED_MODULE_6__FirmanteGrupal___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['modal2', 'modal3'])),
  watch: {
    '$store.state.modal2': function $storeStateModal2(val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    '$store.state.modal3': function $storeStateModal3(val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    'regional': function regional(val) {
      if (val) {
        console.log('dep', val);
        this.filters[5].value = val;
        this.updateList();
      }
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_crud_table_mixins_crud_table__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_tramite__ = __webpack_require__(295);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_util_crud_table_mixins_crud_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__common_mixins_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_tramite__["a" /* default */]],
  created: function created() {
    this.user = this.$storage.getUser();
    this.idTramite = this.user.id_tramite;
    this.solicitantes = [];
    this.getSolicitantes(4);
  },
  data: function data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'tramites',
      headers: [{ text: this.$t('transact.crud.init_date'), value: 'fecha_inicio' }, { text: this.$t('transact.crud.end_date'), value: 'fecha_fin' }, { text: this.$t('transact.crud.cod_tracking'), value: 'cod_seguimiento' }, { text: this.$t('transact.crud.solicitante'), value: 'solicitante_nombres solicitante_primer_apellido solicitante_segundo_apellido' }, { text: this.$t('common.status'), value: 'estado' }],
      form: {
        cod_seguimiento: '',
        id_solicitante: ''
      },
      dataGraphql: '\n        id\n        fecha_inicio\n        fecha_fin\n        estado\n        cod_seguimiento\n        id_solicitante\n        solicitante_nombres\n        solicitante_primer_apellido\n        solicitante_segundo_apellido\n      ',
      filters: [{
        field: 'id_solicitante',
        label: this.$t('transact.crud.solicitante'),
        type: 'text',
        typeG: 'Int'
      }, {
        field: 'cod_seguimiento',
        label: this.$t('transact.crud.cod_tracking'),
        type: 'text',
        typeG: 'String'
      }, {
        field: 'estado',
        label: this.$t('transact.crud.status'),
        type: 'select',
        typeG: 'EstadoTramite',
        items: [{ value: '', text: 'TODOS' }, { value: 'SOLICITADO', text: 'SOLICITADO' }, { value: 'EN_PROCESO', text: 'EN PROCESO' }, { value: 'FINALIZADO', text: 'FINALIZADO' }]
      }],
      idTramite: null,
      valid: true
    };
  },

  methods: {
    openModal: function openModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$refs.form.reset();
      if (data.id) {
        data.telefonos = data.telefonos.split(',');
        this.form = data;
      } else {
        this.form = {
          nombre: '',
          sigla: '',
          descripcion: '',
          email: '',
          web: '',
          direccion: '',
          telefonos: [],
          estado: ''
        };
      }
      this.$store.commit('openModal');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.form);

        if (data.id_solicitante.value) {
          data.id_solicitante = data.id_solicitante.value;
        }

        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: '\n              mutation edit($id: Int!, $tramite: EditTramite!) {\n                tramiteEdit(id: $id, tramite: $tramite) {\n                  id\n                }\n              }\n            ',
            variables: {
              id: this.form.id,
              tramite: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          data.fecha_inicio = new Date();
          this.$service.graphql({
            query: '\n              mutation add($tramite: NewTramite!) {\n                tramiteAdd(tramite: $tramite) {\n                  id\n                }\n              }\n            ',
            variables: {
              tramite: data
            }
          }).then(function (response) {
            if (response) {
              _this.$store.commit('closeModal');
              _this.updateList();
              _this.$message.success();
            }
          });
        }
      }
    },
    remove: function remove(item) {
      this.form.telefonos.splice(this.form.telefonos.indexOf(item), 1);
      this.form.telefonos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.form.telefonos));
    }
  },
  components: {
    CrudTable: __WEBPACK_IMPORTED_MODULE_2__common_util_crud_table_CrudTable_vue___default.a
  }
});

/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 110,
	"./af.js": 110,
	"./ar": 117,
	"./ar-dz": 111,
	"./ar-dz.js": 111,
	"./ar-kw": 112,
	"./ar-kw.js": 112,
	"./ar-ly": 113,
	"./ar-ly.js": 113,
	"./ar-ma": 114,
	"./ar-ma.js": 114,
	"./ar-sa": 115,
	"./ar-sa.js": 115,
	"./ar-tn": 116,
	"./ar-tn.js": 116,
	"./ar.js": 117,
	"./az": 118,
	"./az.js": 118,
	"./be": 119,
	"./be.js": 119,
	"./bg": 120,
	"./bg.js": 120,
	"./bm": 121,
	"./bm.js": 121,
	"./bn": 122,
	"./bn.js": 122,
	"./bo": 123,
	"./bo.js": 123,
	"./br": 124,
	"./br.js": 124,
	"./bs": 125,
	"./bs.js": 125,
	"./ca": 126,
	"./ca.js": 126,
	"./cs": 127,
	"./cs.js": 127,
	"./cv": 128,
	"./cv.js": 128,
	"./cy": 129,
	"./cy.js": 129,
	"./da": 130,
	"./da.js": 130,
	"./de": 133,
	"./de-at": 131,
	"./de-at.js": 131,
	"./de-ch": 132,
	"./de-ch.js": 132,
	"./de.js": 133,
	"./dv": 134,
	"./dv.js": 134,
	"./el": 135,
	"./el.js": 135,
	"./en-SG": 136,
	"./en-SG.js": 136,
	"./en-au": 137,
	"./en-au.js": 137,
	"./en-ca": 138,
	"./en-ca.js": 138,
	"./en-gb": 139,
	"./en-gb.js": 139,
	"./en-ie": 140,
	"./en-ie.js": 140,
	"./en-il": 141,
	"./en-il.js": 141,
	"./en-nz": 142,
	"./en-nz.js": 142,
	"./eo": 143,
	"./eo.js": 143,
	"./es": 146,
	"./es-do": 144,
	"./es-do.js": 144,
	"./es-us": 145,
	"./es-us.js": 145,
	"./es.js": 146,
	"./et": 147,
	"./et.js": 147,
	"./eu": 148,
	"./eu.js": 148,
	"./fa": 149,
	"./fa.js": 149,
	"./fi": 150,
	"./fi.js": 150,
	"./fo": 151,
	"./fo.js": 151,
	"./fr": 154,
	"./fr-ca": 152,
	"./fr-ca.js": 152,
	"./fr-ch": 153,
	"./fr-ch.js": 153,
	"./fr.js": 154,
	"./fy": 155,
	"./fy.js": 155,
	"./ga": 156,
	"./ga.js": 156,
	"./gd": 157,
	"./gd.js": 157,
	"./gl": 158,
	"./gl.js": 158,
	"./gom-latn": 159,
	"./gom-latn.js": 159,
	"./gu": 160,
	"./gu.js": 160,
	"./he": 161,
	"./he.js": 161,
	"./hi": 162,
	"./hi.js": 162,
	"./hr": 163,
	"./hr.js": 163,
	"./hu": 164,
	"./hu.js": 164,
	"./hy-am": 165,
	"./hy-am.js": 165,
	"./id": 166,
	"./id.js": 166,
	"./is": 167,
	"./is.js": 167,
	"./it": 169,
	"./it-ch": 168,
	"./it-ch.js": 168,
	"./it.js": 169,
	"./ja": 170,
	"./ja.js": 170,
	"./jv": 171,
	"./jv.js": 171,
	"./ka": 172,
	"./ka.js": 172,
	"./kk": 173,
	"./kk.js": 173,
	"./km": 174,
	"./km.js": 174,
	"./kn": 175,
	"./kn.js": 175,
	"./ko": 176,
	"./ko.js": 176,
	"./ku": 177,
	"./ku.js": 177,
	"./ky": 178,
	"./ky.js": 178,
	"./lb": 179,
	"./lb.js": 179,
	"./lo": 180,
	"./lo.js": 180,
	"./lt": 181,
	"./lt.js": 181,
	"./lv": 182,
	"./lv.js": 182,
	"./me": 183,
	"./me.js": 183,
	"./mi": 184,
	"./mi.js": 184,
	"./mk": 185,
	"./mk.js": 185,
	"./ml": 186,
	"./ml.js": 186,
	"./mn": 187,
	"./mn.js": 187,
	"./mr": 188,
	"./mr.js": 188,
	"./ms": 190,
	"./ms-my": 189,
	"./ms-my.js": 189,
	"./ms.js": 190,
	"./mt": 191,
	"./mt.js": 191,
	"./my": 192,
	"./my.js": 192,
	"./nb": 193,
	"./nb.js": 193,
	"./ne": 194,
	"./ne.js": 194,
	"./nl": 196,
	"./nl-be": 195,
	"./nl-be.js": 195,
	"./nl.js": 196,
	"./nn": 197,
	"./nn.js": 197,
	"./pa-in": 198,
	"./pa-in.js": 198,
	"./pl": 199,
	"./pl.js": 199,
	"./pt": 201,
	"./pt-br": 200,
	"./pt-br.js": 200,
	"./pt.js": 201,
	"./ro": 202,
	"./ro.js": 202,
	"./ru": 203,
	"./ru.js": 203,
	"./sd": 204,
	"./sd.js": 204,
	"./se": 205,
	"./se.js": 205,
	"./si": 206,
	"./si.js": 206,
	"./sk": 207,
	"./sk.js": 207,
	"./sl": 208,
	"./sl.js": 208,
	"./sq": 209,
	"./sq.js": 209,
	"./sr": 211,
	"./sr-cyrl": 210,
	"./sr-cyrl.js": 210,
	"./sr.js": 211,
	"./ss": 212,
	"./ss.js": 212,
	"./sv": 213,
	"./sv.js": 213,
	"./sw": 214,
	"./sw.js": 214,
	"./ta": 215,
	"./ta.js": 215,
	"./te": 216,
	"./te.js": 216,
	"./tet": 217,
	"./tet.js": 217,
	"./tg": 218,
	"./tg.js": 218,
	"./th": 219,
	"./th.js": 219,
	"./tl-ph": 220,
	"./tl-ph.js": 220,
	"./tlh": 221,
	"./tlh.js": 221,
	"./tr": 222,
	"./tr.js": 222,
	"./tzl": 223,
	"./tzl.js": 223,
	"./tzm": 225,
	"./tzm-latn": 224,
	"./tzm-latn.js": 224,
	"./tzm.js": 225,
	"./ug-cn": 226,
	"./ug-cn.js": 226,
	"./uk": 227,
	"./uk.js": 227,
	"./ur": 228,
	"./ur.js": 228,
	"./uz": 230,
	"./uz-latn": 229,
	"./uz-latn.js": 229,
	"./uz.js": 230,
	"./vi": 231,
	"./vi.js": 231,
	"./x-pseudo": 232,
	"./x-pseudo.js": 232,
	"./yo": 233,
	"./yo.js": 233,
	"./zh-cn": 234,
	"./zh-cn.js": 234,
	"./zh-hk": 235,
	"./zh-hk.js": 235,
	"./zh-tw": 236,
	"./zh-tw.js": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 426;

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(494),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(511),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(503),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(518),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(509),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(505),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(524),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(520),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf-view"
  }, [_c('div', {
    staticClass: "pdf-view-actions"
  }, [_c('div', {
    staticClass: "pdf-view-page"
  }, [_c('span', [_vm._v("Página: "), _c('span', [_vm._v(_vm._s(_vm.page_num))]), _vm._v(" / "), _c('span', [_vm._v(" " + _vm._s(_vm.page_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "pdf-view-buttons"
  }, [_c('v-btn', {
    attrs: {
      "type": "button",
      "disabled": _vm.page_num == 1
    },
    on: {
      "click": _vm.onPrevPage
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Anterior")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "button",
      "disabled": _vm.page_num == _vm.page_count
    },
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("Siguiente "), _c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.descargar(_vm.url)
      }
    }
  }, [_c('v-icon', [_vm._v("file_download")]), _vm._v(" Descargar\n      ")], 1)], 1)]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v("Cargando PDF espere por favor...")])])
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('documento.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function(props) {
        return [_c('v-card-title', {
          staticClass: "headline"
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.form.id ? 'folder' : 'create_new_folder'))]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('documento.crud.editDocumento') : _vm.$t('documento.crud.addDocumento')) + "\n            "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal')
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
          ref: "form",
          attrs: {
            "lazy-validation": ""
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.save($event)
            }
          },
          model: {
            value: (_vm.valid),
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        }, [_c('v-card-text', [_c('v-container', {
          attrs: {
            "grid-list-md": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.entidades,
            "label": "Entidad",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_entidad),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_entidad", $$v)
            },
            expression: "form.id_entidad"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.derivar_opciones,
            "label": "Derivar a:",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.derivar),
            callback: function($$v) {
              _vm.$set(_vm.form, "derivar", $$v)
            },
            expression: "form.derivar"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.nombre),
            callback: function($$v) {
              _vm.$set(_vm.form, "nombre", $$v)
            },
            expression: "form.nombre"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Código portal",
            "maxlength": "50"
          },
          model: {
            value: (_vm.form.codigo_portal),
            callback: function($$v) {
              _vm.$set(_vm.form, "codigo_portal", $$v)
            },
            expression: "form.codigo_portal"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Descripcion",
            "maxlength": "500",
            "multi-line": "",
            "counter": 500
          },
          model: {
            value: (_vm.form.descripcion),
            callback: function($$v) {
              _vm.$set(_vm.form, "descripcion", $$v)
            },
            expression: "form.descripcion"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Duración del trámite en días",
            "maxlength": "10"
          },
          model: {
            value: (_vm.form.duracion),
            callback: function($$v) {
              _vm.$set(_vm.form, "duracion", $$v)
            },
            expression: "form.duracion"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('h5', [_vm._v("Información de pago")]), _vm._v(" "), _c('ul', {
          staticClass: "no-style"
        }, [_vm._l((_vm.form.monto), function(item, index) {
          return [_c('li', [_c('strong', [_vm._v("Nro. de Cuenta:")]), _vm._v(" " + _vm._s(item.cuenta) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Monto:")]), _vm._v(" Bs. " + _vm._s(item.monto) + "\n                        ")])]
        })], 2)])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
          staticClass: "error--text text-required"
        }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal');
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "type": "submit"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')))], 1)], 1)], 1)]
      }
    }, {
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'documento', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Regenerar Token")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['documentos:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'documento')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.documento !== items.item.documento) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'documento', 'EditDocumento')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.documento === items.item.documento) ? _c('router-link', {
          attrs: {
            "slot": "activator",
            "to": "/account"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("file")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Este documento soy yo, clic aquí para ir a mi cuenta.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.codigo_portal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.entidad_nombre))]), _vm._v(" "), _c('td', [(items.item.derivar == 'ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n            " + _vm._s(items.item.derivar) + "\n          ")]) : _vm._e(), _vm._v(" "), (items.item.derivar == 'CANCILLERIA') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.derivar) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-md-right"
        }, [_vm._v(_vm._s(items.item.precio))]), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['documentos:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openDocs()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Agregar documento")])], 1) : _vm._e()], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.$store.state.modal3),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal3", $$v)
      },
      expression: "$store.state.modal3"
    }
  }, [(_vm.mydocs) ? _c('add-docs', {
    attrs: {
      "mydocs": _vm.mydocs
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.$store.state.modal4),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal4", $$v)
      },
      expression: "$store.state.modal4"
    }
  }, [(_vm.doc) ? _c('regenerar', {
    attrs: {
      "doc": _vm.doc
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "320"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [_c('login-ppte')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('log.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "order": _vm.order,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [(items.item.nivel == 'ERROR') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "error",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.nivel) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.nivel == 'ADVERTENCIA') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.nivel) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.nivel == 'INFO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.nivel) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.mensaje))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.referencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha, 'dd/MM/YYYY hrs. HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.usuario_usuario))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section')
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Observar documento\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "label": "Observacion",
      "maxlength": "500",
      "multi-line": "",
      "counter": 500,
      "rules": _vm.$validate(['required'])
    },
    model: {
      value: (_vm.observacion),
      callback: function($$v) {
        _vm.observacion = $$v
      },
      expression: "observacion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\n      ")], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 3) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_CANCILLERIA_REVISOR', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 6) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_ENTIDAD_REVISOR', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_CANCILLERIA_FIRMANTE', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 3);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 7) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_ENTIDAD_FIRMANTE', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 3);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-toaster"
  }, [_c('transition-group', {
    attrs: {
      "name": "v-toast"
    }
  }, _vm._l((_vm.items), function(t) {
    var _obj;

    return _c('div', {
      key: t.key,
      staticClass: "v-toast",
      class: ( _obj = {}, _obj[t.theme] = t.theme, _obj )
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "message-header",
      attrs: {
        "sm12": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v(_vm._s(t.icon))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(t.title))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(t)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "message-body",
      attrs: {
        "sm12": ""
      },
      domProps: {
        "innerHTML": _vm._s(t.message)
      }
    })], 1)], 1)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detalle-doc"
  }, [(_vm.solicitud) ? _c('v-expansion-panel', {
    attrs: {
      "popout": ""
    }
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3)) ? _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del firmante del documento ")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_c('v-card-text', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_nombre",
      "label": "Ha sido firmado por:",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_nombre),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_nombre", $$v)
      },
      expression: "solicitud.firmante_documento_nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_cargo",
      "label": "Quien actúa en calidad de:",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_cargo),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_cargo", $$v)
      },
      expression: "solicitud.firmante_documento_cargo"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_entidad",
      "label": "Está revestido del sello/timbre",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_entidad),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_entidad", $$v)
      },
      expression: "solicitud.firmante_documento_entidad"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 3) ? _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Departamento donde se enviara el documento para firma")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.solicitud.departamento),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "departamento", $$v)
      },
      expression: "solicitud.departamento"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Vigencia del documento")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('h5', {
    staticClass: "documento-validez"
  }, [_vm._v("El documento tiene "), _c('strong', [_vm._v(" " + _vm._s(Math.abs(Math.floor((_vm.solicitud.fecha_inicio -
    _vm.solicitud.fecha_fin) / 86400000))) + " " + _vm._s(Math.abs(Math.floor((_vm.solicitud.fecha_fin - _vm.solicitud.fecha_inicio) / 86400000)) <= 1 ? 'día' : 'días'))]), _vm._v(" de vigencia.")]), _vm._v(" "), (_vm.solicitud.fecha_inicio_show) ? _c('select-date', {
    attrs: {
      "model": "fecha_inicio",
      "value": _vm.solicitud.fecha_inicio,
      "disabled": _vm.isDisabled,
      "required": true,
      "label": "Valido desde el"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.solicitud.fecha_fin_show) ? _c('select-date', {
    attrs: {
      "model": "fecha_fin",
      "value": _vm.solicitud.fecha_fin,
      "disabled": _vm.isDisabled,
      "required": true,
      "label": "Hasta el"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del documento")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('h4', {
    staticClass: "margin-0"
  }, [_vm._v(_vm._s(_vm.solicitud.documento_nombre) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.solicitud.documento_descripcion) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.solicitud.documento_entidad_nombre))])]), _vm._v(" "), (_vm.solicitud.observacion) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "value": "true"
    }
  }, [_c('strong', [_vm._v("Observación.-")]), _vm._v(" " + _vm._s(_vm.solicitud.observacion) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Número de apostilla:")]), _vm._v(" " + _vm._s(_vm.solicitud.nro_apostilla || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Código de seguridad:")]), _vm._v(" " + _vm._s(_vm.solicitud.cod_seguridad || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de expedición:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.fecha_expedicion) || 'Pendiente') + "\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del solicitante")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Nombre completo:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_nombres) + " " + _vm._s(_vm.solicitud.tramite_solicitante_primer_apellido) + " " + _vm._s(_vm.solicitud.tramite_solicitante_segundo_apellido) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.solicitud.tramite_solicitante_tipo_documento) + ":")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_nro_documento) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de nacimiento:")]), _vm._v(" " + _vm._s(_vm.formato_fecha(_vm.solicitud.tramite_solicitante_fecha_nacimiento)) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_email) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Teléfono:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_telefono) + "\n        ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos de la solicitud")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Código de seguimiento:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_cod_seguimiento) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de solicitud:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.tramite_fecha_inicio)) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de culminación:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.tramite_fecha_fin) || 'Pendiente')), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Tipo de apostilla: ")]), _vm._v(" "), (_vm.solicitud.digital) ? _c('span', [_vm._v("Digital")]) : _c('span', [_vm._v("Física")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento: ")]), _vm._v(" " + _vm._s(_vm.solicitud.departamento)), _c('br'), _vm._v(" "), _vm._l((_vm.solicitud.otros), function(value, key) {
    return _c('span', [(value.nombre) ? _c('strong', [_vm._v(_vm._s(value.nombre) + ": ")]) : _vm._e(), (value.value) ? _c('span', [_vm._v(_vm._s(value.value))]) : _vm._e(), _c('br')])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Pagos")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_vm._l((_vm.pagos), function(item, index) {
    return [_c('v-card-text', [_c('h5', {
      staticClass: "primary--text"
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("monetization_on")]), _vm._v("\n              PAGO " + _vm._s(item.tipo) + "\n            ")], 1), _vm._v(" "), _c('strong', [_vm._v("CPT:")]), _vm._v(" "), (item.cpt) ? _c('span', [_vm._v(_vm._s(item.cpt.cpt))]) : _c('span', [_vm._v("Pendiente de generarse")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de pago:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(item.fecha_pago) || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Estado:")]), _vm._v(" " + _vm._s(item.estado) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Titular del pago:")]), _vm._v(" " + _vm._s(item.titular_factura) + " -\n            "), _c('strong', [_vm._v(_vm._s(item.tipo_documento) + ":")]), _vm._v(" " + _vm._s(item.nro_documento) + "\n          ")]), _vm._v(" "), (index + 1 < _vm.pagos.length) ? _c('v-divider') : _vm._e()]
  })], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" Solicitudes de trámites revisadas")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 4 ? _vm.headers_pago : _vm.headers_sin_pago,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800,
      "checkbox": _vm.$store.state.user.id_rol === 7,
      "showFilter": true
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v("\n            " + _vm._s(items.item.id) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 6) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openRevisor(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFirmante(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(items.item.documento_derivar === 'CANCILLERIA' && items.item.estado === 'FIRMADO_ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v("CREADO - CANCILLERIA")])]) : _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v(_vm._s(items.item.estado.replace(/_/gi, ' ')))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tramite_cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.documento_nombre))]), _vm._v(" "), _c('td', [_c('em', [_c('strong', [_vm._v(_vm._s(items.item.tramite_solicitante_tipo_documento) + ": ")]), _vm._v("\n              " + _vm._s(items.item.tramite_solicitante_nro_documento))]), _c('br'), _vm._v("\n            " + _vm._s(items.item.tramite_solicitante_nombres) + "\n            " + _vm._s(items.item.tramite_solicitante_primer_apellido) + "\n            " + _vm._s(items.item.tramite_solicitante_segundo_apellido) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at)))]), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) ? _c('td', {
          staticClass: "text-xs-center"
        }, [(items.item.pago_entidad || items.item.pago_cancilleria) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.user.id_rol === 7) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openFirmanteGrupal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Firmar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Firmar documentos seleccionados")])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "labels"
  }, [(this.regionales.length > 1) ? _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.regional),
      callback: function($$v) {
        _vm.regional = $$v
      },
      expression: "regional"
    }
  })], 1) : _c('div', {
    staticClass: "text-xs-right"
  }, [_c('strong', [_vm._v("REGIONAL:")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": "info",
      "text-color": "white"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.departamento.split(',').join(' - ')) + "\n            ")])], 1)])], 2)], 1)], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.solicitud) ? _c('revisor', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal3),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal3", $$v)
      },
      expression: "$store.state.modal3"
    }
  }, [(_vm.solicitudC) ? _c('firmante', {
    attrs: {
      "solicitud": _vm.solicitudC
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal7),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal7", $$v)
      },
      expression: "$store.state.modal7"
    }
  }, [(_vm.firmador) ? _c('Firmantegrupal', {
    attrs: {
      "solicitud": _vm.solicitudC,
      "persistent": "",
      "scrollable": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload"
  }, [_c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.vdropzoneSuccess,
      "vdropzone-error": _vm.vdropzoneError
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("vpn_key")]), _vm._v(" Regenerar token\r\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 4)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('h5', [_c('strong', [_vm._v("Trámite: ")]), _vm._v(_vm._s(_vm.doc.documento.nombre))]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n      Se regenerará el Token del trámite para que pueda realizar pagos en la "), _c('strong', [_vm._v("Plataforma de pagos")]), _vm._v(".\r\n    ")]), _vm._v(" "), (_vm.showUsuariosApp) ? _c('div', [(_vm.doc.usuariosApp.length > 1) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos\r\n      ")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.doc.usuariosApp,
      "label": "Aplicación en la Plataforma de pago",
      "item-text": "endpoint",
      "item-value": "id_usuario_app",
      "readonly": _vm.doc.usuariosApp.length == 1,
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.usuarioapp),
      callback: function($$v) {
        _vm.usuarioapp = $$v
      },
      expression: "usuarioapp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showUsuariosApp && _vm.documento) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": true
    }
  }, [_vm._v("\r\n      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos\r\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 4)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\r\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.show || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.obtainTokenForDocument()
      }
    }
  }, [_c('v-icon', [_vm._v("check_circle")]), _vm._v(" Regenerar token\r\n    ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      'app-login': !_vm.auth
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.auth && _vm.sidenav) ? _c('app-sidenav') : _vm._e(), _vm._v(" "), (_vm.auth) ? _c('app-navbar') : _vm._e(), _vm._v(" "), (_vm.main) ? _c('v-content', [(_vm.auth) ? _c('app-breadcrumbs') : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('app-messages'), _vm._v(" "), _c('app-alert'), _vm._v(" "), _c('app-confirm'), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('app-loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n      "), _c('div', {
    staticClass: "tramite-estado"
  }, [_c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "demofi-container"
  }, [(_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('demofi', {
    attrs: {
      "solicitud": _vm.tramite,
      "on-success": _vm.cambiarEstado
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "red",
      "icon": "error",
      "value": true
    }
  }, [_vm._v("\n              No existe documento para firmar\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.tramite) ? _c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n                " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n              ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo > 1 && this.$store.state.user.id_rol === 7),
      expression: "tramite.id_archivo > 1 && this.$store.state.user.id_rol === 7"
    }],
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cambiarDoc()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_horiz")]), _vm._v("\n                Cambiar\n              ")], 1), _vm._v(" "), _c('span', [_vm._v("Cambiar por otro documento")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo == 1 && _vm.$store.state.archivo > 1 && this.$store.state.user.id_rol === 7),
      expression: "tramite.id_archivo == 1 && $store.state.archivo > 1 && this.$store.state.user.id_rol === 7"
    }],
    staticClass: "margin-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelarCambio()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v("\n              Cancelar cambio\n            ")], 1), _vm._v(" "), (_vm.$store.state.permissions['tramitesDoc:update']) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openObservar(_vm.solicitud)
      }
    }
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.$t('common.observation')) + "\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['firmas:create'] && _vm.pdf !== null && _vm.pdfValido === true) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.$store.state.loading
    },
    on: {
      "click": function($event) {
        return _vm.firm(_vm.solicitud)
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.approve')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 7) ? _c('div', [(_vm.tramite.id_archivo == 1) ? _c('file-upload', {
    attrs: {
      "url": _vm.url,
      "max-filesize": _vm.$store.state.maxFilesize,
      "label": "Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos del usuario")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento: ")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_departamento)), _c('br')]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token && _vm.pdf !== null) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pdfValido === false && _vm.tramite.id_archivo > 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              El documento PDF, no es válido o se encuentra corrupto.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf,
      "valido": _vm.validarPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1 || !_vm.pdf) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              No se adjuntó ningún documento PDF\n            ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [(_vm.solicitud) ? _c('observar', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('module.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 640
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'modulo', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['modulos:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'modulo')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['permisos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.openPermisos(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("security")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar permisos")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'modulo', 'EditModulo', _vm.getMenu)
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")])], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": true,
            "color": "info"
          },
          on: {
            "change": function($event) {
              return _vm.changeVisible(items.item, items.item.id)
            }
          },
          slot: "activator",
          model: {
            value: (items.item.visible),
            callback: function($$v) {
              _vm.$set(items.item, "visible", $$v)
            },
            expression: "items.item.visible"
          }
        }), _vm._v(" "), _c('span', [_vm._v("Poner como visible en el menú")])], 1) : _c('v-icon', {
          attrs: {
            "color": items.item.visible ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.ruta))]), _vm._v(" "), _c('td', [(items.item.icono) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v(_vm._s(items.item.icono))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.item.icono))])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getModulo(items.item.id_modulo)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.orden))]), _vm._v(" "), _c('td', [(items.item.visible) ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              VISIBLE\n            ")]) : _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              OCULTO\n            ")])], 1), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['modulos:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('module.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('module.crud.editModule') : _vm.$t('module.crud.addModule')) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.form.estado == 'ACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "success",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.form.estado == 'INACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "warning",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "label",
      "label": _vm.$t('module.crud.label'),
      "autofocus": "",
      "maxlength": "50",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.label),
      callback: function($$v) {
        _vm.$set(_vm.form, "label", $$v)
      },
      expression: "form.label"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ruta",
      "label": _vm.$t('module.crud.path'),
      "maxlength": "50",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.ruta),
      callback: function($$v) {
        _vm.$set(_vm.form, "ruta", $$v)
      },
      expression: "form.ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.isSection,
      "name": "icono",
      "label": _vm.$t('module.crud.icon'),
      "maxlength": "30"
    },
    model: {
      value: (_vm.form.icono),
      callback: function($$v) {
        _vm.$set(_vm.form, "icono", $$v)
      },
      expression: "form.icono"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "orden",
      "label": "Nro. de orden",
      "maxlength": "3",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.orden),
      callback: function($$v) {
        _vm.$set(_vm.form, "orden", $$v)
      },
      expression: "form.orden"
    }
  })], 1), _vm._v(" "), (!_vm.form.id) ? _c('v-flex', {
    attrs: {
      "xs5": "",
      "justify-center": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "value": true,
      "label": "Visible en el menú",
      "color": "info",
      "required": ""
    },
    model: {
      value: (_vm.form.visible),
      callback: function($$v) {
        _vm.$set(_vm.form, "visible", $$v)
      },
      expression: "form.visible"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('h4', [_vm._v("Dependencias")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "value": true,
      "label": "¿Depende de otro módulo?",
      "color": "info"
    },
    model: {
      value: (_vm.isSection),
      callback: function($$v) {
        _vm.isSection = $$v
      },
      expression: "isSection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.isSection) ? _c('v-select', {
    attrs: {
      "items": _vm.modulos,
      "label": "Módulo padre",
      "item-text": "text",
      "item-value": "value",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.id_modulo),
      callback: function($$v) {
        _vm.$set(_vm.form, "id_modulo", $$v)
      },
      expression: "form.id_modulo"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "960"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.roles.length) ? _c('permisos', {
    attrs: {
      "modulo": _vm.modulo,
      "roles": _vm.roles
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "content-class": "dialog--alert",
      "max-width": "360"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Confirmar")], 1), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "md-btn-confirm-selected-cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.textCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "id": "md-btn-confirm-selected-ok"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v(_vm._s(_vm.textOk))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("folder")]), _vm._v(" " + _vm._s(_vm.title))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "showFilter": true
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.id))]), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [_c('div', [_c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDetalle(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")]), _vm._v(" Detalles\n              ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.descargar(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', [_c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v(_vm._s(items.item.estado.replace(/_/gi, ' ')))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.nro_apostilla))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.tramite_cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_expedicion)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.documento_nombre))]), _vm._v(" "), _c('td', [_c('em', [_c('strong', [_vm._v(_vm._s(items.item.tramite_solicitante_tipo_documento) + ": ")]), _vm._v(_vm._s(items.item.tramite_solicitante_nro_documento))]), _c('br'), _vm._v("\n            " + _vm._s(items.item.tramite_solicitante_nombres) + "\n            " + _vm._s(items.item.tramite_solicitante_primer_apellido) + "\n            " + _vm._s(items.item.tramite_solicitante_segundo_apellido) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(items.item.pago_entidad || items.item.pago_cancilleria) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1)]
      }
    }])
  }, [_c('template', {
    slot: "labels"
  }, [(this.regionales.length > 1) ? _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.regional),
      callback: function($$v) {
        _vm.regional = $$v
      },
      expression: "regional"
    }
  })], 1) : _c('div', {
    staticClass: "text-xs-right"
  }, [_c('strong', [_vm._v("REGIONAL: ")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": "info",
      "text-color": "white"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.departamento.split(',').join(' - ')) + "\n            ")])], 1)])], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.solicitud) ? _c('detalle', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-breadcrumbs', [_c('v-icon', {
    attrs: {
      "slot": "divider"
    },
    slot: "divider"
  }, [_vm._v("chevron_right")]), _vm._v(" "), _vm._l((_vm.$store.state.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled
      }
    }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('user.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function(props) {
        return [_c('v-card-title', {
          staticClass: "headline"
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.form.id ? 'person' : 'person_add'))]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('user.crud.editUser') : _vm.$t('user.crud.addUser')) + "\n            "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal')
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
          ref: "form",
          attrs: {
            "lazy-validation": ""
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.save($event)
            }
          },
          model: {
            value: (_vm.valid),
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        }, [(_vm.form.usuario == _vm.usuario && _vm.form.id) ? _c('v-alert', {
          attrs: {
            "color": "info",
            "value": "true"
          }
        }, [_vm._v("\n              Puede cambiar su contraseña yendo a:\n              "), _c('router-link', {
          staticClass: "white--text",
          attrs: {
            "to": "/account"
          }
        }, [_c('strong', [_c('v-icon', {
          staticClass: "icon-small",
          attrs: {
            "dark": ""
          }
        }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1)]), _vm._v(".\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
          attrs: {
            "grid-list-md": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre de usuario",
            "prepend-icon": "person",
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": "",
            "autofocus": ""
          },
          model: {
            value: (_vm.form.usuario),
            callback: function($$v) {
              _vm.$set(_vm.form, "usuario", $$v)
            },
            expression: "form.usuario"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [(!_vm.form.id) ? _c('v-text-field', {
          attrs: {
            "label": "Contraseña",
            "prepend-icon": _vm.getIcon,
            "prepend-icon-cb": _vm.changeIcon,
            "type": _vm.hidePass ? 'password' : 'text',
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.contrasena),
            callback: function($$v) {
              _vm.$set(_vm.form, "contrasena", $$v)
            },
            expression: "form.contrasena"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre(s)",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.nombres),
            callback: function($$v) {
              _vm.$set(_vm.form, "nombres", $$v)
            },
            expression: "form.nombres"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Primer apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.primer_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "primer_apellido", $$v)
            },
            expression: "form.primer_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Segundo apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.segundo_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "segundo_apellido", $$v)
            },
            expression: "form.segundo_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Cargo",
            "maxlength": "255"
          },
          model: {
            value: (_vm.form.cargo),
            callback: function($$v) {
              _vm.$set(_vm.form, "cargo", $$v)
            },
            expression: "form.cargo"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "label": "Regional",
            "items": _vm.regionales,
            "chips": "",
            "attach": "",
            "multiple": ""
          },
          model: {
            value: (_vm.regionalesSeleccionadas),
            callback: function($$v) {
              _vm.regionalesSeleccionadas = $$v
            },
            expression: "regionalesSeleccionadas"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Correo electrónico",
            "maxlength": "100",
            "prepend-icon": "email",
            "rules": _vm.$validate(['email'])
          },
          model: {
            value: (_vm.form.email),
            callback: function($$v) {
              _vm.$set(_vm.form, "email", $$v)
            },
            expression: "form.email"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Teléfono",
            "prepend-icon": "phone",
            "maxlength": "30"
          },
          model: {
            value: (_vm.form.telefono),
            callback: function($$v) {
              _vm.$set(_vm.form, "telefono", $$v)
            },
            expression: "form.telefono"
          }
        })], 1), _vm._v(" "), (_vm.$store.state.user.id_rol != 5) ? _c('v-flex', {
          attrs: {
            "xs7": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.entidades,
            "label": "Entidad",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_entidad),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_entidad", $$v)
            },
            expression: "form.id_entidad"
          }
        })], 1) : _vm._e(), _vm._v(" "), (!(_vm.form.usuario == _vm.usuario && _vm.form.id)) ? _c('v-flex', {
          attrs: {
            "xs5": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.roles,
            "label": "Rol",
            "item-text": "text",
            "item-value": "id",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_rol),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_rol", $$v)
            },
            expression: "form.id_rol"
          }
        })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
          staticClass: "error--text text-required"
        }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal');
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "type": "submit"
          }
        }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')))], 1)], 1)], 1)]
      }
    }, {
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['usuarios:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'usuario', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['usuarios:update'] && _vm.$store.state.user.id_rol == 1) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Restablecer contraseña")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['usuarios:delete'] && items.item.id_rol != 8 && _vm.usuario !== items.item.usuario) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'usuario')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['usuarios:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario !== items.item.usuario) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'usuario', 'EditUsuario')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.permissions['usuarios:update'] && _vm.usuario !== items.item.usuario) ? _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario === items.item.usuario) ? _c('router-link', {
          attrs: {
            "slot": "activator",
            "to": "/account"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("person")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Este usuario soy yo, clic aquí para ir a mi cuenta.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.usuario))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.primer_apellido) + " " + _vm._s(items.item.segundo_apellido) + " " + _vm._s(items.item.nombres))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.entidad_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.rol_nombre))]), _vm._v(" "), _c('td', _vm._l((items.item.departamento.split(',')), function(item) {
          return _c('span', [_vm._v("\n              " + _vm._s(item)), _c('br')])
        }), 0), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['usuarios:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person_add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('user.add')))])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Firmador Grupal\n      "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "demofi-container"
  }, [_c('demofi', {
    attrs: {
      "solicitud": _vm.$store.state.selected,
      "on-success": _vm.cambiarEstado
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.$store.state.permissions['firmas:create']) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.$store.state.loading
    },
    on: {
      "click": function($event) {
        return _vm.firm(_vm.$store.state.selected)
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.approve')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._l((_vm.$store.state.selected), function(item) {
    return [(item.id_archivo === 1) ? _c('v-chip', {
      attrs: {
        "color": "red",
        "text-color": "white"
      }
    }, [_vm._v("\n                Nro. " + _vm._s(item.id) + " - NO TIENE ARCHIVO ADJUNTO\n              ")]) : _c('v-chip', [_vm._v("\n                Nro. " + _vm._s(item.id) + " -\n                " + _vm._s(item.tramite_solicitante_nombres) + "\n                " + _vm._s(item.tramite_solicitante_primer_apellido) + "\n                " + _vm._s(item.tramite_solicitante_segundo_apellido) + " -\n                " + _vm._s(item.documento_nombre) + "\n              ")])]
  }), _vm._v(" "), (!_vm.$store.state.selected || _vm.$store.state.selected === 0) ? _c('div', [
    [_vm._v("\n                No ha seleccionado documentos\n              ")]
  ], 2) : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar documento del trámite de la entidad\r\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 3)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n      Se agregará el trámite de la entidad en base a los trámites registrados en el "), _c('strong', [_vm._v("Portal único de trámites")]), _vm._v(" y la "), _c('strong', [_vm._v("Plataforma de pagos")]), _vm._v(".\r\n    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.mydocs.portal,
      "label": "Documentos",
      "item-text": "nombre",
      "item-value": "codigo_portal",
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.documento),
      callback: function($$v) {
        _vm.documento = $$v
      },
      expression: "documento"
    }
  }), _vm._v(" "), (_vm.showUsuariosApp) ? _c('div', [(_vm.mydocs.usuariosApp.length > 1) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos\r\n      ")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.mydocs.usuariosApp,
      "label": "Aplicación en la Plataforma de pago",
      "item-text": "endpoint",
      "item-value": "id_usuario_app",
      "readonly": _vm.mydocs.usuariosApp.length == 1,
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.usuarioapp),
      callback: function($$v) {
        _vm.usuarioapp = $$v
      },
      expression: "usuarioapp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showUsuariosApp && _vm.documento) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": true
    }
  }, [_vm._v("\r\n      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos\r\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 3)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\r\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.show || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.obtainTokenForDocument()
      }
    }
  }, [_c('v-icon', [_vm._v("check_circle")]), _vm._v(" Crear trámite\r\n    ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "elevation-0",
    attrs: {
      "color": "white",
      "fixed": "",
      "app": "",
      "clipped-right": ""
    }
  }, [(_vm.$store.state.sidenav) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.commit('toggleSidenav')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "text--white"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": '/'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('span', [_vm._v("Actualizar la página completa")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-fullscreen",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.fullscreen()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("fullscreen")]), _vm._v(" "), _c('v-icon', [_vm._v("fullscreen_exit")])], 1), _vm._v(" "), _c('span', [_vm._v("Pantalla completa")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        return _vm.$router.push('account')
      }
    }
  }, [_c('v-icon', [_vm._v("account_circle")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-icon', [_vm._v("")]), _vm._v(" " + _vm._s(_vm.$t('app.logOut')))], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "420"
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-token"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("lock")]), _vm._v(" Cambiar mi contraseña\n      "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword($event)
      }
    }
  }, [_c('v-card-text', [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "color": "info",
      "icon": "info",
      "value": "true"
    }
  }, [_vm._v("Haga click en "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("visibility")]), _vm._v(" para poder\n          ver/ocultar su contraseña.")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Antigua contraseña",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nueva contraseña",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPassword", $$v)
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("lock")]), _vm._v(" Cambiar")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "dark": "",
      "stateless": false,
      "app": ""
    },
    model: {
      value: (_vm.$store.state.toggle),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "toggle", $$v)
      },
      expression: "$store.state.toggle"
    }
  }, [_c('div', {
    staticClass: "sidenav-app",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.commit('toggleSidenav')
      }
    }
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('app.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "sidenav-user__photo"
  }, [_vm._v(_vm._s(_vm.inicial))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticClass: "sidenav-user__name"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("person_pin")]), _vm._v("\n          " + _vm._s(_vm.nombreCompleto) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user__entidad"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n          " + _vm._s(_vm.user.entidad)), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.user.rol))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user__email"
  }, [_vm._v("\n      @" + _vm._s(_vm.user.usuario) + "\n    ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "id": "sidenav-menu"
    }
  }, [_vm._l((_vm.menu), function(item, i) {
    return [(item.submenu) ? _c('v-list-group', {
      attrs: {
        "no-action": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "data-url": item.url
      },
      on: {
        "click": function($event) {
          return _vm.send(item.url, item.submenu)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "warning"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.getLabel(item)) + "\n            ")]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.model ? 'keyboard_arrow_down' : 'keyboard_arrow_right'))])], 1)], 1), _vm._v(" "), _vm._l((item.submenu), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "data-url": child.url
        },
        on: {
          "click": function($event) {
            return _vm.send(child.url)
          }
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.getLabel(child)) + "\n            ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "data-url": item.url
      },
      on: {
        "click": function($event) {
          return _vm.send(item.url, item.submenu)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "warning"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.getLabel(item)) + "\n          ")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('auxiliar.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function(props) {
        return [_c('v-card-title', {
          staticClass: "headline"
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.form.id ? 'person' : 'person_add'))]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('auxiliar.crud.editUser') : _vm.$t('auxiliar.crud.addUser')) + "\n            "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal')
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
          ref: "form",
          attrs: {
            "lazy-validation": ""
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.save($event)
            }
          },
          model: {
            value: (_vm.valid),
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        }, [(_vm.form.usuario == _vm.usuario && _vm.form.id) ? _c('v-alert', {
          attrs: {
            "color": "info",
            "value": "true"
          }
        }, [_vm._v("\n              Puede cambiar su contraseña yendo a:\n              "), _c('router-link', {
          staticClass: "white--text",
          attrs: {
            "to": "/account"
          }
        }, [_c('strong', [_c('v-icon', {
          staticClass: "icon-small",
          attrs: {
            "dark": ""
          }
        }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1)]), _vm._v(".\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
          attrs: {
            "grid-list-md": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre de usuario",
            "prepend-icon": "person",
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": "",
            "autofocus": ""
          },
          model: {
            value: (_vm.form.usuario),
            callback: function($$v) {
              _vm.$set(_vm.form, "usuario", $$v)
            },
            expression: "form.usuario"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [(!_vm.form.id) ? _c('v-text-field', {
          attrs: {
            "label": "Contraseña",
            "prepend-icon": _vm.getIcon,
            "prepend-icon-cb": _vm.changeIcon,
            "type": _vm.hidePass ? 'password' : 'text',
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.contrasena),
            callback: function($$v) {
              _vm.$set(_vm.form, "contrasena", $$v)
            },
            expression: "form.contrasena"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre(s)",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.nombres),
            callback: function($$v) {
              _vm.$set(_vm.form, "nombres", $$v)
            },
            expression: "form.nombres"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Primer apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.primer_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "primer_apellido", $$v)
            },
            expression: "form.primer_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Segundo apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.segundo_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "segundo_apellido", $$v)
            },
            expression: "form.segundo_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Cargo",
            "maxlength": "255"
          },
          model: {
            value: (_vm.form.cargo),
            callback: function($$v) {
              _vm.$set(_vm.form, "cargo", $$v)
            },
            expression: "form.cargo"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-select', {
          attrs: {
            "label": "Regional",
            "items": _vm.regionales,
            "rules": _vm.$validate(['required'])
          },
          model: {
            value: (_vm.form.departamento),
            callback: function($$v) {
              _vm.$set(_vm.form, "departamento", $$v)
            },
            expression: "form.departamento"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Correo electrónico",
            "maxlength": "100",
            "prepend-icon": "email",
            "rules": _vm.$validate(['email'])
          },
          model: {
            value: (_vm.form.email),
            callback: function($$v) {
              _vm.$set(_vm.form, "email", $$v)
            },
            expression: "form.email"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Teléfono",
            "prepend-icon": "phone",
            "maxlength": "30"
          },
          model: {
            value: (_vm.form.telefono),
            callback: function($$v) {
              _vm.$set(_vm.form, "telefono", $$v)
            },
            expression: "form.telefono"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
          staticClass: "error--text text-required"
        }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal');
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "type": "submit"
          }
        }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')))], 1)], 1)], 1)]
      }
    }, {
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['auxiliares:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'auxiliar', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['auxiliares:update'] && _vm.$store.state.user.id_rol == 7) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Restablecer contraseña")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['auxiliares:delete'] && items.item.id_rol != 8 && _vm.usuario !== items.item.usuario) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'auxiliar')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['auxiliares:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario !== items.item.usuario) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'auxiliar', 'EditAuxiliar')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.permissions['auxiliares:update'] && _vm.usuario !== items.item.usuario) ? _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario === items.item.usuario) ? _c('router-link', {
          attrs: {
            "slot": "activator",
            "to": "/account"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("person")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Este usuario soy yo, clic aquí para ir a mi cuenta.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.usuario))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.primer_apellido) + " " + _vm._s(items.item.segundo_apellido) + " " + _vm._s(items.item.nombres))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.departamento))]), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['auxiliares:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person_add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('auxiliar.add')))])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("description")]), _vm._v(" Reportes")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n      Mis reportes\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "pa-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('div', [_vm._v("© " + _vm._s(new Date().getFullYear()))])], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('applicants.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [_vm._v(_vm._s(items.item.nombres) + " " + _vm._s(items.item.primer_apellido) + " " + _vm._s(items.item.segundo_apellido))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tipo_documento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.departamento_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.provincia_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.municipio_nombre))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(!_vm.demofi_ejecutandose) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "value": true
    }
  }, [_c('h3', {
    staticClass: "headline warning--text"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Atención.-")], 1), _vm._v(" "), _c('p', [_vm._v("Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador. Haga:")]), _vm._v(" "), _c('p', [_vm._v("1. Visite el siguiente enlace para su instalación y/o configuración. Presione "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://test.local.agetic.gob.bo/firmador/#"
    }
  }, [_vm._v("aquí")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "margin-0"
  }, [_vm._v("2. Puede verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.verCertificado()
      }
    }
  }, [_vm._v("aquí")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (_vm.demofi_ejecutandose && !_vm.autenticado) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n    Ingrese el PIN de su Token para poder firmar el grupo de documentos.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.certificados.length) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "success",
      "icon": "check",
      "value": true
    }
  }, [_vm._v("\n    Token iniciado correctamente\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.autenticar($event)
      }
    }
  }, [(!_vm.autenticado && !_vm.$store.state.pin) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pin",
      "type": "password",
      "prepend-icon": "verified_user",
      "rules": _vm.$validate(['required']),
      "disabled": !_vm.token_conectado || _vm.autenticado
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.token_conectado || _vm.autenticado
    }
  }, [_vm._v(" Autenticar\n            ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.certificados.length) ? _c('div', [_c('h4', [_c('v-icon', [_vm._v("person")]), _vm._v(" Información del Token")], 1), _vm._v(" "), _c('div', {
    staticClass: "demofi-certificado"
  }, [_c('p', [_c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.firmador.nombreComunSubject))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Organización:")]), _vm._v(" " + _vm._s(_vm.firmador.organizacionSubject))]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Token válido desde el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.inicioValidez))]), _vm._v(" hasta el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.finValidez))])])])]), _vm._v(" "), _c('v-select', {
    staticClass: "p-b-0",
    attrs: {
      "label": "Certificado",
      "rules": _vm.$validate(['required']),
      "prepend-icon": "person",
      "disabled": !_vm.autenticado,
      "item-text": "nombreComunSubject",
      "item-value": "numeroSerie",
      "items": _vm.certificados
    },
    model: {
      value: (_vm.firmadorSeleccionado),
      callback: function($$v) {
        _vm.firmadorSeleccionado = $$v
      },
      expression: "firmadorSeleccionado"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "center": ""
    }
  }, [(_vm.certificados.length) ? _c('v-btn', {
    attrs: {
      "id": "btn-demofi-firm-grupal",
      "color": "success",
      "disabled": !_vm.autenticado || _vm.firmando
    },
    on: {
      "click": _vm.firmar
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("security")]), _vm._v("Firmar")], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['parametros:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'parametro', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['parametros:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'parametro')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v(_vm._s(_vm.$filter.characters(items.item.valor, 50)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.item.valor))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.descripcion))])]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['parametros:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('parametro.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('parametro.crud.editParametro') : _vm.$t('parametro.crud.addParametro')) + "\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('parametro.crud.name'),
      "id": "nombre",
      "rules": _vm.$validate(['required']),
      "required": "",
      "maxlength": "100",
      "disabled": _vm.$store.state.user.id_rol == 2
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "valor",
      "label": _vm.$t('parametro.crud.value'),
      "id": "valor",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.valor),
      callback: function($$v) {
        _vm.$set(_vm.form, "valor", $$v)
      },
      expression: "form.valor"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "label",
      "label": _vm.$t('parametro.crud.label'),
      "id": "label",
      "rules": _vm.$validate(['required']),
      "required": "",
      "maxlength": "100",
      "disabled": _vm.$store.state.user.id_rol == 2
    },
    model: {
      value: (_vm.form.label),
      callback: function($$v) {
        _vm.$set(_vm.form, "label", $$v)
      },
      expression: "form.label"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('parametro.crud.description'),
      "id": "descripcion",
      "disabled": _vm.$store.state.user.id_rol == 2
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "logo-app"
  }), _vm._v(" "), _c('v-card', {
    staticClass: "login-form"
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Plataforma de Pagos\n          "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n            Para poder registrar sus trámites debe ingresar su usuario y contraseña de la Plataforma de pagos de su entidad aquí.\n          ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "label": _vm.$t('login.user'),
      "id": "username",
      "append-icon": "person",
      "autofocus": "",
      "maxlength": "25",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": _vm.$t('login.password'),
      "id": "password",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "large": "",
      "disabled": !_vm.valid || _vm.loading,
      "type": "submit"
    }
  }, [_c('v-icon', [_vm._v("verified_user")]), _vm._v(" " + _vm._s(_vm.$t('login.login')) + "\n          ")], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('transact.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_inicio)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_fin)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.solicitante_nombres) + " " + _vm._s(items.item.solicitante_primer_apellido) + " " + _vm._s(items.item.solicitante_segundo_apellido))]), _vm._v(" "), _c('td', [(items.item.estado == 'SOLICITADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'EN_PROCESO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'FINALIZADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "danger",
            "text-color": "black"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n    "), _c('div', {
    staticClass: "tramite-estado"
  }, [_c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n              " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _vm._l((_vm.pagos), function(item, index) {
    return [_c('v-spacer'), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 && _vm.tramite.estado === 'APOSTILLADO') ? _c('v-tooltip', {
      staticClass: "margin-0",
      attrs: {
        "top": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.imprimir()
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("print")]), _vm._v(" IMPRIMIR EN HOJA MEMBRETADA\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(" Versión para imprimir en hoja membretada")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
      staticClass: "margin-0",
      attrs: {
        "top": ""
      }
    }, [(_vm.$store.state.permissions['tramitesDoc:update'] && _vm.$store.state.user.id_rol === 3 && (item.estado == 'HABILITADO' || _vm.tramite.estado == 'REVISADO_ENTIDAD')) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "info",
        "disabled": item.estado == 'PAGADO'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.generarCpt(_vm.tramite, 'CANCILLERIA')
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("monetization_on")]), _vm._v(" REGENERAR CPT\n              ")], 1) : _vm._e(), _vm._v(" "), (item.estado == 'PAGADO') ? _c('span', [_vm._v("No se puede regenerar Código de Pago(CPT) de un trámite pagado")]) : _c('span', [_vm._v(" Regenerar Código de Pago(CPT)")])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firmante designado")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre) + "\n            ")]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n            No se adjuntó ningún documento PDF\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1), _vm._v(" "), _c('v-card', {
    staticClass: "success white--text account"
  }, [_c('v-container', {
    staticClass: "bg-white",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.user.nombres) + " " + _vm._s(_vm.user.primer_apellido) + " " + _vm._s(_vm.user.segundo_apellido))]), _vm._v(" "), _c('p', [_vm._v("@" + _vm._s(_vm.user.usuario))]), _vm._v(" "), _c('div', {
    staticClass: "account-info"
  }, [_c('p', [_c('strong', [_vm._v("Correo electrónico:")]), _vm._v(" " + _vm._s(_vm.user.email))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('account.crud.entity')) + ":")]), _vm._v(" " + _vm._s(_vm.user.entidad))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('user.crud.role')) + ":")]), _vm._v(" " + _vm._s(_vm.user.rol))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "center-flex",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "sidenav-user__photo"
  }, [_vm._v(_vm._s(_vm.inicial))])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.openPass()
      }
    }
  }, [_c('v-icon', [_vm._v("lock")]), _vm._v(" Cambiar contraseña")], 1), _vm._v(" "), (_vm.user.id_rol != 1) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDeactivate()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("cancel")]), _vm._v(" Desactivar cuenta")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "420"
    },
    model: {
      value: (_vm.modalDeactivate),
      callback: function($$v) {
        _vm.modalDeactivate = $$v
      },
      expression: "modalDeactivate"
    }
  }, [_c('v-card', {
    staticClass: "dialog-token"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Desactivar mi cuenta\n        "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.modalDeactivate = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.deactivate($event)
      }
    }
  }, [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("Una vez desactivada su cuenta si desea volver a habilitarla deberá contactarse con el administrador del sistema.")]), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "color": "info",
      "value": "true",
      "icon": "info"
    }
  }, [_vm._v("Ingrese su contraseña para confirmar la desactivación de su cuenta.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "password",
      "label": _vm.$t('login.password'),
      "id": "password",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.modalDeactivate = false
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "type": "submit"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("vpn_key")]), _vm._v(" Desactivar")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('account-pass')], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-loading",
    attrs: {
      "id": "app-loading"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "warning"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "app-loading-message"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" Solicitudes de trámites de la entidad")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 4 ? _vm.headers_pago : _vm.headers_sin_pago,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800,
      "checkbox": _vm.$store.state.user.id_rol === 7 || _vm.$store.state.user.id_rol === 4,
      "showFilter": true
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v("\n            " + _vm._s(items.item.id) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 6) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openRevisor(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFirmante(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(items.item.documento_derivar === 'CANCILLERIA' && items.item.estado === 'FIRMADO_ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v("CREADO - CANCILLERIA")])]) : _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v(_vm._s(items.item.estado.replace(/_/gi, ' ')))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tramite_cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.documento_nombre))]), _vm._v(" "), _c('td', [_c('em', [_c('strong', [_vm._v(_vm._s(items.item.tramite_solicitante_tipo_documento) + ": ")]), _vm._v("\n              " + _vm._s(items.item.tramite_solicitante_nro_documento))]), _c('br'), _vm._v("\n            " + _vm._s(items.item.tramite_solicitante_nombres) + "\n            " + _vm._s(items.item.tramite_solicitante_primer_apellido) + "\n            " + _vm._s(items.item.tramite_solicitante_segundo_apellido) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at)))]), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) ? _c('td', {
          staticClass: "text-xs-center"
        }, [(items.item.pago_entidad || items.item.pago_cancilleria) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.user.id_rol === 7 || _vm.$store.state.user.id_rol === 4) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openFirmanteGrupal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Firmar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Firmar documentos seleccionados")])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "labels"
  }, [(this.regionales.length > 1) ? _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.regional),
      callback: function($$v) {
        _vm.regional = $$v
      },
      expression: "regional"
    }
  })], 1) : _c('div', {
    staticClass: "text-xs-right"
  }, [_c('strong', [_vm._v("REGIONAL:")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": "info",
      "text-color": "white"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.departamento.split(',').join(' - ')) + "\n            ")])], 1)])], 2)], 1)], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.solicitud) ? _c('revisor', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal3),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal3", $$v)
      },
      expression: "$store.state.modal3"
    }
  }, [(_vm.solicitudC) ? _c('firmante', {
    attrs: {
      "solicitud": _vm.solicitudC
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal7),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal7", $$v)
      },
      expression: "$store.state.modal7"
    }
  }, [(_vm.firmador) ? _c('Firmantegrupal', {
    attrs: {
      "solicitud": _vm.solicitudC,
      "persistent": "",
      "scrollable": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('pago.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "order": _vm.order,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [(items.item.estado == 'PENDIENTE') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "error",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'HABILITADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'PAGADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(items.item.tipo == 'ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.tipo) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.tipo == 'CANCILLERIA') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.tipo) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.titular_factura))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nro_documento))]), _vm._v(" "), _c('td', _vm._l((items.item.cpt), function(value, key) {
          return _c('span', [(key === 'cpt') ? _c('span', [_vm._v("\n                  " + _vm._s(value) + "\n                ")]) : _vm._e()])
        }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.id_tramite_doc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at, 'dd/MM/YYYY hrs. HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_pago, 'dd/MM/YYYY hrs. HH:mm')))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" N° de Solicitud: " + _vm._s(_vm.tramite.id) + "\n      "), _c('div', {
    staticClass: "tramite-estado"
  }, [(_vm.tramite.documento_derivar === 'CANCILLERIA') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": 'info',
      "text-color": "white"
    }
  }, [_c('small', [_vm._v("ENVIADO DESDE SERVICIO WEB")])]) : _vm._e(), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": _vm.estados[_vm.tramite.estado],
      "text-color": "white"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.tramite.estado ? _vm.tramite.estado.replace(/_/gi, ' ') : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('detalle-doc', {
    attrs: {
      "solicitud": _vm.tramite,
      "pagos": _vm.pagos
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-tooltip', {
    staticClass: "margin-0",
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalles = !_vm.detalles
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.detalles ? 'chevron_left' : 'chevron_right'))]), _vm._v("\n                " + _vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + "\n              ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detalles ? 'Ocultar' : 'Mostrar') + " detalles")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo > 1),
      expression: "tramite.id_archivo > 1"
    }],
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cambiarDoc()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_horiz")]), _vm._v("\n                Cambiar\n              ")], 1), _vm._v(" "), _c('span', [_vm._v("Cambiar por otro documento")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tramite.id_archivo == 1 && _vm.$store.state.archivo > 1),
      expression: "tramite.id_archivo == 1 && $store.state.archivo > 1"
    }],
    staticClass: "margin-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelarCambio()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v("\n              Cancelar cambio\n            ")], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [(_vm.$store.state.permissions['tramitesDoc:update'] && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR') ? _c('v-btn', {
    staticClass: "margin-0",
    attrs: {
      "slot": "activator",
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openObservar(_vm.solicitud)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" OBSERVAR\n              ")], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Observar documento")])], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 && _vm.tramite.id_archivo != null && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR') ? _c('v-btn', {
    staticClass: "m-r-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.tramite.id_archivo == 1
    },
    on: {
      "click": function($event) {
        return _vm.aprobarEntidad(_vm.tramite);
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Enviar para firma (Entidad)\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 3 && _vm.tramite.id_archivo != null && _vm.tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR' && _vm.pdfValido === true) ? _c('v-btn', {
    staticClass: "m-r-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.tramite.id_archivo == 1
    },
    on: {
      "click": function($event) {
        return _vm.aprobarCancilleria(_vm.tramite);
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Enviar para firma\n            ")], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) && _vm.solicitud.firmante && _vm.solicitud.firmante.firmante_nombre_completo) ? _c('v-layout', {
    staticClass: "firma-detalle",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos del usuario")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_nombre_completo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_cargo || '[no registrado]') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Entidad:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.entidad_nombre)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.firmante_departamento.split(',').join(', ')) + "\n            ")]), _vm._v(" "), (_vm.solicitud.firmante.certicado_token) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Datos firma en documento")]), _vm._v(" "), _c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunSubject) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Certificado por:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.nombreComunIssuer) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha inicio validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.inicioValidez) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha fin validez:")]), _vm._v(" " + _vm._s(_vm.solicitud.firmante.certicado_token.finValidez) + " "), _c('br')]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3) ? _c('div', [(_vm.tramite.id_archivo == 1) ? _c('file-upload', {
    attrs: {
      "url": _vm.url,
      "max-filesize": _vm.$store.state.maxFilesize,
      "label": "Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [(_vm.pdfValido == false && _vm.tramite.id_archivo > 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              El documento PDF, no es válido o se encuentra corrupto.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pdf && _vm.tramite.id_archivo > 1) ? _c('pdf-view', {
    attrs: {
      "data": _vm.pdf,
      "url": _vm.urlPdf,
      "valido": _vm.validarPdf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.solicitud.estado.indexOf('OBSERVADO') != -1 && _vm.tramite.id_archivo == 1) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n              La solicitud no cuenta con un documento PDF adjunto\n            ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [(_vm.solicitud) ? _c('observar', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("settings")]), _vm._v(" " + _vm._s(_vm.$t('parametro.preferencias')))], 1), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "primary tab-preferencias",
    attrs: {
      "dark": ""
    }
  }, [(_vm.$store.state.permissions['parametros:read']) ? _c('v-tabs-item', {
    key: "parametros",
    attrs: {
      "href": "#parametros",
      "ripple": ""
    }
  }, [_c('v-icon', [_vm._v("settings_applications")]), _vm._v(" " + _vm._s(_vm.$t('parametro.title')) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['roles:read']) ? _c('v-tabs-item', {
    key: "roles",
    attrs: {
      "href": "#roles",
      "ripple": ""
    }
  }, [_c('v-icon', [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('rol.title')) + "\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "warning"
    }
  })], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "parametros",
    attrs: {
      "id": "parametros"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.$store.state.permissions['parametros:read'] && _vm.active == 'parametros') ? _c('parametro') : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "roles",
    attrs: {
      "id": "roles"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.$store.state.permissions['roles:read'] && _vm.active == 'roles') ? _c('rol') : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-date",
    class: {
      'select-date-label': _vm.label.length
    }
  }, [(_vm.label.length) ? _c('label', {
    staticClass: "select-date-title"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Día",
      "maxlength": "2",
      "rules": _vm.required ? _vm.$validate(['required']) : [],
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.$filter.numeric($event)
      }
    },
    model: {
      value: (_vm.form.day),
      callback: function($$v) {
        _vm.$set(_vm.form, "day", $$v)
      },
      expression: "form.day"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mes",
      "maxlength": "2",
      "rules": _vm.required ? _vm.$validate(['required']) : [],
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.$filter.numeric($event)
      }
    },
    model: {
      value: (_vm.form.month),
      callback: function($$v) {
        _vm.$set(_vm.form, "month", $$v)
      },
      expression: "form.month"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Año",
      "maxlength": "4",
      "rules": _vm.required ? _vm.$validate(['required']) : [],
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.$filter.numeric($event)
      }
    },
    model: {
      value: (_vm.form.year),
      callback: function($$v) {
        _vm.$set(_vm.form, "year", $$v)
      },
      expression: "form.year"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "logo-app"
  }), _vm._v(" "), _c('v-card', {
    staticClass: "login-form"
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('login.title')))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "label": _vm.$t('login.user'),
      "id": "username",
      "append-icon": "person",
      "autofocus": "",
      "maxlength": "25",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": _vm.$t('login.password'),
      "id": "password",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "large": "",
      "disabled": !_vm.valid,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.login')))])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('a', {
    attrs: {
      "href": "https://firmadigital.bo/jacobitus4/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "src": "/admin/static/images/logoadsib.png"
    }
  })])])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found__message text-xs-center"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("NO TIENE PERMISOS PARA REALIZAR ESTA ACCIÓN")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Volver atrás")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("4")]), _vm._v("0"), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("3")])])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "content-class": "dialog--confirm",
      "max-width": "360"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Alerta")]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Permisos para " + _vm._s(_vm.modulo.label) + "\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "alert-permiso",
    attrs: {
      "color": "info",
      "icon": "info",
      "value": "true"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_vm._v("Habilite/deshabilite los permisos del módulo para cada rol, donde:")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Con permiso",
      "value": true,
      "text-color": "white",
      "color": "primary"
    },
    on: {
      "change": function($event) {
        _vm.activo = true
      }
    },
    model: {
      value: (_vm.activo),
      callback: function($$v) {
        _vm.activo = $$v
      },
      expression: "activo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Sin permiso",
      "text-color": "white",
      "color": "primary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rol")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Ver")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Crear")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Actualizar")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Eliminar")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("CSV")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Firmar")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permisos), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "title-permiso"
    }, [_c('strong', [_vm._v(_vm._s(item.rol_nombre))]), _c('br'), _vm._v(" "), _c('sub', [_c('em', [_vm._v(_vm._s(item.rol_descripcion))])])]), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.read),
        callback: function($$v) {
          _vm.$set(item, "read", $$v)
        },
        expression: "item.read"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.create),
        callback: function($$v) {
          _vm.$set(item, "create", $$v)
        },
        expression: "item.create"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.update),
        callback: function($$v) {
          _vm.$set(item, "update", $$v)
        },
        expression: "item.update"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.delete),
        callback: function($$v) {
          _vm.$set(item, "delete", $$v)
        },
        expression: "item.delete"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.csv),
        callback: function($$v) {
          _vm.$set(item, "csv", $$v)
        },
        expression: "item.csv"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.firma),
        callback: function($$v) {
          _vm.$set(item, "firma", $$v)
        },
        expression: "item.firma"
      }
    })], 1)])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.close')) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found__message text-xs-center"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("SE PRODUJO UN ERROR EN EL SERVIDOR")]), _vm._v(" "), (_vm.$store.state.message) ? _c('div', {
    staticClass: "error-500"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.state.message) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Volver atrás")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("5")]), _vm._v("0"), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("0")])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$store.state.user.id_rol !== 5 ? _vm.$t('entity.title') : 'Entidad'))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [(_vm.$store.state.user.id_rol !== 5) ? _c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['entidades:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'entidad', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:update'] && _vm.$store.state.user.id_rol == 1) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Generar Token de acceso")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'entidad')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['entidades:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.idEntidad != items.item.id) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'entidad', 'EditEntidad')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.permissions['entidades:update'] && _vm.idEntidad != items.item.id) ? _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.idEntidad == items.item.id) ? _c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("business")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Esta es mi entidad.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.sigla))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.web))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.direccion))]), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }], null, false, 56077139)
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['entidades:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.descargarTodo()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v(" Sincronizar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Sincronizar con el Portal Único de Trámites")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['entidades:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')) + "\n            ")], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('entity.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('entity.crud.editEnt') : _vm.$t('entity.crud.addEnt')) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [(_vm.form.estado == 'ACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "success",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.form.estado == 'INACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "warning",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h4', [_vm._v("Datos generales")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('entity.crud.name'),
      "id": "nombre",
      "autofocus": "",
      "maxlength": "150",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "sigla",
      "label": _vm.$t('entity.crud.acronym'),
      "id": "sigla",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.sigla),
      callback: function($$v) {
        _vm.$set(_vm.form, "sigla", $$v)
      },
      expression: "form.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('entity.crud.description'),
      "id": "descripcion",
      "maxlength": "500",
      "counter": 500,
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "codigo_portal",
      "label": "Código único de portal",
      "id": "codigo_portal",
      "maxlength": "20",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.codigo_portal),
      callback: function($$v) {
        _vm.$set(_vm.form, "codigo_portal", $$v)
      },
      expression: "form.codigo_portal"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Datos de contacto")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": _vm.$t('entity.crud.email'),
      "prepend-icon": "email",
      "id": "email",
      "maxlength": "100",
      "rules": _vm.$validate(['email'])
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "web",
      "label": _vm.$t('entity.crud.web'),
      "prepend-icon": "public",
      "id": "web",
      "maxlength": "100",
      "rules": _vm.$validate(['url'])
    },
    model: {
      value: (_vm.form.web),
      callback: function($$v) {
        _vm.$set(_vm.form, "web", $$v)
      },
      expression: "form.web"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "direccion",
      "label": _vm.$t('entity.crud.address'),
      "id": "direccion",
      "maxlength": "500",
      "counter": 500
    },
    model: {
      value: (_vm.form.direccion),
      callback: function($$v) {
        _vm.$set(_vm.form, "direccion", $$v)
      },
      expression: "form.direccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('entity.crud.phones'),
      "chips": "",
      "tags": "",
      "prepend-icon": "phone"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(data.item) + "\n                      ")])]
      }
    }], null, false, 490438845),
    model: {
      value: (_vm.form.telefonos),
      callback: function($$v) {
        _vm.$set(_vm.form, "telefonos", $$v)
      },
      expression: "form.telefonos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2) : _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h4', [_vm._v("Datos generales")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('entity.crud.name'),
      "id": "nombre",
      "autofocus": "",
      "maxlength": "150",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "sigla",
      "label": _vm.$t('entity.crud.acronym'),
      "id": "sigla",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.sigla),
      callback: function($$v) {
        _vm.$set(_vm.form, "sigla", $$v)
      },
      expression: "form.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('entity.crud.description'),
      "id": "descripcion",
      "maxlength": "500",
      "counter": 500,
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "codigo_portal",
      "label": "Código único de portal",
      "id": "codigo_portal",
      "maxlength": "20",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.codigo_portal),
      callback: function($$v) {
        _vm.$set(_vm.form, "codigo_portal", $$v)
      },
      expression: "form.codigo_portal"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("Datos de contacto")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": _vm.$t('entity.crud.email'),
      "prepend-icon": "email",
      "id": "email",
      "maxlength": "100",
      "rules": _vm.$validate(['email'])
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "web",
      "label": _vm.$t('entity.crud.web'),
      "prepend-icon": "public",
      "id": "web",
      "maxlength": "100",
      "rules": _vm.$validate(['url'])
    },
    model: {
      value: (_vm.form.web),
      callback: function($$v) {
        _vm.$set(_vm.form, "web", $$v)
      },
      expression: "form.web"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "direccion",
      "label": _vm.$t('entity.crud.address'),
      "id": "direccion",
      "maxlength": "500",
      "counter": 500
    },
    model: {
      value: (_vm.form.direccion),
      callback: function($$v) {
        _vm.$set(_vm.form, "direccion", $$v)
      },
      expression: "form.direccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('entity.crud.phones'),
      "chips": "",
      "tags": "",
      "prepend-icon": "phone"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(data.item) + "\n                  ")])]
      }
    }]),
    model: {
      value: (_vm.form.telefonos),
      callback: function($$v) {
        _vm.$set(_vm.form, "telefonos", $$v)
      },
      expression: "form.telefonos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Guardar cambios\n          ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("vpn_key")]), _vm._v(" Token de acceso - " + _vm._s(_vm.nombre) + "\n        "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Token de la entidad",
      "textarea": "",
      "readonly": "",
      "rows": "14"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cerrar\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-lang",
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "icon-flag",
    class: {
      'es': _vm.lang.icon == 'es', 'en': _vm.lang.icon == 'en', 'ay': _vm.lang.icon == 'ay'
    }
  }), _vm._v(" " + _vm._s(_vm.lang.text) + "\n  ")]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(item) {
    return _c('v-list-tile', {
      key: item.title
    }, [_c('v-list-tile-title', {
      on: {
        "click": function($event) {
          return _vm.selectLang(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon-flag",
      class: {
        'es': item.icon == 'es', 'en': item.icon == 'en', 'ay': item.icon == 'ay'
      }
    }), _vm._v(" " + _vm._s(item.text) + "\n      ")])], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found__message text-xs-center"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("PÁGINA NO ENCONTRADA")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Volver atrás")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("4")]), _vm._v("0"), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("4")])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "id-refresh": "btn-refresh-rol"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['roles:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'rol', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['roles:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'rol')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.descripcion))])]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['roles:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('rol.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('rol.crud.editRol') : _vm.$t('rol.crud.addRol')) + "\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nombre",
      "label": _vm.$t('rol.crud.name'),
      "id": "nombre",
      "rules": _vm.$validate(['required']),
      "required": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.$set(_vm.form, "nombre", $$v)
      },
      expression: "form.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "descripcion",
      "label": _vm.$t('rol.crud.description'),
      "id": "descripcion",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.form, "descripcion", $$v)
      },
      expression: "form.descripcion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(!_vm.demofi_ejecutandose) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "value": true
    }
  }, [_c('h3', {
    staticClass: "headline warning--text"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Atención.-")], 1), _vm._v(" "), _c('p', [_vm._v("Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador. Haga:")]), _vm._v(" "), _c('p', [_vm._v("1. Visite el siguiente enlace para su instalación y/o configuración. Presione "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://firmadigital.bo/jacobitus4/"
    }
  }, [_vm._v("aquí")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "margin-0"
  }, [_vm._v("2. Puede verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.verCertificado()
      }
    }
  }, [_vm._v("aquí")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (_vm.demofi_ejecutandose && !_vm.autenticado) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n    Ingrese el PIN de su Token para poder firmar el documento.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.certificados.length) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "success",
      "icon": "check",
      "value": true
    }
  }, [_vm._v("\n    Token iniciado correctamente\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.autenticar($event)
      }
    }
  }, [(!_vm.autenticado && !_vm.$store.state.pin) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pin",
      "type": "password",
      "prepend-icon": "verified_user",
      "rules": _vm.$validate(['required']),
      "disabled": !_vm.token_conectado || _vm.autenticado
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.token_conectado || _vm.autenticado
    }
  }, [_vm._v(" Autenticar\n            ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.certificados.length) ? _c('div', [_c('h4', [_c('v-icon', [_vm._v("person")]), _vm._v(" Información del Token")], 1), _vm._v(" "), (_vm.segmento) ? _c('div', {
    staticClass: "demofi-certificado"
  }, [_c('p', [_c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.firmador.nombreComunSubject))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Organización:")]), _vm._v(" " + _vm._s(_vm.firmador.organizacionSubject))]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Token válido desde el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.inicioValidez))]), _vm._v(" hasta el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.finValidez))])])])]) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "p-b-0",
    attrs: {
      "label": "Certificado",
      "rules": _vm.$validate(['required']),
      "prepend-icon": "person",
      "disabled": !_vm.autenticado,
      "item-text": "nombreComunSubject",
      "item-value": "numeroSerie",
      "items": _vm.certificados
    },
    model: {
      value: (_vm.firmadorSeleccionado),
      callback: function($$v) {
        _vm.firmadorSeleccionado = $$v
      },
      expression: "firmadorSeleccionado"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "center": ""
    }
  }, [(_vm.existeCertificados) ? [(_vm.certificados.length) ? _c('v-btn', {
    attrs: {
      "id": "btn-demofi-firm",
      "color": "success",
      "disabled": !_vm.autenticado || _vm.firmando
    },
    on: {
      "click": _vm.firmar
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("security")]), _vm._v("Firmar")], 1) : _vm._e()] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.certificados.length === 0 && _vm.autenticado),
      expression: "certificados.length === 0 && autenticado"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "warning"
    }
  }, [_vm._v("warning")]), _vm._v("No se encontraron certificados válidos en su token\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crud-table"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "btn-container",
    attrs: {
      "xs8": ""
    }
  }, [_vm._t("buttons"), _vm._v(" "), _c('div', {
    staticClass: "btn-filter",
    class: {
      'active': _vm.showFilterActive
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(_vm.filters.length) ? _c('v-btn', {
    staticClass: "btn-refresh",
    attrs: {
      "slot": "activator",
      "id": _vm.idFilter
    },
    nativeOn: {
      "click": function($event) {
        return _vm.filtrar()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("filter_list")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.filters')))])], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-refresh",
    attrs: {
      "slot": "activator",
      "id": _vm.idRefresh
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getData()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.updateList')))])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": _vm.widthModal
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_vm._t("form", [_vm._v("Agregue su formulario aquí")])], 2)], 1)], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_vm._t("labels")], 2), _vm._v(" "), (_vm.filter) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("filters", [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Buscar",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], {
    "search": _vm.search
  })], 2) : _vm._e(), _vm._v(" "), (_vm.filters.length) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilterActive),
      expression: "showFilterActive"
    }],
    staticClass: "filter-container"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("search")]), _vm._v(" "), _vm._l((_vm.filters), function(filter) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (filter.type != 'hidden'),
        expression: "filter.type != 'hidden'"
      }],
      key: filter.field,
      staticClass: "filter-item"
    }, [(filter.type == 'text') ? _c('v-text-field', {
      attrs: {
        "label": filter.label,
        "hide-details": ""
      },
      model: {
        value: (_vm.search[filter.field]),
        callback: function($$v) {
          _vm.$set(_vm.search, filter.field, $$v)
        },
        expression: "search[filter.field]"
      }
    }) : _vm._e(), _vm._v(" "), (filter.type == 'select') ? _c('v-select', {
      attrs: {
        "items": filter.items,
        "label": filter.label,
        "item-text": "text",
        "item-value": "value",
        "hide-details": "",
        "autocomplete": ""
      },
      model: {
        value: (_vm.search[filter.field]),
        callback: function($$v) {
          _vm.$set(_vm.search, filter.field, $$v)
        },
        expression: "search[filter.field]"
      }
    }) : _vm._e(), _vm._v(" "), (filter.type == 'boolean') ? _c('v-switch', {
      attrs: {
        "slot": "activator",
        "value": true,
        "color": "info"
      },
      on: {
        "change": function($event) {
          return _vm.changeVisible(_vm.items.item, _vm.items.item.id, 'modulo', 'EditModulo')
        }
      },
      slot: "activator",
      model: {
        value: (_vm.items.item.visible),
        callback: function($$v) {
          _vm.$set(_vm.items.item, "visible", $$v)
        },
        expression: "items.item.visible"
      }
    }) : _vm._e(), _vm._v(" "), (filter.type == 'hidden') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.search[filter.field]),
        expression: "search[filter.field]"
      }],
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (_vm.search[filter.field])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.search, filter.field, $event.target.value)
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.filtrar()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('span', [_vm._v("Cerrar filtro/búsqueda")])], 1)], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.getHeaders,
      "items": _vm.items,
      "pagination": _vm.pagination,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "select-all": _vm.checkbox,
      "item-key": "id",
      "rowsPerPageText": _vm.$t('common.rowsPage'),
      "noResultsText": "No se encontraron registros que coincidan",
      "noDataText": "No hay resultados",
      "rowsPerPageItems": _vm.rowsPerPageItems
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [(_vm.checkbox) ? _c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._t("items", [_vm._v("\n            Defina la lista de registros aquí\n          ")], {
          "item": props.item
        })], 2)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        " + _vm._s(pageStart) + "-" + _vm._s(pageStop) + " " + _vm._s(_vm.$t('common.of')) + " " + _vm._s(_vm.totalItems) + "\n      ")]
      }
    }], null, true),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 544 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 545 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 546 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 547 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[296]);


// WEBPACK FOOTER //
// static/js/app.333940945fb707fdd75b.js